// Code generated by protoc-gen-synurang-ffi. DO NOT EDIT.
// TypeScript lite protobuf types for volvoxgrid.v1

export const PROTO_PACKAGE = "volvoxgrid.v1" as const;

type ProtoKind =
  | "int32"
  | "int64"
  | "sint32"
  | "sint64"
  | "uint32"
  | "uint64"
  | "fixed32"
  | "fixed64"
  | "sfixed32"
  | "sfixed64"
  | "float"
  | "double"
  | "bool"
  | "string"
  | "bytes"
  | "enum"
  | "message";

type ProtoWireType = 0 | 1 | 2 | 5;
type EnumLike = Record<string, string | number>;
export type ProtoJsonValue = null | boolean | number | string | ProtoJsonValue[] | { [key: string]: ProtoJsonValue };
export type ProtoJsonObject = { [key: string]: ProtoJsonValue };

type ProtoFieldInfo = {
  readonly no: number;
  readonly name: string;
  readonly jsonName: string;
  readonly prop: string;
  readonly kind: ProtoKind;
  readonly repeated?: boolean;
  readonly optional?: boolean;
  readonly oneof?: string;
  readonly oneofCase?: number;
  readonly messageType?: string;
  readonly enumType?: EnumLike;
};

const PRESENT = Symbol("synurang.present");

type LiteMessage = {
  [PRESENT]?: Set<number>;
  toByteArray?: () => Uint8Array;
  toBinary?: () => Uint8Array;
  toJson?: () => ProtoJsonObject;
};

type MessageConstructor<T extends LiteMessage = LiteMessage> = {
  new(init?: any): T;
  readonly typeName: string;
  readonly fields: readonly ProtoFieldInfo[];
  fromBinary(data: Uint8Array): T;
};

const MESSAGE_TYPES: Record<string, MessageConstructor> = {};

function registerMessage(ctor: MessageConstructor): void {
  MESSAGE_TYPES[ctor.typeName] = ctor;
  MESSAGE_TYPES[ctor.name] = ctor;
}

function markPresent(msg: LiteMessage, fieldNo: number): void {
  if (msg[PRESENT] == null) {
    Object.defineProperty(msg, PRESENT, {
      configurable: false,
      enumerable: false,
      value: new Set<number>(),
    });
  }
  msg[PRESENT]!.add(fieldNo);
}

function isPresent(msg: LiteMessage, field: ProtoFieldInfo): boolean {
  if (field.oneof != null) {
    return (msg as any)[field.oneof] === field.oneofCase;
  }
  return msg[PRESENT]?.has(field.no) ?? false;
}

function initMessage(msg: LiteMessage, fields: readonly ProtoFieldInfo[], init?: Record<string, unknown>): void {
  if (init == null) {
    return;
  }
  for (const field of fields) {
    if (!Object.prototype.hasOwnProperty.call(init, field.prop)) {
      continue;
    }
    (msg as any)[field.prop] = init[field.prop];
    markPresent(msg, field.no);
    if (field.oneof != null && field.oneofCase != null) {
      (msg as any)[field.oneof] = field.oneofCase;
    }
  }
}

class ProtoReader {
  private offset = 0;

  constructor(private readonly data: Uint8Array) {}

  get eof(): boolean {
    return this.offset >= this.data.length;
  }

  readTag(): { fieldNo: number; wireType: ProtoWireType } | null {
    if (this.eof) {
      return null;
    }
    const tag = this.readVarint();
    return {
      fieldNo: Number(tag >> 3n),
      wireType: Number(tag & 0x07n) as ProtoWireType,
    };
  }

  readVarint(): bigint {
    let value = 0n;
    let shift = 0n;
    while (this.offset < this.data.length) {
      const byte = BigInt(this.data[this.offset++]);
      value |= (byte & 0x7fn) << shift;
      if ((byte & 0x80n) === 0n) {
        break;
      }
      shift += 7n;
    }
    return value;
  }

  readInt32(): number {
    return Number(BigInt.asIntN(32, this.readVarint()));
  }

  readInt64(): bigint {
    return BigInt.asIntN(64, this.readVarint());
  }

  readSint32(): number {
    const value = this.readVarint();
    return Number(BigInt.asIntN(32, (value >> 1n) ^ -(value & 1n)));
  }

  readSint64(): bigint {
    const value = this.readVarint();
    return BigInt.asIntN(64, (value >> 1n) ^ -(value & 1n));
  }

  readUint32(): number {
    return Number(this.readVarint() & 0xffffffffn);
  }

  readUint64(): bigint {
    return this.readVarint();
  }

  readFixed32(): number {
    this.ensureAvailable(4);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 4).getUint32(0, true);
    this.offset += 4;
    return value;
  }

  readFixed64(): bigint {
    this.ensureAvailable(8);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 8).getBigUint64(0, true);
    this.offset += 8;
    return value;
  }

  readSfixed32(): number {
    this.ensureAvailable(4);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 4).getInt32(0, true);
    this.offset += 4;
    return value;
  }

  readSfixed64(): bigint {
    this.ensureAvailable(8);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 8).getBigInt64(0, true);
    this.offset += 8;
    return value;
  }

  readBool(): boolean {
    return this.readVarint() !== 0n;
  }

  readFloat(): number {
    this.ensureAvailable(4);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 4).getFloat32(0, true);
    this.offset += 4;
    return value;
  }

  readDouble(): number {
    this.ensureAvailable(8);
    const value = new DataView(this.data.buffer, this.data.byteOffset + this.offset, 8).getFloat64(0, true);
    this.offset += 8;
    return value;
  }

  readLengthDelimited(): Uint8Array {
    const size = Number(this.readVarint());
    this.ensureAvailable(size);
    const out = this.data.slice(this.offset, this.offset + size);
    this.offset += size;
    return out;
  }

  readString(): string {
    return new TextDecoder().decode(this.readLengthDelimited());
  }

  skipField(wireType: ProtoWireType): void {
    switch (wireType) {
      case 0:
        this.readVarint();
        return;
      case 1:
        this.ensureAvailable(8);
        this.offset += 8;
        return;
      case 2: {
        const size = Number(this.readVarint());
        this.ensureAvailable(size);
        this.offset += size;
        return;
      }
      case 5:
        this.ensureAvailable(4);
        this.offset += 4;
        return;
      default:
        this.offset = this.data.length;
    }
  }

  private ensureAvailable(size: number): void {
    if (size < 0 || this.offset + size > this.data.length) {
      throw new RangeError("Malformed protobuf payload");
    }
  }
}

class ProtoWriter {
  private readonly bytes: number[] = [];

  toUint8Array(): Uint8Array {
    return new Uint8Array(this.bytes);
  }

  writeTag(fieldNo: number, wireType: ProtoWireType): void {
    this.writeVarintRaw((BigInt(fieldNo) << 3n) | BigInt(wireType));
  }

  writeKindBody(kind: ProtoKind, value: unknown): void {
    switch (kind) {
      case "int32":
      case "enum":
        this.writeVarintRaw(BigInt.asUintN(64, BigInt(Number(value))));
        return;
      case "int64":
        this.writeVarintRaw(BigInt.asUintN(64, BigInt(value as bigint | number)));
        return;
      case "sint32": {
        const n = BigInt.asIntN(32, BigInt(Number(value)));
        this.writeVarintRaw(BigInt.asUintN(32, (n << 1n) ^ (n >> 31n)));
        return;
      }
      case "sint64": {
        const n = BigInt.asIntN(64, BigInt(value as bigint | number));
        this.writeVarintRaw(BigInt.asUintN(64, (n << 1n) ^ (n >> 63n)));
        return;
      }
      case "uint32":
        this.writeVarintRaw(BigInt(Number(value) >>> 0));
        return;
      case "uint64":
        this.writeVarintRaw(BigInt(value as bigint | number));
        return;
      case "fixed32": {
        const data = new Uint8Array(4);
        new DataView(data.buffer).setUint32(0, Number(value) >>> 0, true);
        this.writeRaw(data);
        return;
      }
      case "fixed64": {
        const data = new Uint8Array(8);
        new DataView(data.buffer).setBigUint64(0, BigInt.asUintN(64, BigInt(value as bigint | number)), true);
        this.writeRaw(data);
        return;
      }
      case "sfixed32": {
        const data = new Uint8Array(4);
        new DataView(data.buffer).setInt32(0, Number(value), true);
        this.writeRaw(data);
        return;
      }
      case "sfixed64": {
        const data = new Uint8Array(8);
        new DataView(data.buffer).setBigInt64(0, BigInt.asIntN(64, BigInt(value as bigint | number)), true);
        this.writeRaw(data);
        return;
      }
      case "float": {
        const data = new Uint8Array(4);
        new DataView(data.buffer).setFloat32(0, Number(value), true);
        this.writeRaw(data);
        return;
      }
      case "double": {
        const data = new Uint8Array(8);
        new DataView(data.buffer).setFloat64(0, Number(value), true);
        this.writeRaw(data);
        return;
      }
      case "bool":
        this.writeVarintRaw(value ? 1n : 0n);
        return;
      default:
        throw new Error("Unsupported packed protobuf kind: " + kind);
    }
  }

  writeScalar(fieldNo: number, kind: ProtoKind, value: unknown): void {
    this.writeTag(fieldNo, wireTypeForKind(kind));
    this.writeKindBody(kind, value);
  }

  writeString(fieldNo: number, value: string): void {
    this.writeBytes(fieldNo, new TextEncoder().encode(value));
  }

  writeBytes(fieldNo: number, value: Uint8Array): void {
    this.writeTag(fieldNo, 2);
    this.writeVarintRaw(BigInt(value.byteLength));
    this.writeRaw(value);
  }

  private writeRaw(data: Uint8Array): void {
    for (const byte of data) {
      this.bytes.push(byte);
    }
  }

  private writeVarintRaw(value: bigint): void {
    let v = value;
    while (v >= 0x80n) {
      this.bytes.push(Number((v & 0x7fn) | 0x80n));
      v >>= 7n;
    }
    this.bytes.push(Number(v));
  }
}

function wireTypeForKind(kind: ProtoKind): ProtoWireType {
  switch (kind) {
    case "int32":
    case "int64":
    case "sint32":
    case "sint64":
    case "uint32":
    case "uint64":
    case "bool":
    case "enum":
      return 0;
    case "fixed64":
    case "sfixed64":
    case "double":
      return 1;
    case "fixed32":
    case "sfixed32":
    case "float":
      return 5;
    case "string":
    case "bytes":
    case "message":
      return 2;
  }
}

function isPackable(kind: ProtoKind): boolean {
  return kind !== "string" && kind !== "bytes" && kind !== "message";
}

function readPackedValue(reader: ProtoReader, field: ProtoFieldInfo): unknown {
  switch (field.kind) {
    case "int32":
    case "enum":
      return reader.readInt32();
    case "int64":
      return reader.readInt64();
    case "sint32":
      return reader.readSint32();
    case "sint64":
      return reader.readSint64();
    case "uint32":
      return reader.readUint32();
    case "uint64":
      return reader.readUint64();
    case "fixed32":
      return reader.readFixed32();
    case "fixed64":
      return reader.readFixed64();
    case "sfixed32":
      return reader.readSfixed32();
    case "sfixed64":
      return reader.readSfixed64();
    case "float":
      return reader.readFloat();
    case "double":
      return reader.readDouble();
    case "bool":
      return reader.readBool();
    default:
      throw new Error("Unsupported packed protobuf kind: " + field.kind);
  }
}

function readFieldValue(reader: ProtoReader, field: ProtoFieldInfo): unknown {
  switch (field.kind) {
    case "int32":
    case "enum":
      return reader.readInt32();
    case "int64":
      return reader.readInt64();
    case "sint32":
      return reader.readSint32();
    case "sint64":
      return reader.readSint64();
    case "uint32":
      return reader.readUint32();
    case "uint64":
      return reader.readUint64();
    case "fixed32":
      return reader.readFixed32();
    case "fixed64":
      return reader.readFixed64();
    case "sfixed32":
      return reader.readSfixed32();
    case "sfixed64":
      return reader.readSfixed64();
    case "float":
      return reader.readFloat();
    case "double":
      return reader.readDouble();
    case "bool":
      return reader.readBool();
    case "string":
      return reader.readString();
    case "bytes":
      return reader.readLengthDelimited();
    case "message": {
      const bytes = reader.readLengthDelimited();
      const ctor = field.messageType == null ? undefined : MESSAGE_TYPES[field.messageType];
      return ctor == null ? bytes : ctor.fromBinary(bytes);
    }
  }
}

function decodeMessage<T extends LiteMessage>(ctor: MessageConstructor<T>, data: Uint8Array): T {
  const reader = new ProtoReader(data);
  const msg = new ctor();
  while (!reader.eof) {
    const tag = reader.readTag();
    if (tag == null) {
      break;
    }
    const field = ctor.fields.find((candidate) => candidate.no === tag.fieldNo);
    if (field == null) {
      reader.skipField(tag.wireType);
      continue;
    }
    if (field.repeated) {
      const values = ((msg as any)[field.prop] ??= []);
      if (tag.wireType === 2 && isPackable(field.kind)) {
        const packed = new ProtoReader(reader.readLengthDelimited());
        while (!packed.eof) {
          values.push(readPackedValue(packed, field));
        }
      } else {
        values.push(readFieldValue(reader, field));
      }
      markPresent(msg, field.no);
      continue;
    }
    (msg as any)[field.prop] = readFieldValue(reader, field);
    markPresent(msg, field.no);
    if (field.oneof != null && field.oneofCase != null) {
      (msg as any)[field.oneof] = field.oneofCase;
    }
  }
  return msg;
}

function encodeMessage(msg: LiteMessage, fields: readonly ProtoFieldInfo[]): Uint8Array {
  const writer = new ProtoWriter();
  for (const field of fields) {
    if (field.oneof != null && (msg as any)[field.oneof] !== field.oneofCase) {
      continue;
    }
    const value = (msg as any)[field.prop];
    if (field.repeated) {
      if (!Array.isArray(value) || value.length === 0) {
        continue;
      }
      if (isPackable(field.kind)) {
        const packed = new ProtoWriter();
        for (const item of value) {
          packed.writeKindBody(field.kind, item);
        }
        writer.writeBytes(field.no, packed.toUint8Array());
      } else {
        for (const item of value) {
          writeFieldValue(writer, field, item);
        }
      }
      continue;
    }
    if (value == null) {
      continue;
    }
    if (!isPresent(msg, field) && isDefaultValue(field, value)) {
      continue;
    }
    writeFieldValue(writer, field, value);
  }
  return writer.toUint8Array();
}

function writeFieldValue(writer: ProtoWriter, field: ProtoFieldInfo, value: unknown): void {
  switch (field.kind) {
    case "string":
      writer.writeString(field.no, String(value));
      return;
    case "bytes":
      writer.writeBytes(field.no, value as Uint8Array);
      return;
    case "message":
      writer.writeBytes(field.no, encodeMessageValue(field, value));
      return;
    default:
      writer.writeScalar(field.no, field.kind, value);
      return;
  }
}

function encodeMessageValue(field: ProtoFieldInfo, value: unknown): Uint8Array {
  if (value instanceof Uint8Array) {
    return value;
  }
  const lite = value as LiteMessage;
  if (typeof lite.toBinary === "function") {
    return lite.toBinary();
  }
  if (typeof lite.toByteArray === "function") {
    return lite.toByteArray();
  }
  if (field.messageType != null && value != null && typeof value === "object") {
    const ctor = MESSAGE_TYPES[field.messageType];
    if (ctor != null) {
      return new ctor(value as Record<string, unknown>).toBinary!();
    }
  }
  throw new Error("Cannot encode message field '" + field.name + "': value is not a registered message type");
}

function isDefaultValue(field: ProtoFieldInfo, value: unknown): boolean {
  switch (field.kind) {
    case "int32":
    case "sint32":
    case "uint32":
    case "fixed32":
    case "sfixed32":
    case "float":
    case "double":
    case "enum":
      return Number(value) === 0;
    case "int64":
    case "sint64":
    case "uint64":
    case "fixed64":
    case "sfixed64":
      return BigInt(value as bigint | number) === 0n;
    case "bool":
      return value === false;
    case "string":
      return value === "";
    case "bytes":
      return value instanceof Uint8Array && value.byteLength === 0;
    case "message":
      return value == null;
  }
}

function messageToJson(msg: LiteMessage, fields: readonly ProtoFieldInfo[]): ProtoJsonObject {
  const out: ProtoJsonObject = {};
  for (const field of fields) {
    if (field.oneof != null && (msg as any)[field.oneof] !== field.oneofCase) {
      continue;
    }
    const value = (msg as any)[field.prop];
    if (field.repeated) {
      if (Array.isArray(value) && value.length > 0) {
        out[field.jsonName] = value.map((item) => valueToJson(field, item));
      }
      continue;
    }
    if (value == null) {
      continue;
    }
    if (!isPresent(msg, field) && isDefaultValue(field, value)) {
      continue;
    }
    out[field.jsonName] = valueToJson(field, value);
  }
  return out;
}

function valueToJson(field: ProtoFieldInfo, value: unknown): ProtoJsonValue {
  switch (field.kind) {
    case "int64":
    case "sint64":
    case "uint64":
    case "fixed64":
    case "sfixed64":
      return BigInt(value as bigint | number).toString();
    case "bytes":
      return value instanceof Uint8Array ? bytesToBase64(value) : "";
    case "enum": {
      const enumName = field.enumType?.[Number(value)];
      return typeof enumName === "string" ? enumName : Number(value);
    }
    case "message":
      if (value instanceof Uint8Array) {
        return bytesToBase64(value);
      }
      if (typeof (value as LiteMessage).toJson === "function") {
        return (value as Required<Pick<LiteMessage, "toJson">>).toJson();
      }
      return {};
    default:
      return value as ProtoJsonValue;
  }
}

function bytesToBase64(bytes: Uint8Array): string {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  let out = "";
  let i = 0;
  for (; i + 2 < bytes.length; i += 3) {
    const n = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
    out += alphabet[(n >> 18) & 63] + alphabet[(n >> 12) & 63] + alphabet[(n >> 6) & 63] + alphabet[n & 63];
  }
  if (i < bytes.length) {
    const a = bytes[i];
    const b = i + 1 < bytes.length ? bytes[i + 1] : 0;
    const n = (a << 16) | (b << 8);
    out += alphabet[(n >> 18) & 63] + alphabet[(n >> 12) & 63] + (i + 1 < bytes.length ? alphabet[(n >> 6) & 63] : "=") + "=";
  }
  return out;
}
export enum AggregateType {
  AGG_NONE = 0,
  AGG_CLEAR = 1,
  AGG_SUM = 2,
  AGG_PERCENT = 3,
  AGG_COUNT = 4,
  AGG_AVERAGE = 5,
  AGG_MAX = 6,
  AGG_MIN = 7,
  AGG_STD_DEV = 8,
  AGG_VAR = 9,
  AGG_RANGE = 10,
  AGG_COUNT_ALL = 11,
  AGG_MEDIAN = 12,
  AGG_COUNT_DISTINCT = 13,
}
export enum Align {
  ALIGN_LEFT_TOP = 0,
  ALIGN_LEFT_CENTER = 1,
  ALIGN_LEFT_BOTTOM = 2,
  ALIGN_CENTER_TOP = 3,
  ALIGN_CENTER_CENTER = 4,
  ALIGN_CENTER_BOTTOM = 5,
  ALIGN_RIGHT_TOP = 6,
  ALIGN_RIGHT_CENTER = 7,
  ALIGN_RIGHT_BOTTOM = 8,
  ALIGN_GENERAL = 9,
}
export enum ApplyScope {
  APPLY_SINGLE = 0,
  APPLY_SELECTION = 1,
}
export enum ArchiveRequest_Action {
  ACTION_UNSPECIFIED = 0,
  SAVE = 1,
  LOAD = 2,
  DELETE = 3,
  LIST = 4,
}
export enum AutoSizeMode {
  AUTOSIZE_BOTH = 0,
  AUTOSIZE_COL_WIDTH = 1,
  AUTOSIZE_ROW_HEIGHT = 2,
}
export enum BarcodeCaptionPosition {
  CAPTION_NONE = 0,
  CAPTION_BOTTOM = 1,
  CAPTION_TOP = 2,
}
export enum BarcodeCheckDigitMode {
  CHECK_DIGIT_DEFAULT = 0,
  CHECK_DIGIT_NONE = 1,
  CHECK_DIGIT_GENERATE = 2,
}
export enum BarcodeQrErrorCorrection {
  QR_ECC_DEFAULT = 0,
  QR_ECC_LOW = 1,
  QR_ECC_MEDIUM = 2,
  QR_ECC_QUARTILE = 3,
  QR_ECC_HIGH = 4,
}
export enum BarcodeRenderStatus {
  BARCODE_RENDER_STATUS_UNSPECIFIED = 0,
  BARCODE_RENDER_STATUS_OK = 1,
  BARCODE_RENDER_STATUS_EMPTY_PAYLOAD = 2,
  BARCODE_RENDER_STATUS_INVALID_PAYLOAD = 3,
  BARCODE_RENDER_STATUS_UNSUPPORTED_SYMBOLOGY = 4,
}
export enum BarcodeSymbology {
  BARCODE_NONE = 0,
  BARCODE_QR = 1,
  BARCODE_CODE128 = 10,
  BARCODE_CODE39 = 11,
  BARCODE_CODE93 = 12,
  BARCODE_CODE11 = 13,
  BARCODE_EAN13 = 20,
  BARCODE_EAN8 = 21,
  BARCODE_UPC_A = 22,
  BARCODE_UPC_E = 23,
  BARCODE_EAN_SUPP = 24,
  BARCODE_ITF = 30,
  BARCODE_STF = 31,
  BARCODE_CODABAR = 32,
}
export enum BarcodeTextEncoding {
  BARCODE_TEXT_AUTO = 0,
  BARCODE_TEXT_ASCII = 1,
  BARCODE_TEXT_UTF8 = 2,
  BARCODE_TEXT_GS1 = 3,
}
export enum BorderAppearance {
  BORDER_APPEARANCE_FLAT = 0,
  BORDER_APPEARANCE_RAISED = 1,
  BORDER_APPEARANCE_SUBTLE = 2,
}
export enum BorderStyle {
  BORDER_NONE = 0,
  BORDER_THIN = 1,
  BORDER_THICK = 2,
  BORDER_DOTTED = 3,
  BORDER_DASHED = 4,
  BORDER_DOUBLE = 5,
}
export enum ButtonRole {
  BUTTON_ROLE_DEFAULT = 0,
  BUTTON_ROLE_ELLIPSIS = 1,
  BUTTON_ROLE_CLEAR = 2,
  BUTTON_ROLE_CUSTOM = 3,
}
export enum CellHitArea {
  HIT_CELL = 0,
  HIT_TEXT = 1,
  HIT_PICTURE = 2,
  HIT_BUTTON = 3,
  HIT_CHECKBOX = 4,
  HIT_DROPDOWN = 5,
}
export enum CellInteraction {
  CELL_INTERACTION_UNSPECIFIED = 0,
  CELL_INTERACTION_NONE = 1,
  CELL_INTERACTION_TEXT_LINK = 2,
  CELL_INTERACTION_BUTTON = 3,
}
export enum CellSpanMode {
  CELL_SPAN_NONE = 0,
  CELL_SPAN_FREE = 1,
  CELL_SPAN_BY_ROW = 2,
  CELL_SPAN_BY_COLUMN = 3,
  CELL_SPAN_ADJACENT = 4,
  CELL_SPAN_HEADER_ONLY = 5,
  CELL_SPAN_SPILL = 6,
  CELL_SPAN_GROUP = 7,
}
export enum CheckedState {
  CHECKED_UNCHECKED = 0,
  CHECKED_CHECKED = 1,
  CHECKED_GRAYED = 2,
}
export enum ClearRegion {
  CLEAR_SCROLLABLE = 0,
  CLEAR_FIXED_ROWS = 1,
  CLEAR_FIXED_COLS = 2,
  CLEAR_FIXED_BOTH = 3,
  CLEAR_ALL_ROWS = 4,
  CLEAR_ALL_COLS = 5,
  CLEAR_ALL_BOTH = 6,
}
export enum ClearScope {
  CLEAR_SCOPE_UNSPECIFIED = 0,
  CLEAR_EVERYTHING = 1,
  CLEAR_FORMATTING = 2,
  CLEAR_DATA = 3,
  CLEAR_SELECTION = 4,
}
export enum CoercionMode {
  COERCION_UNSPECIFIED = 0,
  COERCION_STRICT = 1,
  COERCION_FLEXIBLE = 2,
  COERCION_PARSE_ONLY = 3,
}
export enum ColIndicatorCellMode {
  COL_INDICATOR_CELL_NONE = 0,
  COL_INDICATOR_CELL_HEADER_TEXT = 1,
  COL_INDICATOR_CELL_SORT_GLYPH = 2,
  COL_INDICATOR_CELL_SORT_PRIORITY = 4,
  COL_INDICATOR_CELL_FILTER_BUTTON = 8,
  COL_INDICATOR_CELL_FILTER_STATE = 16,
  COL_INDICATOR_CELL_MENU_BUTTON = 32,
  COL_INDICATOR_CELL_CHOOSER = 64,
  COL_INDICATOR_CELL_DRAG_REORDER = 128,
  COL_INDICATOR_CELL_HIDDEN_MARKER = 256,
  COL_INDICATOR_CELL_RESIZE_HANDLE = 512,
  COL_INDICATOR_CELL_SELECT_ALL = 1024,
  COL_INDICATOR_CELL_STATUS_ICON = 2048,
  COL_INDICATOR_CELL_CUSTOM = 4096,
}
export enum ColumnDataType {
  COLUMN_DATA_STRING = 0,
  COLUMN_DATA_NUMBER = 1,
  COLUMN_DATA_DATE = 2,
  COLUMN_DATA_BOOLEAN = 3,
  COLUMN_DATA_CURRENCY = 4,
}
export enum ComposeMethod {
  COMPOSE_METHOD_NONE = 0,
  COMPOSE_METHOD_HANGUL = 1,
  COMPOSE_METHOD_DEAD_KEY = 2,
  COMPOSE_METHOD_TELEX = 3,
}
export enum CornerIndicatorSlotKind {
  CORNER_SLOT_NONE = 0,
  CORNER_SLOT_SELECT_ALL = 1,
  CORNER_SLOT_OUTLINE_LEVELS = 2,
  CORNER_SLOT_CUSTOM = 3,
}
export enum CursorType {
  CURSOR_DEFAULT = 0,
  CURSOR_RESIZE_COL = 1,
  CURSOR_RESIZE_ROW = 2,
  CURSOR_MOVE_COL = 3,
  CURSOR_TEXT = 4,
  CURSOR_HAND = 5,
  CURSOR_MOVE_ROW = 6,
  CURSOR_WAIT = 7,
  CURSOR_NOT_ALLOWED = 8,
  CURSOR_CROSSHAIR = 9,
  CURSOR_COPY = 10,
}
export enum CustomRenderMode {
  CUSTOM_RENDER_NONE = 0,
  CUSTOM_RENDER_CELL = 1,
  CUSTOM_RENDER_ROW = 2,
}
export enum DemoDataFormat {
  DEMO_DATA_FORMAT_UNSPECIFIED = 0,
  DEMO_DATA_FORMAT_JSON = 1,
}
export enum DragMode {
  DRAG_NONE = 0,
  DRAG_MANUAL = 1,
  DRAG_AUTOMATIC = 2,
}
export enum DropMode {
  DROP_NONE = 0,
  DROP_MANUAL = 1,
  DROP_AUTOMATIC = 2,
}
export enum DropdownItemLayout {
  DROPDOWN_ITEM_AUTO = 0,
  DROPDOWN_ITEM_LABEL = 1,
  DROPDOWN_ITEM_VALUE_LABEL = 2,
  DROPDOWN_ITEM_LABEL_DETAILS = 3,
}
export enum EditEndReason {
  EDIT_END_UNSPECIFIED = 0,
  EDIT_END_COMMITTED = 1,
  EDIT_END_CANCELED = 2,
  EDIT_END_REVERTED_INVALID = 3,
  EDIT_END_FOCUS_LOST = 4,
  EDIT_END_CELL_REMOVED = 5,
  EDIT_END_GRID_DESTROYED = 6,
}
export enum EditStartReason {
  EDIT_START_UNSPECIFIED = 0,
  EDIT_START_F2 = 1,
  EDIT_START_DOUBLE_CLICK = 2,
  EDIT_START_CLICK_CARET = 3,
  EDIT_START_ENTER_KEY = 4,
  EDIT_START_PRINTABLE_KEY = 5,
  EDIT_START_IME_COMPOSITION = 6,
  EDIT_START_DROPDOWN_BUTTON = 7,
  EDIT_START_PROGRAMMATIC = 8,
}
export enum EditTrigger {
  EDIT_TRIGGER_NONE = 0,
  EDIT_TRIGGER_KEY = 1,
  EDIT_TRIGGER_KEY_CLICK = 2,
}
export enum EditUiMode {
  EDIT_UI_MODE_ENTER = 0,
  EDIT_UI_MODE_EDIT = 1,
}
export enum EditorKind {
  EDITOR_KIND_UNSPECIFIED = 0,
  EDITOR_TEXT = 1,
  EDITOR_MULTILINE_TEXT = 2,
  EDITOR_NUMBER = 3,
  EDITOR_CHECKBOX = 4,
  EDITOR_SELECT = 5,
  EDITOR_COMBO = 6,
  EDITOR_DATE_TIME = 7,
  EDITOR_BUTTON = 8,
  EDITOR_CUSTOM = 100,
}
export enum EditorOwner {
  EDITOR_OWNER_ENGINE = 0,
  EDITOR_OWNER_HOST_NATIVE = 1,
  EDITOR_OWNER_CUSTOM = 2,
}
export enum EditorPresentation {
  EDITOR_CANVAS = 0,
  EDITOR_POPUP_OVER = 1,
  EDITOR_POPUP_UNDER = 2,
  EDITOR_MODAL = 3,
  EDITOR_INLINE = 4,
}
export enum EditorUpdateReason {
  EDITOR_UPDATE_UNSPECIFIED = 0,
  EDITOR_UPDATE_GEOMETRY = 1,
  EDITOR_UPDATE_VALIDATION = 2,
  EDITOR_UPDATE_NORMALIZED_VALUE = 3,
  EDITOR_UPDATE_PROGRAMMATIC_VALUE = 4,
  EDITOR_UPDATE_REMOTE_VALUE = 5,
  EDITOR_UPDATE_CUSTOM_PAYLOAD = 6,
}
export enum ErrorCode {
  ERROR_UNKNOWN = 0,
  ERROR_INVALID_ARGUMENT = 1,
  ERROR_NOT_FOUND = 2,
  ERROR_INVALID_STATE = 3,
  ERROR_TYPE_VIOLATION = 4,
  ERROR_DECODE_FAILED = 5,
  ERROR_ENCODE_FAILED = 6,
  ERROR_NOT_IMPLEMENTED = 7,
  ERROR_INTERNAL = 8,
}
export enum ExportFormat {
  EXPORT_FORMAT_UNSPECIFIED = 0,
  EXPORT_BINARY = 1,
  EXPORT_TSV = 2,
  EXPORT_CSV = 3,
  EXPORT_DELIMITED = 4,
  EXPORT_XLSX = 5,
}
export enum ExportScope {
  EXPORT_SCOPE_UNSPECIFIED = 0,
  EXPORT_ALL = 1,
  EXPORT_DATA_ONLY = 2,
  EXPORT_FORMAT_ONLY = 3,
}
export enum FillHandlePosition {
  FILL_HANDLE_NONE = 0,
  FILL_HANDLE_BOTTOM_RIGHT = 1,
  FILL_HANDLE_BOTTOM_LEFT = 2,
  FILL_HANDLE_TOP_RIGHT = 3,
  FILL_HANDLE_TOP_LEFT = 4,
  FILL_HANDLE_ALL_CORNERS = 5,
}
export enum FocusBorderStyle {
  FOCUS_BORDER_NONE = 0,
  FOCUS_BORDER_THIN = 1,
  FOCUS_BORDER_THICK = 2,
  FOCUS_BORDER_INSET = 3,
  FOCUS_BORDER_RAISED = 4,
}
export enum FrameKind {
  FRAME_KIND_FRAME = 0,
  FRAME_KIND_SESSION_START = 1,
  FRAME_KIND_SESSION_END = 2,
}
export enum FramePacingMode {
  FRAME_PACING_MODE_AUTO = 0,
  FRAME_PACING_MODE_PLATFORM = 1,
  FRAME_PACING_MODE_UNLIMITED = 2,
  FRAME_PACING_MODE_FIXED = 3,
}
export enum GridEventTargetFlag {
  GRID_TARGET_FLAG_NONE = 0,
  GRID_TARGET_FLAG_CHECKED = 1,
  GRID_TARGET_FLAG_INDETERMINATE = 2,
  GRID_TARGET_FLAG_EXPANDED = 4,
  GRID_TARGET_FLAG_COLLAPSED = 8,
  GRID_TARGET_FLAG_SORT_ASC = 16,
  GRID_TARGET_FLAG_SORT_DESC = 32,
  GRID_TARGET_FLAG_FILTER_ACTIVE = 64,
  GRID_TARGET_FLAG_SELECTED = 128,
  GRID_TARGET_FLAG_DISABLED = 256,
  GRID_TARGET_FLAG_EDITING = 512,
  GRID_TARGET_FLAG_SUBTOTAL = 1024,
  GRID_TARGET_FLAG_PINNED = 2048,
}
export enum GridLineDirection {
  GRIDLINE_BOTH = 0,
  GRIDLINE_HORIZONTAL = 1,
  GRIDLINE_VERTICAL = 2,
}
export enum GridLineStyle {
  GRIDLINE_NONE = 0,
  GRIDLINE_SOLID = 1,
  GRIDLINE_INSET = 2,
  GRIDLINE_RAISED = 3,
}
export enum GridTargetKind {
  GRID_TARGET_UNSPECIFIED = 0,
  GRID_TARGET_DATA_CELL = 1,
  GRID_TARGET_ROW_INDICATOR = 2,
  GRID_TARGET_COL_INDICATOR = 3,
  GRID_TARGET_CORNER_INDICATOR = 4,
  GRID_TARGET_BACKGROUND = 5,
}
export enum GroupTotalPosition {
  GROUP_TOTAL_ABOVE = 0,
  GROUP_TOTAL_BELOW = 1,
}
export enum HeaderPolicy {
  HEADER_AUTO = 0,
  HEADER_NONE = 1,
  HEADER_FIRST_ROW = 2,
}
export enum IconAlign {
  ICON_ALIGN_INLINE_END = 0,
  ICON_ALIGN_INLINE_START = 1,
  ICON_ALIGN_START = 2,
  ICON_ALIGN_END = 3,
  ICON_ALIGN_CENTER = 4,
}
export enum ImageAlignment {
  IMG_ALIGN_LEFT_TOP = 0,
  IMG_ALIGN_LEFT_CENTER = 1,
  IMG_ALIGN_LEFT_BOTTOM = 2,
  IMG_ALIGN_CENTER_TOP = 3,
  IMG_ALIGN_CENTER_CENTER = 4,
  IMG_ALIGN_CENTER_BOTTOM = 5,
  IMG_ALIGN_RIGHT_TOP = 6,
  IMG_ALIGN_RIGHT_CENTER = 7,
  IMG_ALIGN_RIGHT_BOTTOM = 8,
  IMG_ALIGN_STRETCH = 9,
  IMG_ALIGN_TILE = 10,
}
export enum IndicatorAppearance {
  INDICATOR_APPEARANCE_CLASSIC = 0,
  INDICATOR_APPEARANCE_FLAT = 1,
  INDICATOR_APPEARANCE_MODERN = 2,
}
export enum IndicatorBand {
  INDICATOR_BAND_UNSPECIFIED = 0,
  INDICATOR_BAND_ROW_START = 1,
  INDICATOR_BAND_ROW_END = 2,
  INDICATOR_BAND_COL_TOP = 3,
  INDICATOR_BAND_COL_BOTTOM = 4,
  INDICATOR_BAND_CORNER_TOP_START = 5,
  INDICATOR_BAND_CORNER_TOP_END = 6,
  INDICATOR_BAND_CORNER_BOTTOM_START = 7,
  INDICATOR_BAND_CORNER_BOTTOM_END = 8,
}
export enum InputType {
  INPUT_TYPE_TEXT = 0,
  INPUT_TYPE_NUMBER = 1,
  INPUT_TYPE_EMAIL = 2,
  INPUT_TYPE_URL = 3,
  INPUT_TYPE_PHONE = 4,
  INPUT_TYPE_PASSWORD = 5,
}
export enum KeyEvent_Type {
  KEY_TYPE_UNSPECIFIED = 0,
  KEY_DOWN = 1,
  KEY_UP = 2,
  KEY_PRESS = 3,
}
export enum LoadDataStatus {
  LOAD_OK = 0,
  LOAD_PARTIAL = 1,
  LOAD_FAILED = 2,
}
export enum NodeRelation {
  NODE_PARENT = 0,
  NODE_FIRST_CHILD = 1,
  NODE_LAST_CHILD = 2,
  NODE_NEXT_SIBLING = 3,
  NODE_PREV_SIBLING = 4,
}
export enum PinPosition {
  PIN_NONE = 0,
  PIN_TOP = 1,
  PIN_BOTTOM = 2,
}
export enum PointerEvent_Type {
  TYPE_UNSPECIFIED = 0,
  DOWN = 1,
  UP = 2,
  MOVE = 3,
}
export enum PresentMode {
  PRESENT_AUTO = 0,
  PRESENT_FIFO = 1,
  PRESENT_MAILBOX = 2,
  PRESENT_IMMEDIATE = 3,
}
export enum PrintOrientation {
  PRINT_PORTRAIT = 0,
  PRINT_LANDSCAPE = 1,
}
export enum PullToRefreshTheme {
  PULL_TO_REFRESH_THEME_UNSPECIFIED = 0,
  PULL_TO_REFRESH_THEME_TOP_BAND = 1,
  PULL_TO_REFRESH_THEME_MATERIAL = 2,
}
export enum RenderLayerBit {
  RENDER_LAYER_OVERLAY_BANDS = 0,
  RENDER_LAYER_INDICATORS = 1,
  RENDER_LAYER_BACKGROUNDS = 2,
  RENDER_LAYER_PROGRESS_BARS = 3,
  RENDER_LAYER_GRID_LINES = 4,
  RENDER_LAYER_HEADER_MARKS = 5,
  RENDER_LAYER_BACKGROUND_IMAGE = 6,
  RENDER_LAYER_CELL_BORDERS = 7,
  RENDER_LAYER_CELL_TEXT = 8,
  RENDER_LAYER_CELL_PICTURES = 9,
  RENDER_LAYER_SORT_GLYPHS = 10,
  RENDER_LAYER_COL_DRAG_MARKER = 11,
  RENDER_LAYER_CHECKBOXES = 12,
  RENDER_LAYER_DROPDOWN_BUTTONS = 13,
  RENDER_LAYER_SELECTION = 14,
  RENDER_LAYER_HOVER_HIGHLIGHT = 15,
  RENDER_LAYER_EDIT_HIGHLIGHTS = 16,
  RENDER_LAYER_FOCUS_RECT = 17,
  RENDER_LAYER_FILL_HANDLE = 18,
  RENDER_LAYER_OUTLINE = 19,
  RENDER_LAYER_FROZEN_BORDERS = 20,
  RENDER_LAYER_ACTIVE_EDITOR = 21,
  RENDER_LAYER_ACTIVE_DROPDOWN = 22,
  RENDER_LAYER_SCROLL_BARS = 23,
  RENDER_LAYER_FAST_SCROLL = 24,
  RENDER_LAYER_PULL_TO_REFRESH = 25,
  RENDER_LAYER_DEBUG_OVERLAY = 26,
  RENDER_LAYER_BARCODES = 27,
}
export enum RendererMode {
  RENDERER_AUTO = 0,
  RENDERER_CPU = 1,
  RENDERER_GPU = 2,
  RENDERER_GPU_VULKAN = 3,
  RENDERER_GPU_GLES = 4,
  RENDERER_TUI = 5,
  RENDERER_GPU_DX12 = 6,
  RENDERER_GPU_METAL = 7,
  RENDERER_GPU_OPENGL = 8,
}
export enum RowIndicatorSlotKind {
  ROW_INDICATOR_SLOT_NONE = 0,
  ROW_INDICATOR_SLOT_NUMBERS = 1,
  ROW_INDICATOR_SLOT_CURRENT = 2,
  ROW_INDICATOR_SLOT_SELECTION = 3,
  ROW_INDICATOR_SLOT_CHECKBOX = 4,
  ROW_INDICATOR_SLOT_HANDLE = 5,
  ROW_INDICATOR_SLOT_EDITING = 6,
  ROW_INDICATOR_SLOT_MODIFIED = 7,
  ROW_INDICATOR_SLOT_ERROR = 8,
  ROW_INDICATOR_SLOT_NEW_ROW = 9,
  ROW_INDICATOR_SLOT_EXPANDER = 10,
  ROW_INDICATOR_SLOT_RESIZE = 11,
  ROW_INDICATOR_SLOT_ACTION = 12,
  ROW_INDICATOR_SLOT_STATUS_ICON = 13,
  ROW_INDICATOR_SLOT_CUSTOM = 14,
  ROW_INDICATOR_SLOT_NUMBERS_DATA_ONLY = 15,
}
export enum ScrollBarAppearance {
  SCROLLBAR_APPEARANCE_CLASSIC = 0,
  SCROLLBAR_APPEARANCE_FLAT = 1,
  SCROLLBAR_APPEARANCE_MODERN = 2,
  SCROLLBAR_APPEARANCE_OVERLAY = 3,
}
export enum ScrollBarMode {
  SCROLLBAR_MODE_AUTO = 0,
  SCROLLBAR_MODE_ALWAYS = 1,
  SCROLLBAR_MODE_NEVER = 2,
}
export enum ScrollBarsMode {
  SCROLLBAR_NONE = 0,
  SCROLLBAR_HORIZONTAL = 1,
  SCROLLBAR_VERTICAL = 2,
  SCROLLBAR_BOTH = 3,
}
export enum SelectionMode {
  SELECTION_FREE = 0,
  SELECTION_BY_ROW = 1,
  SELECTION_BY_COLUMN = 2,
  SELECTION_LISTBOX = 3,
  SELECTION_MULTI_RANGE = 4,
}
export enum SelectionVisibility {
  SELECTION_VIS_NONE = 0,
  SELECTION_VIS_ALWAYS = 1,
  SELECTION_VIS_WHEN_FOCUSED = 2,
}
export enum SortOrder {
  SORT_NONE = 0,
  SORT_ASCENDING = 1,
  SORT_DESCENDING = 2,
}
export enum SortType {
  SORT_TYPE_AUTO = 0,
  SORT_TYPE_NUMERIC = 1,
  SORT_TYPE_STRING = 2,
  SORT_TYPE_STRING_NO_CASE = 3,
  SORT_TYPE_CUSTOM = 4,
}
export enum SpanCompareMode {
  SPAN_COMPARE_EXACT = 0,
  SPAN_COMPARE_NO_CASE = 1,
  SPAN_COMPARE_TRIM_NO_CASE = 2,
  SPAN_COMPARE_INCLUDE_NULLS = 3,
}
export enum StickyEdge {
  STICKY_NONE = 0,
  STICKY_TOP = 1,
  STICKY_BOTTOM = 2,
  STICKY_LEFT = 3,
  STICKY_RIGHT = 4,
  STICKY_BOTH = 5,
}
export enum TabBehavior {
  TAB_CONTROLS = 0,
  TAB_CELLS = 1,
}
export enum TerminalColorLevel {
  TERMINAL_COLOR_LEVEL_AUTO = 0,
  TERMINAL_COLOR_LEVEL_TRUECOLOR = 1,
  TERMINAL_COLOR_LEVEL_256 = 2,
  TERMINAL_COLOR_LEVEL_16 = 3,
}
export enum TerminalCommand_Kind {
  TERMINAL_COMMAND_NONE = 0,
  TERMINAL_COMMAND_EXIT = 1,
}
export enum TextBaseline {
  TEXT_BASELINE_NORMAL = 0,
  TEXT_BASELINE_SUPERSCRIPT = 1,
  TEXT_BASELINE_SUBSCRIPT = 2,
}
export enum TextEffect {
  TEXT_EFFECT_NONE = 0,
  TEXT_EFFECT_EMBOSS = 1,
  TEXT_EFFECT_ENGRAVE = 2,
  TEXT_EFFECT_EMBOSS_LIGHT = 3,
  TEXT_EFFECT_ENGRAVE_LIGHT = 4,
}
export enum TextHintingMode {
  TEXT_HINT_AUTO = 0,
  TEXT_HINT_NONE = 1,
  TEXT_HINT_SLIGHT = 2,
  TEXT_HINT_FULL = 3,
}
export enum TextRenderMode {
  TEXT_RENDER_AUTO = 0,
  TEXT_RENDER_GRAYSCALE = 1,
  TEXT_RENDER_SUBPIXEL = 2,
  TEXT_RENDER_MONO = 3,
}
export enum ThemePreset {
  THEME_NONE = 0,
  THEME_CLASSIC = 1,
  THEME_LIGHT = 2,
  THEME_DARK = 3,
  THEME_HIGH_CONTRAST = 4,
  THEME_MONOKAI = 5,
  THEME_AMBER = 6,
}
export enum TreeIndicatorStyle {
  TREE_INDICATOR_NONE = 0,
  TREE_INDICATOR_ARROWS = 1,
  TREE_INDICATOR_ARROWS_LEAF = 2,
  TREE_INDICATOR_CONNECTORS = 3,
  TREE_INDICATOR_CONNECTORS_LEAF = 4,
}
export enum TypeAheadMode {
  TYPE_AHEAD_NONE = 0,
  TYPE_AHEAD_FROM_START = 1,
  TYPE_AHEAD_FROM_CURSOR = 2,
}
export enum TypePolicy {
  TYPE_AUTO_DETECT = 0,
  TYPE_ALL_STRING = 1,
  TYPE_FROM_SCHEMA = 2,
}
export enum ValidationMode {
  VALIDATION_BLOCK = 0,
  VALIDATION_REVERT = 1,
  VALIDATION_ALLOW_INVALID = 2,
}
export enum ValidationTrigger {
  VALIDATION_TRIGGER_ON_COMMIT = 0,
  VALIDATION_TRIGGER_ON_CHANGE = 1,
  VALIDATION_TRIGGER_ON_PAUSE = 2,
  VALIDATION_TRIGGER_ON_FOCUS_LOST = 3,
}
export enum WriteErrorMode {
  WRITE_ERROR_UNSPECIFIED = 0,
  WRITE_ERROR_REJECT = 1,
  WRITE_ERROR_SET_NULL = 2,
  WRITE_ERROR_SKIP = 3,
}
export enum ZoomEvent_Phase {
  ZOOM_PHASE_UNSPECIFIED = 0,
  ZOOM_BEGIN = 1,
  ZOOM_UPDATE = 2,
  ZOOM_END = 3,
}
export const AfterEditEventFields = {
  "row": 1,
  "col": 2,
  "old_text": 3,
  "new_text": 4,
} as const;
export const AfterMoveColumnEventFields = {
  "col": 1,
  "old_position": 2,
} as const;
export const AfterMoveRowEventFields = {
  "row": 1,
  "old_position": 2,
} as const;
export const AfterNodeToggleEventFields = {
  "row": 1,
  "collapse": 2,
} as const;
export const AfterScrollEventFields = {
  "old_top_row": 1,
  "old_left_col": 2,
  "new_top_row": 3,
  "new_left_col": 4,
} as const;
export const AfterSortEventFields = {
  "col": 1,
} as const;
export const AfterTreeNodeToggleEventFields = {
  "node_id": 1,
  "row": 2,
  "collapse": 3,
} as const;
export const AfterUserFreezeEventFields = {
  "frozen_rows": 1,
  "frozen_cols": 2,
} as const;
export const AfterUserResizeEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const AggregateRequestFields = {
  "grid_id": 1,
  "aggregate": 2,
  "row1": 3,
  "col1": 4,
  "row2": 5,
  "col2": 6,
} as const;
export const AggregateResponseFields = {
  "value": 1,
} as const;
export const AppendDataRequestFields = {
  "grid_id": 1,
  "data": 2,
  "options": 3,
} as const;
export const ArchiveRequestFields = {
  "grid_id": 1,
  "name": 2,
  "action": 3,
  "data": 4,
} as const;
export const ArchiveResponseFields = {
  "data": 1,
  "names": 2,
} as const;
export const AutoSizeRequestFields = {
  "grid_id": 1,
  "col_from": 2,
  "col_to": 3,
  "equal": 4,
  "max_width": 5,
} as const;
export const AutoSizeResponseFields = {
} as const;
export const BarcodeCaptionOptionsFields = {
  "position": 1,
  "text": 2,
  "color": 3,
  "font_size": 4,
} as const;
export const BarcodeDataFields = {
  "symbology": 1,
  "value": 2,
  "encoding": 3,
  "render": 4,
  "caption": 5,
} as const;
export const BarcodeEncodingOptionsFields = {
  "check_digit": 1,
  "text_encoding": 2,
  "qr_ecc": 3,
} as const;
export const BarcodeRenderOptionsFields = {
  "foreground": 1,
  "background": 2,
  "alignment": 3,
  "module_size": 4,
  "quiet_zone": 5,
  "bar_height": 10,
  "narrow_bar_width": 11,
  "show_size_warning": 12,
  "size_warning_color": 13,
  "use_full_rect": 14,
} as const;
export const BeforeEditEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const BeforeMouseDownEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const BeforeMoveColumnEventFields = {
  "col": 1,
  "new_position": 2,
} as const;
export const BeforeMoveRowEventFields = {
  "row": 1,
  "new_position": 2,
} as const;
export const BeforeNodeToggleEventFields = {
  "row": 1,
  "collapse": 2,
} as const;
export const BeforePageBreakEventFields = {
  "row": 1,
} as const;
export const BeforeScrollEventFields = {
  "old_top_row": 1,
  "old_left_col": 2,
  "new_top_row": 3,
  "new_left_col": 4,
} as const;
export const BeforeSortEventFields = {
  "col": 1,
} as const;
export const BeforeTreeNodeToggleEventFields = {
  "node_id": 1,
  "row": 2,
  "collapse": 3,
} as const;
export const BeforeUserResizeEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const BorderFields = {
  "style": 1,
  "color": 2,
} as const;
export const BordersFields = {
  "all": 1,
  "top": 2,
  "right": 3,
  "bottom": 4,
  "left": 5,
} as const;
export const BufferReadyFields = {
  "handle": 1,
  "stride": 2,
  "width": 3,
  "height": 4,
  "capacity": 5,
} as const;
export const CellChangedEventFields = {
  "row": 1,
  "col": 2,
  "old_text": 3,
  "new_text": 4,
} as const;
export const CellDataFields = {
  "row": 1,
  "col": 2,
  "value": 3,
  "style": 4,
  "checked": 5,
  "interaction": 6,
  "barcode": 7,
  "barcode_status": 8,
  "rich_text": 9,
} as const;
export const CellEditChangeEventFields = {
  "text": 1,
} as const;
export const CellEditValidateEventFields = {
  "row": 1,
  "col": 2,
  "edit_text": 3,
} as const;
export const CellFocusChangedEventFields = {
  "old_row": 1,
  "old_col": 2,
  "new_row": 3,
  "new_col": 4,
} as const;
export const CellFocusChangingEventFields = {
  "old_row": 1,
  "old_col": 2,
  "new_row": 3,
  "new_col": 4,
} as const;
export const CellRangeFields = {
  "row1": 1,
  "col1": 2,
  "row2": 3,
  "col2": 4,
} as const;
export const CellStyleFields = {
  "background": 1,
  "foreground": 2,
  "align": 3,
  "font": 4,
  "padding": 5,
  "borders": 6,
  "text_effect": 7,
  "progress": 8,
  "progress_color": 9,
  "shrink_to_fit": 10,
} as const;
export const CellUpdateFields = {
  "row": 1,
  "col": 2,
  "value": 3,
  "style": 4,
  "checked": 5,
  "picture": 6,
  "picture_align": 7,
  "button_picture": 8,
  "editor": 9,
  "sticky_row": 10,
  "sticky_col": 11,
  "interaction": 12,
  "barcode": 13,
  "rich_text": 14,
} as const;
export const CellValueFields = {
  "text": 1,
  "number": 2,
  "flag": 3,
  "raw": 4,
  "timestamp": 5,
} as const;
export const CellsResponseFields = {
  "cells": 1,
} as const;
export const CheckboxEditorParamsFields = {
  "three_state": 1,
} as const;
export const ClearRequestFields = {
  "grid_id": 1,
  "scope": 2,
  "region": 3,
} as const;
export const ClearResponseFields = {
  "cleared_count": 1,
} as const;
export const ClickEventFields = {
  "row": 1,
  "col": 2,
  "hit_area": 3,
  "interaction": 4,
  "target": 5,
} as const;
export const ClipboardCommandFields = {
  "grid_id": 1,
  "copy": 2,
  "cut": 3,
  "paste": 4,
  "delete": 5,
} as const;
export const ClipboardCopyFields = {
} as const;
export const ClipboardCutFields = {
} as const;
export const ClipboardDeleteFields = {
} as const;
export const ClipboardPasteFields = {
  "text": 1,
  "rich_data": 2,
} as const;
export const ClipboardResponseFields = {
  "text": 1,
  "rich_data": 2,
} as const;
export const ColIndicatorCellFields = {
  "row1": 1,
  "row2": 2,
  "col1": 3,
  "col2": 4,
  "text": 5,
  "custom_key": 6,
  "data": 7,
  "modes": 8,
} as const;
export const ColIndicatorCellModesFields = {
  "modes": 1,
} as const;
export const ColIndicatorConfigFields = {
  "visible": 1,
  "default_row_height": 2,
  "band_rows": 3,
  "background": 4,
  "foreground": 5,
  "grid_lines": 6,
  "grid_color": 7,
  "auto_size": 8,
  "allow_resize": 9,
  "allow_reorder": 10,
  "allow_menu": 11,
  "row_defs": 12,
  "cells": 13,
  "cell_modes": 14,
} as const;
export const ColIndicatorRowDefFields = {
  "index": 1,
  "height": 2,
} as const;
export const ColumnDefFields = {
  "index": 1,
  "width": 2,
  "min_width": 3,
  "max_width": 4,
  "caption": 5,
  "align": 6,
  "fixed_align": 7,
  "data_type": 8,
  "format": 9,
  "key": 10,
  "sort_order": 11,
  "sort_type": 12,
  "editor": 13,
  "indent": 14,
  "hidden": 15,
  "span": 16,
  "image_list": 17,
  "data": 18,
  "sticky": 19,
  "padding": 20,
  "fixed_padding": 21,
  "nullable": 22,
  "coercion_mode": 23,
  "error_mode": 24,
  "interaction": 25,
  "progress_color": 26,
} as const;
export const CompareEventFields = {
  "request_id": 1,
  "row1": 2,
  "row2": 3,
  "col": 4,
} as const;
export const CompareResponseFields = {
  "request_id": 1,
  "result": 2,
} as const;
export const ConfigureRequestFields = {
  "grid_id": 1,
  "config": 2,
} as const;
export const ConfigureResponseFields = {
} as const;
export const CornerIndicatorConfigFields = {
  "visible": 1,
  "background": 2,
  "foreground": 3,
  "custom_key": 4,
  "data": 5,
  "slots": 6,
} as const;
export const CornerIndicatorSlotFields = {
  "kind": 1,
  "width": 2,
  "visible": 3,
  "custom_key": 4,
  "data": 5,
  "label_text": 6,
} as const;
export const CreateRequestFields = {
  "viewport_width": 1,
  "viewport_height": 2,
  "scale": 3,
  "config": 4,
} as const;
export const CreateResponseFields = {
  "grid_id": 1,
  "warnings": 2,
} as const;
export const CsvOptionsFields = {
  "delimiter": 1,
  "quote_char": 2,
  "trim_whitespace": 3,
} as const;
export const CursorChangeFields = {
  "cursor": 1,
} as const;
export const CustomEditorActionFields = {
  "action_id": 1,
  "payload": 2,
} as const;
export const CustomEditorActionEventFields = {
  "session_id": 1,
  "row": 2,
  "col": 3,
  "action_id": 4,
  "payload": 5,
} as const;
export const CustomRenderCellEventFields = {
  "row": 1,
  "col": 2,
  "x": 3,
  "y": 4,
  "width": 5,
  "height": 6,
  "text": 7,
  "style": 8,
  "done": 9,
} as const;
export const DataRefreshedEventFields = {
} as const;
export const DataRefreshingEventFields = {
} as const;
export const DateTimeEditorParamsFields = {
  "format": 1,
  "min_timestamp": 2,
  "max_timestamp": 3,
  "date_only": 4,
  "time_only": 5,
} as const;
export const DblClickEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const DefineColumnsRequestFields = {
  "grid_id": 1,
  "columns": 2,
} as const;
export const DefineColumnsResponseFields = {
} as const;
export const DefineRowsRequestFields = {
  "grid_id": 1,
  "rows": 2,
} as const;
export const DefineRowsResponseFields = {
} as const;
export const DestroyRequestFields = {
  "grid_id": 1,
} as const;
export const DestroyResponseFields = {
} as const;
export const DragCompleteEventFields = {
  "success": 1,
} as const;
export const DragDropEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const DragOverEventFields = {
  "row": 1,
  "col": 2,
  "x": 3,
  "y": 4,
} as const;
export const DragStartEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const EditActivationFields = {
  "trigger": 1,
  "tab_behavior": 2,
  "single_click_edit": 3,
  "suppress_click_edit": 4,
  "commit_on_focus_lost": 5,
  "preserve_edit_on_navigation": 6,
} as const;
export const EditCancelFields = {
} as const;
export const EditCommandFields = {
  "grid_id": 1,
  "start": 2,
  "session": 3,
  "get_state": 4,
} as const;
export const EditCommitFields = {
  "value": 1,
} as const;
export const EditConfigFields = {
  "activation": 1,
  "default_editor": 2,
  "compose_method": 3,
} as const;
export const EditGetStateFields = {
} as const;
export const EditSetHighlightsFields = {
  "regions": 1,
} as const;
export const EditStartFields = {
  "row": 1,
  "col": 2,
  "reason": 3,
  "seed_value": 4,
  "caret_position": 5,
} as const;
export const EditStateFields = {
  "active": 1,
  "session": 2,
} as const;
export const EditValidationRequestFields = {
  "request_id": 1,
  "session_id": 2,
  "row": 3,
  "col": 4,
  "value": 5,
} as const;
export const EditValidationResponseFields = {
  "request_id": 1,
  "session_id": 2,
  "errors": 3,
  "normalized_value": 4,
} as const;
export const EditorActionFields = {
  "action_id": 1,
  "label": 2,
  "role": 3,
  "icon": 4,
} as const;
export const EditorCapabilitiesFields = {
  "accepts_text_input": 1,
  "supports_selection": 2,
  "supports_cut": 3,
  "supports_paste": 4,
  "supports_undo": 5,
} as const;
export const EditorListItemsRequestFields = {
  "request_id": 1,
  "session_id": 2,
  "data_source_id": 3,
  "filter_text": 4,
  "offset": 5,
  "limit": 6,
} as const;
export const EditorListItemsResponseFields = {
  "request_id": 1,
  "session_id": 2,
  "items": 3,
  "has_more": 4,
} as const;
export const EditorPreeditChangedFields = {
  "text": 1,
  "cursor": 2,
  "commit": 3,
} as const;
export const EditorSessionFields = {
  "session_id": 1,
  "row": 2,
  "col": 3,
  "viewport_rect": 4,
  "editor": 5,
  "value": 6,
  "selection": 7,
  "ui_mode": 8,
  "capabilities": 9,
  "reason": 10,
  "state_version": 11,
  "composing": 12,
  "preedit_text": 13,
  "validation_errors": 14,
} as const;
export const EditorSessionCommandFields = {
  "session_id": 1,
  "state_version": 2,
  "value_changed": 3,
  "selection_changed": 4,
  "preedit_changed": 5,
  "commit": 6,
  "cancel": 7,
  "custom_action": 8,
} as const;
export const EditorSessionEndedFields = {
  "session_id": 1,
  "reason": 2,
  "committed_value": 3,
  "state_version": 4,
} as const;
export const EditorSessionStartedFields = {
  "session": 1,
} as const;
export const EditorSessionUpdatedFields = {
  "session_id": 1,
  "state_version": 2,
  "reason": 3,
  "viewport_rect": 4,
  "value": 5,
  "selection": 6,
  "visible": 7,
  "force_refocus": 8,
  "validation_errors": 9,
  "custom_payload": 10,
} as const;
export const EditorSpecFields = {
  "kind": 1,
  "owner": 2,
  "presentation": 3,
  "validation_mode": 4,
  "validation_trigger": 5,
  "validation_debounce_ms": 6,
  "custom_editor_id": 10,
  "text": 11,
  "number": 12,
  "checkbox": 13,
  "list": 14,
  "date_time": 15,
  "actions": 16,
  "custom_props": 17,
} as const;
export const EditorValueFields = {
  "value": 1,
  "edit_text": 2,
  "display_text": 3,
} as const;
export const EditorValueChangedFields = {
  "value": 1,
} as const;
export const EnterCellEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const ErrorEventFields = {
  "code": 1,
  "message": 2,
} as const;
export const EventDecisionFields = {
  "grid_id": 1,
  "event_id": 2,
  "cancel": 3,
} as const;
export const EventStreamRequestFields = {
  "grid_id": 1,
} as const;
export const ExportRequestFields = {
  "grid_id": 1,
  "format": 2,
  "scope": 3,
} as const;
export const ExportResponseFields = {
  "data": 1,
  "format": 2,
} as const;
export const FieldMappingFields = {
  "field": 1,
  "col_index": 2,
  "col_key": 3,
} as const;
export const FilterDataEventFields = {
  "row": 1,
  "col": 2,
  "text": 3,
} as const;
export const FindRequestFields = {
  "grid_id": 1,
  "col": 2,
  "start_row": 3,
  "text_query": 4,
  "regex_query": 5,
} as const;
export const FindResponseFields = {
  "row": 1,
} as const;
export const FontFields = {
  "family": 1,
  "families": 2,
  "size": 3,
  "bold": 4,
  "italic": 5,
  "underline": 6,
  "strikethrough": 7,
  "stretch": 8,
} as const;
export const FrameDoneFields = {
  "handle": 1,
  "dirty_x": 2,
  "dirty_y": 3,
  "dirty_w": 4,
  "dirty_h": 5,
  "metrics": 6,
  "bytes_written": 7,
  "required_capacity": 8,
  "frame_kind": 9,
} as const;
export const FrameMetricsFields = {
  "frame_time_ms": 1,
  "fps": 2,
  "layer_times_us": 3,
  "zone_cell_counts": 4,
  "instance_count": 5,
} as const;
export const FreezePolicyFields = {
  "columns": 1,
  "rows": 2,
} as const;
export const GetCellsRequestFields = {
  "grid_id": 1,
  "row1": 2,
  "col1": 3,
  "row2": 4,
  "col2": 5,
  "include_style": 6,
  "include_checked": 7,
  "include_typed": 8,
  "include_barcode_status": 9,
  "include_rich_text": 10,
} as const;
export const GetConfigRequestFields = {
  "grid_id": 1,
} as const;
export const GetDemoDataRequestFields = {
  "demo": 1,
} as const;
export const GetDemoDataResponseFields = {
  "demo": 1,
  "format": 2,
  "data": 3,
} as const;
export const GetHeaderRowEventFields = {
  "page": 1,
} as const;
export const GetMemoryUsageRequestFields = {
  "grid_id": 1,
} as const;
export const GetMergedRangeRequestFields = {
  "grid_id": 1,
  "row": 2,
  "col": 3,
} as const;
export const GetMergedRegionsRequestFields = {
  "grid_id": 1,
} as const;
export const GetNodeRequestFields = {
  "grid_id": 1,
  "row": 2,
  "relation": 3,
} as const;
export const GetSchemaRequestFields = {
  "grid_id": 1,
} as const;
export const GetSelectionRequestFields = {
  "grid_id": 1,
} as const;
export const GpuFrameDoneFields = {
  "dirty_x": 1,
  "dirty_y": 2,
  "dirty_w": 3,
  "dirty_h": 4,
  "metrics": 5,
} as const;
export const GpuSurfaceReadyFields = {
  "surface_handle": 1,
  "width": 2,
  "height": 3,
} as const;
export const GridConfigFields = {
  "layout": 1,
  "style": 2,
  "selection": 3,
  "editing": 4,
  "scrolling": 5,
  "outline": 6,
  "span": 7,
  "interaction": 8,
  "rendering": 9,
  "version": 10,
  "indicators": 11,
  "theme_preset": 12,
} as const;
export const GridEventFields = {
  "grid_id": 1,
  "event_id": 100,
  "cell_focus_changing": 2,
  "cell_focus_changed": 3,
  "selection_changing": 4,
  "selection_changed": 5,
  "enter_cell": 6,
  "leave_cell": 7,
  "before_edit": 8,
  "start_edit": 9,
  "after_edit": 10,
  "cell_edit_validate": 11,
  "cell_edit_change": 12,
  "key_down_edit": 13,
  "key_press_edit": 14,
  "key_up_edit": 15,
  "edit_validation_request": 16,
  "editor_list_items_request": 17,
  "custom_editor_action": 18,
  "cell_changed": 19,
  "row_status_change": 20,
  "before_sort": 21,
  "after_sort": 22,
  "compare": 23,
  "before_node_toggle": 24,
  "after_node_toggle": 25,
  "before_scroll": 26,
  "after_scroll": 27,
  "scroll_tooltip": 28,
  "before_user_resize": 29,
  "after_user_resize": 30,
  "after_user_freeze": 31,
  "before_move_column": 32,
  "after_move_column": 33,
  "before_move_row": 34,
  "after_move_row": 35,
  "before_mouse_down": 36,
  "mouse_down": 37,
  "mouse_up": 38,
  "mouse_move": 39,
  "click": 40,
  "dbl_click": 41,
  "key_down": 42,
  "key_press": 43,
  "key_up": 44,
  "custom_render_cell": 45,
  "drag_start": 46,
  "drag_over": 47,
  "drag_drop": 48,
  "drag_complete": 49,
  "type_ahead_started": 50,
  "type_ahead_ended": 51,
  "data_refreshing": 52,
  "data_refreshed": 53,
  "filter_data": 54,
  "error": 55,
  "before_page_break": 56,
  "start_page": 57,
  "get_header_row": 58,
  "pull_to_refresh_triggered": 59,
  "pull_to_refresh_canceled": 60,
  "tree_children_requested": 61,
  "before_tree_node_toggle": 62,
  "after_tree_node_toggle": 63,
  "tree_node_activate": 64,
  "tree_node_context_menu": 65,
} as const;
export const GridEventTargetFields = {
  "kind": 1,
  "band": 2,
  "slot_index": 3,
  "slot_kind": 4,
  "custom_key": 5,
  "text": 6,
  "int_value": 7,
  "status_flags": 8,
  "data": 9,
  "sub_mode": 10,
} as const;
export const GridLinesFields = {
  "style": 1,
  "direction": 2,
  "color": 3,
  "width": 4,
} as const;
export const HeaderFeaturesFields = {
  "sort": 1,
  "reorder": 2,
  "chooser": 3,
} as const;
export const HeaderMarkSizeFields = {
  "ratio": 1,
  "px": 2,
} as const;
export const HeaderResizeHandleFields = {
  "enabled": 1,
  "color": 2,
  "width": 3,
  "height": 4,
  "hit_width": 5,
  "show_only_when_resizable": 6,
} as const;
export const HeaderSeparatorFields = {
  "enabled": 1,
  "color": 2,
  "width": 3,
  "height": 4,
  "skip_merged": 5,
} as const;
export const HeaderStyleFields = {
  "separator": 1,
  "resize_handle": 2,
} as const;
export const HighlightRegionFields = {
  "range": 1,
  "style": 2,
  "ref_id": 3,
  "text_start": 4,
  "text_length": 5,
} as const;
export const HighlightStyleFields = {
  "background": 1,
  "foreground": 2,
  "borders": 3,
  "fill_handle": 4,
  "fill_handle_color": 5,
} as const;
export const HoverConfigFields = {
  "row": 1,
  "column": 2,
  "cell": 3,
  "row_style": 4,
  "column_style": 5,
  "cell_style": 6,
} as const;
export const IconPicturesFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "node_open": 3,
  "node_closed": 4,
  "checkbox_checked": 5,
  "checkbox_unchecked": 6,
  "checkbox_indeterminate": 7,
} as const;
export const IconSlotStylesFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "sort_none": 3,
  "tree_expanded": 4,
  "tree_collapsed": 5,
  "menu": 6,
  "filter": 7,
  "filter_active": 8,
  "columns": 9,
  "drag_handle": 10,
  "checkbox_checked": 11,
  "checkbox_unchecked": 12,
  "checkbox_indeterminate": 13,
} as const;
export const IconSlotsFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "sort_none": 3,
  "tree_expanded": 4,
  "tree_collapsed": 5,
  "menu": 6,
  "filter": 7,
  "filter_active": 8,
  "columns": 9,
  "drag_handle": 10,
  "checkbox_checked": 11,
  "checkbox_unchecked": 12,
  "checkbox_indeterminate": 13,
} as const;
export const IconStyleFields = {
  "font": 1,
  "color": 2,
  "align": 3,
  "gap": 4,
} as const;
export const IconThemeFields = {
  "slots": 1,
  "defaults": 2,
  "overrides": 3,
  "pictures": 4,
} as const;
export const ImageDataFields = {
  "data": 1,
  "format": 2,
} as const;
export const IndicatorColorsFields = {
  "background": 1,
  "foreground": 2,
  "grid": 3,
  "button_background": 4,
  "button_foreground": 5,
  "button_border": 6,
  "button_pressed_background": 7,
  "button_pressed_foreground": 8,
  "button_pressed_border_dark": 9,
  "button_pressed_border_light": 10,
  "button_hover_background": 11,
  "button_hover_foreground": 12,
  "button_hover_border": 13,
} as const;
export const IndicatorFocusConfigFields = {
  "enable_keyboard_focus": 1,
  "enter_key_code": 2,
  "exit_key_code": 3,
} as const;
export const IndicatorsConfigFields = {
  "row_start": 1,
  "row_end": 2,
  "col_top": 3,
  "col_bottom": 4,
  "corner_top_start": 5,
  "corner_top_end": 6,
  "corner_bottom_start": 7,
  "corner_bottom_end": 8,
  "focus": 9,
  "appearance": 10,
  "colors": 11,
} as const;
export const InsertRowsRequestFields = {
  "grid_id": 1,
  "index": 2,
  "count": 3,
  "text": 4,
} as const;
export const InsertRowsResponseFields = {
  "inserted_count": 1,
  "new_row_count": 2,
  "first_row": 3,
} as const;
export const InteractionConfigFields = {
  "resize": 1,
  "freeze": 2,
  "type_ahead": 3,
  "type_ahead_delay": 4,
  "auto_size_mouse": 5,
  "auto_size_mode": 6,
  "auto_resize": 7,
  "drag_mode": 8,
  "drop_mode": 9,
  "header_features": 10,
  "decision_timeout_ms": 11,
  "compare_response_timeout_ms": 12,
} as const;
export const JsonOptionsFields = {
  "data_path": 1,
} as const;
export const KeyDownEditEventFields = {
  "session_id": 1,
  "key_code": 2,
  "modifier": 3,
} as const;
export const KeyDownEventFields = {
  "key_code": 1,
  "modifier": 2,
} as const;
export const KeyEventFields = {
  "type": 1,
  "key_code": 2,
  "modifier": 3,
  "character": 4,
} as const;
export const KeyPressEditEventFields = {
  "session_id": 1,
  "key_ascii": 2,
} as const;
export const KeyPressEventFields = {
  "key_ascii": 1,
} as const;
export const KeyUpEditEventFields = {
  "session_id": 1,
  "key_code": 2,
  "modifier": 3,
} as const;
export const KeyUpEventFields = {
  "key_code": 1,
  "modifier": 2,
} as const;
export const LayoutConfigFields = {
  "rows": 1,
  "cols": 2,
  "fixed_rows": 3,
  "fixed_cols": 4,
  "frozen_rows": 5,
  "frozen_cols": 6,
  "default_row_height": 7,
  "default_col_width": 8,
  "right_to_left": 9,
  "extend_last_col": 10,
} as const;
export const LeaveCellEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const ListDataSourceFields = {
  "data_source_id": 1,
  "filterable": 2,
  "pageable": 3,
  "page_size": 4,
} as const;
export const ListEditorParamsFields = {
  "static_items": 1,
  "data_source": 2,
  "allow_custom_value": 3,
  "searchable": 4,
  "multi_select": 5,
  "item_layout": 6,
} as const;
export const ListItemFields = {
  "value": 1,
  "label": 2,
  "details": 3,
  "disabled": 4,
} as const;
export const LoadDataOptionsFields = {
  "csv": 1,
  "json": 2,
  "header_policy": 10,
  "field_map": 11,
  "type_policy": 12,
  "coercion": 13,
  "error_mode": 14,
  "date_format": 15,
  "decimal_char": 16,
  "auto_create_columns": 17,
  "atomic": 19,
  "skip_rows": 20,
  "max_rows": 21,
} as const;
export const LoadDataRequestFields = {
  "grid_id": 1,
  "data": 2,
  "options": 3,
} as const;
export const LoadDataResultFields = {
  "status": 1,
  "rows": 2,
  "cols": 3,
  "rejected": 4,
  "violations": 5,
  "warnings": 6,
  "inferred_columns": 7,
} as const;
export const LoadDemoRequestFields = {
  "grid_id": 1,
  "demo": 2,
} as const;
export const LoadDemoResponseFields = {
} as const;
export const LoadFontDataRequestFields = {
  "data": 1,
  "font_name": 2,
  "font_names": 3,
} as const;
export const LoadFontDataResponseFields = {
} as const;
export const LoadTableRequestFields = {
  "grid_id": 1,
  "rows": 2,
  "cols": 3,
  "values": 4,
  "atomic": 5,
} as const;
export const MemoryUsageResponseFields = {
  "total_bytes": 1,
  "cell_data_bytes": 2,
  "style_bytes": 3,
  "layout_bytes": 4,
  "column_bytes": 5,
  "row_bytes": 6,
  "selection_bytes": 7,
  "animation_bytes": 8,
  "text_engine_bytes": 9,
  "event_bytes": 10,
  "misc_bytes": 11,
  "cell_count": 12,
  "rows": 13,
  "cols": 14,
} as const;
export const MergeCellsRequestFields = {
  "grid_id": 1,
  "range": 2,
} as const;
export const MergeCellsResponseFields = {
  "merged": 1,
} as const;
export const MergedRegionsResponseFields = {
  "ranges": 1,
} as const;
export const MouseDownEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
} as const;
export const MouseMoveEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
  "target": 5,
} as const;
export const MouseUpEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
} as const;
export const MoveColumnRequestFields = {
  "grid_id": 1,
  "col": 2,
  "position": 3,
} as const;
export const MoveColumnResponseFields = {
} as const;
export const MoveRowRequestFields = {
  "grid_id": 1,
  "row": 2,
  "position": 3,
} as const;
export const MoveRowResponseFields = {
} as const;
export const NodeInfoFields = {
  "row": 1,
  "level": 2,
  "is_expanded": 3,
  "child_count": 4,
  "parent_row": 5,
  "first_child": 6,
  "last_child": 7,
} as const;
export const NumberEditorParamsFields = {
  "min": 1,
  "max": 2,
  "step": 3,
  "format": 4,
  "nullable": 5,
} as const;
export const OutlineConfigFields = {
  "tree_indicator": 1,
  "tree_color": 2,
  "group_total_position": 3,
  "multi_totals": 4,
  "indicator_indent": 5,
  "max_levels": 6,
  "show_level_buttons": 7,
  "label_column": 8,
  "icon_column": 9,
} as const;
export const OutlineRequestFields = {
  "grid_id": 1,
  "level": 2,
} as const;
export const OutlineResponseFields = {
} as const;
export const PaddingFields = {
  "left": 1,
  "top": 2,
  "right": 3,
  "bottom": 4,
} as const;
export const PointerEventFields = {
  "type": 1,
  "x": 2,
  "y": 3,
  "modifier": 4,
  "button": 5,
  "dbl_click": 6,
} as const;
export const PrintPageFields = {
  "page_number": 1,
  "image_data": 2,
  "width": 3,
  "height": 4,
} as const;
export const PrintRequestFields = {
  "grid_id": 1,
  "orientation": 2,
  "margin_left": 3,
  "margin_top": 4,
  "margin_right": 5,
  "margin_bottom": 6,
  "header": 7,
  "footer": 8,
  "show_page_numbers": 9,
} as const;
export const PrintResponseFields = {
  "pages": 1,
} as const;
export const PullToRefreshCanceledEventFields = {
} as const;
export const PullToRefreshConfigFields = {
  "enabled": 1,
  "theme": 2,
  "text_pull": 3,
  "text_release": 4,
} as const;
export const PullToRefreshTriggeredEventFields = {
} as const;
export const RectFields = {
  "x": 1,
  "y": 2,
  "width": 3,
  "height": 4,
} as const;
export const RefreshRequestFields = {
  "grid_id": 1,
} as const;
export const RefreshResponseFields = {
} as const;
export const RegexQueryFields = {
  "pattern": 1,
} as const;
export const RegionStyleFields = {
  "background": 1,
  "foreground": 2,
  "font": 3,
  "grid_lines": 4,
  "text_effect": 5,
  "separator": 6,
  "cell_padding": 7,
} as const;
export const RemoveRowsRequestFields = {
  "grid_id": 1,
  "index": 2,
  "count": 3,
} as const;
export const RemoveRowsResponseFields = {
  "removed_count": 1,
  "new_row_count": 2,
} as const;
export const RenderConfigFields = {
  "renderer_mode": 1,
  "debug_overlay": 2,
  "animation_enabled": 3,
  "animation_duration_ms": 4,
  "text_layout_cache_cap": 5,
  "present_mode": 6,
  "frame_pacing_mode": 7,
  "target_frame_rate_hz": 8,
  "render_layer_mask": 9,
  "layer_profiling": 10,
  "scroll_blit": 11,
  "font_fallback_enabled": 12,
} as const;
export const RenderInputFields = {
  "grid_id": 1,
  "viewport": 2,
  "pointer": 3,
  "key": 4,
  "buffer": 5,
  "scroll": 6,
  "event_decision": 7,
  "zoom": 8,
  "gpu_surface": 9,
  "terminal_input": 10,
  "terminal_capabilities": 11,
  "terminal_viewport": 12,
  "terminal_command": 13,
  "compare_response": 14,
  "edit_validation_response": 15,
  "editor_list_items_response": 16,
} as const;
export const RenderOutputFields = {
  "rendered": 1,
  "frame_done": 2,
  "selection": 3,
  "cursor": 4,
  "editor_started": 5,
  "editor_updated": 6,
  "editor_ended": 7,
  "tooltip_request": 8,
  "gpu_frame_done": 9,
} as const;
export const ResizePolicyFields = {
  "columns": 1,
  "rows": 2,
  "uniform": 3,
} as const;
export const ResizeViewportRequestFields = {
  "grid_id": 1,
  "width": 2,
  "height": 3,
} as const;
export const ResizeViewportResponseFields = {
  "viewport_width": 1,
  "viewport_height": 2,
} as const;
export const RichTextFields = {
  "runs": 1,
} as const;
export const RowDefFields = {
  "index": 1,
  "height": 2,
  "hidden": 3,
  "is_subtotal": 4,
  "outline_level": 5,
  "is_collapsed": 6,
  "data": 7,
  "status": 8,
  "span": 9,
  "pin": 10,
  "sticky": 11,
} as const;
export const RowIndicatorConfigFields = {
  "visible": 1,
  "width": 2,
  "background": 3,
  "foreground": 4,
  "grid_lines": 5,
  "grid_color": 6,
  "auto_size": 7,
  "allow_resize": 8,
  "allow_select": 9,
  "allow_reorder": 10,
  "slots": 11,
} as const;
export const RowIndicatorSlotFields = {
  "kind": 1,
  "width": 2,
  "visible": 3,
  "custom_key": 4,
  "data": 5,
} as const;
export const RowStatusFields = {
  "domain": 1,
  "code": 2,
} as const;
export const RowStatusChangeEventFields = {
  "row": 1,
  "status": 2,
} as const;
export const ScalarValueFields = {
  "string_value": 1,
  "number_value": 2,
  "bool_value": 3,
  "bytes_value": 4,
} as const;
export const SchemaResponseFields = {
  "columns": 1,
} as const;
export const ScrollBarColorsFields = {
  "thumb": 1,
  "thumb_hover": 2,
  "thumb_active": 3,
  "track": 4,
  "arrow": 5,
  "border": 6,
} as const;
export const ScrollBarConfigFields = {
  "show_h": 1,
  "show_v": 2,
  "appearance": 3,
  "size": 4,
  "min_thumb": 5,
  "corner_radius": 6,
  "colors": 7,
  "fade_delay_ms": 8,
  "fade_duration_ms": 9,
  "margin": 10,
} as const;
export const ScrollConfigFields = {
  "scroll_bar": 1,
  "scroll_track": 2,
  "scroll_tips": 3,
  "fling_enabled": 4,
  "fling_impulse_gain": 5,
  "fling_friction": 6,
  "pinch_zoom_enabled": 7,
  "fast_scroll": 8,
  "scrollbars": 9,
  "pull_to_refresh": 10,
} as const;
export const ScrollEventFields = {
  "delta_x": 1,
  "delta_y": 2,
} as const;
export const ScrollTooltipEventFields = {
  "text": 1,
} as const;
export const SelectRequestFields = {
  "grid_id": 1,
  "active_row": 2,
  "active_col": 3,
  "ranges": 4,
  "show": 5,
} as const;
export const SelectResponseFields = {
  "selection": 1,
} as const;
export const SelectionChangedEventFields = {
  "old_ranges": 1,
  "new_ranges": 2,
  "active_row": 3,
  "active_col": 4,
} as const;
export const SelectionChangingEventFields = {
  "old_ranges": 1,
  "new_ranges": 2,
  "active_row": 3,
  "active_col": 4,
} as const;
export const SelectionConfigFields = {
  "mode": 1,
  "focus_border": 2,
  "visibility": 3,
  "allow": 4,
  "header_click_select": 5,
  "style": 6,
  "hover": 7,
  "indicator_row_style": 8,
  "indicator_col_style": 9,
  "active_cell_style": 10,
} as const;
export const SelectionStateFields = {
  "active_row": 1,
  "active_col": 2,
  "ranges": 3,
  "top_row": 4,
  "left_col": 5,
  "bottom_row": 6,
  "right_col": 7,
  "mouse_row": 8,
  "mouse_col": 9,
} as const;
export const SelectionUpdateFields = {
  "active_row": 1,
  "active_col": 2,
  "ranges": 3,
} as const;
export const SeparatorFields = {
  "visible": 1,
  "color": 2,
  "width": 3,
} as const;
export const SetColRequestFields = {
  "grid_id": 1,
  "col": 2,
} as const;
export const SetLeftColResponseFields = {
  "left_col": 1,
} as const;
export const SetRedrawRequestFields = {
  "grid_id": 1,
  "enabled": 2,
} as const;
export const SetRedrawResponseFields = {
} as const;
export const SetRowRequestFields = {
  "grid_id": 1,
  "row": 2,
} as const;
export const SetTopRowResponseFields = {
  "top_row": 1,
} as const;
export const ShowCellRequestFields = {
  "grid_id": 1,
  "row": 2,
  "col": 3,
} as const;
export const ShowCellResponseFields = {
  "top_row": 1,
  "left_col": 2,
} as const;
export const SortColumnFields = {
  "col": 1,
  "order": 2,
  "type": 3,
} as const;
export const SortRequestFields = {
  "grid_id": 1,
  "sort_columns": 2,
} as const;
export const SortResponseFields = {
} as const;
export const SpanConfigFields = {
  "cell_span": 1,
  "cell_span_fixed": 2,
  "cell_span_compare": 3,
  "group_span_compare": 4,
} as const;
export const StartEditEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const StartPageEventFields = {
  "page": 1,
} as const;
export const StructFieldFields = {
  "key": 1,
  "value": 2,
} as const;
export const StructValueFields = {
  "fields": 1,
} as const;
export const StyleConfigFields = {
  "background": 1,
  "foreground": 2,
  "alternate_background": 3,
  "font": 4,
  "cell_padding": 5,
  "text_effect": 6,
  "progress_color": 7,
  "grid_lines": 10,
  "fixed": 11,
  "frozen": 12,
  "header": 13,
  "sheet_background": 20,
  "sheet_border": 21,
  "appearance": 22,
  "background_image": 23,
  "background_image_align": 24,
  "text_rendering": 25,
  "icons": 30,
  "image_over_text": 31,
  "show_sort_numbers": 32,
  "apply_scope": 33,
  "custom_render": 34,
  "format": 40,
  "word_wrap": 41,
  "ellipsis": 42,
  "text_overflow": 43,
} as const;
export const SubtotalRequestFields = {
  "grid_id": 1,
  "aggregate": 2,
  "group_on_col": 3,
  "aggregate_col": 4,
  "caption": 5,
  "background": 6,
  "foreground": 7,
  "add_outline": 8,
  "font": 9,
} as const;
export const SubtotalResultFields = {
  "rows": 1,
} as const;
export const TerminalCapabilitiesFields = {
  "color_level": 1,
  "sgr_mouse": 2,
  "focus_events": 3,
  "bracketed_paste": 4,
} as const;
export const TerminalCommandFields = {
  "kind": 1,
} as const;
export const TerminalInputBytesFields = {
  "data": 1,
} as const;
export const TerminalViewportFields = {
  "origin_x": 1,
  "origin_y": 2,
  "width": 3,
  "height": 4,
  "fullscreen": 5,
} as const;
export const TextEditorParamsFields = {
  "max_length": 1,
  "mask": 2,
  "allow_newlines": 3,
  "input_type": 4,
} as const;
export const TextFormatRunFields = {
  "start_index": 1,
  "style": 2,
} as const;
export const TextQueryFields = {
  "text": 1,
  "case_sensitive": 2,
  "full_match": 3,
} as const;
export const TextRenderingFields = {
  "mode": 1,
  "hinting": 2,
  "pixel_snap": 3,
} as const;
export const TextRunStyleFields = {
  "foreground": 1,
  "font": 2,
  "baseline": 3,
  "link_url": 4,
} as const;
export const TextSelectionFields = {
  "start": 1,
  "length": 2,
} as const;
export const TextSelectionChangedFields = {
  "selection": 1,
} as const;
export const TooltipRequestFields = {
  "x": 1,
  "y": 2,
  "text": 3,
} as const;
export const TreeChildrenRequestedEventFields = {
  "node_id": 1,
  "row": 2,
  "request_id": 3,
} as const;
export const TreeNodeActivateEventFields = {
  "node_id": 1,
  "row": 2,
} as const;
export const TreeNodeContextMenuEventFields = {
  "node_id": 1,
  "row": 2,
  "x": 3,
  "y": 4,
} as const;
export const TypeAheadEndedEventFields = {
} as const;
export const TypeAheadStartedEventFields = {
  "col": 1,
  "text": 2,
} as const;
export const TypeViolationFields = {
  "row": 1,
  "col": 2,
  "expected": 3,
  "actual": 4,
  "reason": 5,
} as const;
export const UnmergeCellsRequestFields = {
  "grid_id": 1,
  "range": 2,
} as const;
export const UnmergeCellsResponseFields = {
  "unmerged_count": 1,
} as const;
export const UpdateCellsRequestFields = {
  "grid_id": 1,
  "cells": 2,
  "atomic": 3,
} as const;
export const ValidationErrorFields = {
  "code": 1,
  "message": 2,
  "blocking": 3,
} as const;
export const ViewportStateFields = {
  "scroll_x": 1,
  "scroll_y": 2,
  "width": 3,
  "height": 4,
} as const;
export const WriteResultFields = {
  "written_count": 1,
  "rejected_count": 2,
  "violations": 3,
} as const;
export const ZoomEventFields = {
  "phase": 1,
  "scale": 2,
  "focal_x_px": 3,
  "focal_y_px": 4,
} as const;
export class AfterEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "old_text",
      jsonName: "oldText",
      prop: "oldText",
      kind: "string" as ProtoKind,
    },
    {
      no: 4,
      name: "new_text",
      jsonName: "newText",
      prop: "newText",
      kind: "string" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  oldText: string = "";
  newText: string = "";

  constructor(init?: Partial<AfterEditEvent>) {
    initMessage(this, AfterEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterEditEvent {
    return decodeMessage(AfterEditEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterEditEvent {
    return AfterEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterEditEvent.fields);
  }
}
registerMessage(AfterEditEvent);
export class AfterMoveColumnEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterMoveColumnEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_position",
      jsonName: "oldPosition",
      prop: "oldPosition",
      kind: "int32" as ProtoKind,
    },
  ];
  col: number = 0;
  oldPosition: number = 0;

  constructor(init?: Partial<AfterMoveColumnEvent>) {
    initMessage(this, AfterMoveColumnEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterMoveColumnEvent {
    return decodeMessage(AfterMoveColumnEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterMoveColumnEvent {
    return AfterMoveColumnEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterMoveColumnEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterMoveColumnEvent.fields);
  }
}
registerMessage(AfterMoveColumnEvent);
export class AfterMoveRowEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterMoveRowEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_position",
      jsonName: "oldPosition",
      prop: "oldPosition",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  oldPosition: number = 0;

  constructor(init?: Partial<AfterMoveRowEvent>) {
    initMessage(this, AfterMoveRowEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterMoveRowEvent {
    return decodeMessage(AfterMoveRowEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterMoveRowEvent {
    return AfterMoveRowEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterMoveRowEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterMoveRowEvent.fields);
  }
}
registerMessage(AfterMoveRowEvent);
export class AfterNodeToggleEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterNodeToggleEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "collapse",
      jsonName: "collapse",
      prop: "collapse",
      kind: "bool" as ProtoKind,
    },
  ];
  row: number = 0;
  collapse: boolean = false;

  constructor(init?: Partial<AfterNodeToggleEvent>) {
    initMessage(this, AfterNodeToggleEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterNodeToggleEvent {
    return decodeMessage(AfterNodeToggleEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterNodeToggleEvent {
    return AfterNodeToggleEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterNodeToggleEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterNodeToggleEvent.fields);
  }
}
registerMessage(AfterNodeToggleEvent);
export class AfterScrollEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterScrollEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_top_row",
      jsonName: "oldTopRow",
      prop: "oldTopRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_left_col",
      jsonName: "oldLeftCol",
      prop: "oldLeftCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "new_top_row",
      jsonName: "newTopRow",
      prop: "newTopRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "new_left_col",
      jsonName: "newLeftCol",
      prop: "newLeftCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldTopRow: number = 0;
  oldLeftCol: number = 0;
  newTopRow: number = 0;
  newLeftCol: number = 0;

  constructor(init?: Partial<AfterScrollEvent>) {
    initMessage(this, AfterScrollEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterScrollEvent {
    return decodeMessage(AfterScrollEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterScrollEvent {
    return AfterScrollEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterScrollEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterScrollEvent.fields);
  }
}
registerMessage(AfterScrollEvent);
export class AfterSortEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterSortEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  col: number = 0;

  constructor(init?: Partial<AfterSortEvent>) {
    initMessage(this, AfterSortEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterSortEvent {
    return decodeMessage(AfterSortEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterSortEvent {
    return AfterSortEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterSortEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterSortEvent.fields);
  }
}
registerMessage(AfterSortEvent);
export class AfterTreeNodeToggleEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterTreeNodeToggleEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "node_id",
      jsonName: "nodeId",
      prop: "nodeId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "collapse",
      jsonName: "collapse",
      prop: "collapse",
      kind: "bool" as ProtoKind,
    },
  ];
  nodeId: string = "";
  row: number = 0;
  collapse: boolean = false;

  constructor(init?: Partial<AfterTreeNodeToggleEvent>) {
    initMessage(this, AfterTreeNodeToggleEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterTreeNodeToggleEvent {
    return decodeMessage(AfterTreeNodeToggleEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterTreeNodeToggleEvent {
    return AfterTreeNodeToggleEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterTreeNodeToggleEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterTreeNodeToggleEvent.fields);
  }
}
registerMessage(AfterTreeNodeToggleEvent);
export class AfterUserFreezeEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterUserFreezeEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "frozen_rows",
      jsonName: "frozenRows",
      prop: "frozenRows",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "frozen_cols",
      jsonName: "frozenCols",
      prop: "frozenCols",
      kind: "int32" as ProtoKind,
    },
  ];
  frozenRows: number = 0;
  frozenCols: number = 0;

  constructor(init?: Partial<AfterUserFreezeEvent>) {
    initMessage(this, AfterUserFreezeEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterUserFreezeEvent {
    return decodeMessage(AfterUserFreezeEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterUserFreezeEvent {
    return AfterUserFreezeEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterUserFreezeEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterUserFreezeEvent.fields);
  }
}
registerMessage(AfterUserFreezeEvent);
export class AfterUserResizeEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AfterUserResizeEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<AfterUserResizeEvent>) {
    initMessage(this, AfterUserResizeEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AfterUserResizeEvent {
    return decodeMessage(AfterUserResizeEvent, data);
  }

  static parseFrom(data: Uint8Array): AfterUserResizeEvent {
    return AfterUserResizeEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AfterUserResizeEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AfterUserResizeEvent.fields);
  }
}
registerMessage(AfterUserResizeEvent);
export class AggregateRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AggregateRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "aggregate",
      jsonName: "aggregate",
      prop: "aggregate",
      kind: "enum" as ProtoKind,
      enumType: AggregateType,
    },
    {
      no: 3,
      name: "row1",
      jsonName: "row1",
      prop: "row1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "col1",
      jsonName: "col1",
      prop: "col1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "row2",
      jsonName: "row2",
      prop: "row2",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "col2",
      jsonName: "col2",
      prop: "col2",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  aggregate: AggregateType = 0;
  row1: number = 0;
  col1: number = 0;
  row2: number = 0;
  col2: number = 0;

  constructor(init?: Partial<AggregateRequest>) {
    initMessage(this, AggregateRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AggregateRequest {
    return decodeMessage(AggregateRequest, data);
  }

  static parseFrom(data: Uint8Array): AggregateRequest {
    return AggregateRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AggregateRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AggregateRequest.fields);
  }
}
registerMessage(AggregateRequest);
export class AggregateResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AggregateResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "double" as ProtoKind,
    },
  ];
  value: number = 0;

  constructor(init?: Partial<AggregateResponse>) {
    initMessage(this, AggregateResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AggregateResponse {
    return decodeMessage(AggregateResponse, data);
  }

  static parseFrom(data: Uint8Array): AggregateResponse {
    return AggregateResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AggregateResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AggregateResponse.fields);
  }
}
registerMessage(AggregateResponse);
export class AppendDataRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AppendDataRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 3,
      name: "options",
      jsonName: "options",
      prop: "options",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "LoadDataOptions",
    },
  ];
  gridId: bigint = 0n;
  data?: Uint8Array;
  options?: LoadDataOptions;

  constructor(init?: Partial<AppendDataRequest>) {
    initMessage(this, AppendDataRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AppendDataRequest {
    return decodeMessage(AppendDataRequest, data);
  }

  static parseFrom(data: Uint8Array): AppendDataRequest {
    return AppendDataRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AppendDataRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AppendDataRequest.fields);
  }
}
registerMessage(AppendDataRequest);
export class ArchiveRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ArchiveRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "name",
      jsonName: "name",
      prop: "name",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "action",
      jsonName: "action",
      prop: "action",
      kind: "enum" as ProtoKind,
      enumType: ArchiveRequest_Action,
    },
    {
      no: 4,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  name: string = "";
  action: ArchiveRequest_Action = 0;
  data?: Uint8Array;

  constructor(init?: Partial<ArchiveRequest>) {
    initMessage(this, ArchiveRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ArchiveRequest {
    return decodeMessage(ArchiveRequest, data);
  }

  static parseFrom(data: Uint8Array): ArchiveRequest {
    return ArchiveRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ArchiveRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ArchiveRequest.fields);
  }
}
registerMessage(ArchiveRequest);
export class ArchiveResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ArchiveResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 2,
      name: "names",
      jsonName: "names",
      prop: "names",
      kind: "string" as ProtoKind,
      repeated: true,
    },
  ];
  data?: Uint8Array;
  names: string[] = [];

  constructor(init?: Partial<ArchiveResponse>) {
    initMessage(this, ArchiveResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ArchiveResponse {
    return decodeMessage(ArchiveResponse, data);
  }

  static parseFrom(data: Uint8Array): ArchiveResponse {
    return ArchiveResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ArchiveResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ArchiveResponse.fields);
  }
}
registerMessage(ArchiveResponse);
export class AutoSizeRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AutoSizeRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "col_from",
      jsonName: "colFrom",
      prop: "colFrom",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col_to",
      jsonName: "colTo",
      prop: "colTo",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "equal",
      jsonName: "equal",
      prop: "equal",
      kind: "bool" as ProtoKind,
    },
    {
      no: 5,
      name: "max_width",
      jsonName: "maxWidth",
      prop: "maxWidth",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  colFrom: number = 0;
  colTo: number = 0;
  equal: boolean = false;
  maxWidth: number = 0;

  constructor(init?: Partial<AutoSizeRequest>) {
    initMessage(this, AutoSizeRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AutoSizeRequest {
    return decodeMessage(AutoSizeRequest, data);
  }

  static parseFrom(data: Uint8Array): AutoSizeRequest {
    return AutoSizeRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AutoSizeRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AutoSizeRequest.fields);
  }
}
registerMessage(AutoSizeRequest);
export class AutoSizeResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.AutoSizeResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<AutoSizeResponse>) {
    initMessage(this, AutoSizeResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): AutoSizeResponse {
    return decodeMessage(AutoSizeResponse, data);
  }

  static parseFrom(data: Uint8Array): AutoSizeResponse {
    return AutoSizeResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, AutoSizeResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, AutoSizeResponse.fields);
  }
}
registerMessage(AutoSizeResponse);
export class BarcodeCaptionOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BarcodeCaptionOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "position",
      jsonName: "position",
      prop: "position",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: BarcodeCaptionPosition,
    },
    {
      no: 2,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "font_size",
      jsonName: "fontSize",
      prop: "fontSize",
      kind: "float" as ProtoKind,
      optional: true,
    },
  ];
  position: BarcodeCaptionPosition = 0;
  text: string = "";
  color: number = 0;
  fontSize: number = 0;

  constructor(init?: Partial<BarcodeCaptionOptions>) {
    initMessage(this, BarcodeCaptionOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BarcodeCaptionOptions {
    return decodeMessage(BarcodeCaptionOptions, data);
  }

  static parseFrom(data: Uint8Array): BarcodeCaptionOptions {
    return BarcodeCaptionOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BarcodeCaptionOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BarcodeCaptionOptions.fields);
  }
}
registerMessage(BarcodeCaptionOptions);
export class BarcodeData implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BarcodeData" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "symbology",
      jsonName: "symbology",
      prop: "symbology",
      kind: "enum" as ProtoKind,
      enumType: BarcodeSymbology,
    },
    {
      no: 2,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "encoding",
      jsonName: "encoding",
      prop: "encoding",
      kind: "message" as ProtoKind,
      messageType: "BarcodeEncodingOptions",
    },
    {
      no: 4,
      name: "render",
      jsonName: "render",
      prop: "render",
      kind: "message" as ProtoKind,
      messageType: "BarcodeRenderOptions",
    },
    {
      no: 5,
      name: "caption",
      jsonName: "caption",
      prop: "caption",
      kind: "message" as ProtoKind,
      messageType: "BarcodeCaptionOptions",
    },
  ];
  symbology: BarcodeSymbology = 0;
  value: string = "";
  encoding?: BarcodeEncodingOptions;
  render?: BarcodeRenderOptions;
  caption?: BarcodeCaptionOptions;

  constructor(init?: Partial<BarcodeData>) {
    initMessage(this, BarcodeData.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BarcodeData {
    return decodeMessage(BarcodeData, data);
  }

  static parseFrom(data: Uint8Array): BarcodeData {
    return BarcodeData.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BarcodeData.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BarcodeData.fields);
  }
}
registerMessage(BarcodeData);
export class BarcodeEncodingOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BarcodeEncodingOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "check_digit",
      jsonName: "checkDigit",
      prop: "checkDigit",
      kind: "enum" as ProtoKind,
      enumType: BarcodeCheckDigitMode,
    },
    {
      no: 2,
      name: "text_encoding",
      jsonName: "textEncoding",
      prop: "textEncoding",
      kind: "enum" as ProtoKind,
      enumType: BarcodeTextEncoding,
    },
    {
      no: 3,
      name: "qr_ecc",
      jsonName: "qrEcc",
      prop: "qrEcc",
      kind: "enum" as ProtoKind,
      enumType: BarcodeQrErrorCorrection,
    },
  ];
  checkDigit: BarcodeCheckDigitMode = 0;
  textEncoding: BarcodeTextEncoding = 0;
  qrEcc: BarcodeQrErrorCorrection = 0;

  constructor(init?: Partial<BarcodeEncodingOptions>) {
    initMessage(this, BarcodeEncodingOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BarcodeEncodingOptions {
    return decodeMessage(BarcodeEncodingOptions, data);
  }

  static parseFrom(data: Uint8Array): BarcodeEncodingOptions {
    return BarcodeEncodingOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BarcodeEncodingOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BarcodeEncodingOptions.fields);
  }
}
registerMessage(BarcodeEncodingOptions);
export class BarcodeRenderOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BarcodeRenderOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "alignment",
      jsonName: "alignment",
      prop: "alignment",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ImageAlignment,
    },
    {
      no: 4,
      name: "module_size",
      jsonName: "moduleSize",
      prop: "moduleSize",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 5,
      name: "quiet_zone",
      jsonName: "quietZone",
      prop: "quietZone",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 10,
      name: "bar_height",
      jsonName: "barHeight",
      prop: "barHeight",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 11,
      name: "narrow_bar_width",
      jsonName: "narrowBarWidth",
      prop: "narrowBarWidth",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 12,
      name: "show_size_warning",
      jsonName: "showSizeWarning",
      prop: "showSizeWarning",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 13,
      name: "size_warning_color",
      jsonName: "sizeWarningColor",
      prop: "sizeWarningColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 14,
      name: "use_full_rect",
      jsonName: "useFullRect",
      prop: "useFullRect",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  foreground: number = 0;
  background: number = 0;
  alignment: ImageAlignment = 0;
  moduleSize: number = 0;
  quietZone: number = 0;
  barHeight: number = 0;
  narrowBarWidth: number = 0;
  showSizeWarning: boolean = false;
  sizeWarningColor: number = 0;
  useFullRect: boolean = false;

  constructor(init?: Partial<BarcodeRenderOptions>) {
    initMessage(this, BarcodeRenderOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BarcodeRenderOptions {
    return decodeMessage(BarcodeRenderOptions, data);
  }

  static parseFrom(data: Uint8Array): BarcodeRenderOptions {
    return BarcodeRenderOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BarcodeRenderOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BarcodeRenderOptions.fields);
  }
}
registerMessage(BarcodeRenderOptions);
export class BeforeEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<BeforeEditEvent>) {
    initMessage(this, BeforeEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeEditEvent {
    return decodeMessage(BeforeEditEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeEditEvent {
    return BeforeEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeEditEvent.fields);
  }
}
registerMessage(BeforeEditEvent);
export class BeforeMouseDownEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeMouseDownEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  row: number = 0;
  col: number = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<BeforeMouseDownEvent>) {
    initMessage(this, BeforeMouseDownEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeMouseDownEvent {
    return decodeMessage(BeforeMouseDownEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeMouseDownEvent {
    return BeforeMouseDownEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeMouseDownEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeMouseDownEvent.fields);
  }
}
registerMessage(BeforeMouseDownEvent);
export class BeforeMoveColumnEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeMoveColumnEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "new_position",
      jsonName: "newPosition",
      prop: "newPosition",
      kind: "int32" as ProtoKind,
    },
  ];
  col: number = 0;
  newPosition: number = 0;

  constructor(init?: Partial<BeforeMoveColumnEvent>) {
    initMessage(this, BeforeMoveColumnEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeMoveColumnEvent {
    return decodeMessage(BeforeMoveColumnEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeMoveColumnEvent {
    return BeforeMoveColumnEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeMoveColumnEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeMoveColumnEvent.fields);
  }
}
registerMessage(BeforeMoveColumnEvent);
export class BeforeMoveRowEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeMoveRowEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "new_position",
      jsonName: "newPosition",
      prop: "newPosition",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  newPosition: number = 0;

  constructor(init?: Partial<BeforeMoveRowEvent>) {
    initMessage(this, BeforeMoveRowEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeMoveRowEvent {
    return decodeMessage(BeforeMoveRowEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeMoveRowEvent {
    return BeforeMoveRowEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeMoveRowEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeMoveRowEvent.fields);
  }
}
registerMessage(BeforeMoveRowEvent);
export class BeforeNodeToggleEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeNodeToggleEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "collapse",
      jsonName: "collapse",
      prop: "collapse",
      kind: "bool" as ProtoKind,
    },
  ];
  row: number = 0;
  collapse: boolean = false;

  constructor(init?: Partial<BeforeNodeToggleEvent>) {
    initMessage(this, BeforeNodeToggleEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeNodeToggleEvent {
    return decodeMessage(BeforeNodeToggleEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeNodeToggleEvent {
    return BeforeNodeToggleEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeNodeToggleEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeNodeToggleEvent.fields);
  }
}
registerMessage(BeforeNodeToggleEvent);
export class BeforePageBreakEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforePageBreakEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;

  constructor(init?: Partial<BeforePageBreakEvent>) {
    initMessage(this, BeforePageBreakEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforePageBreakEvent {
    return decodeMessage(BeforePageBreakEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforePageBreakEvent {
    return BeforePageBreakEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforePageBreakEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforePageBreakEvent.fields);
  }
}
registerMessage(BeforePageBreakEvent);
export class BeforeScrollEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeScrollEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_top_row",
      jsonName: "oldTopRow",
      prop: "oldTopRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_left_col",
      jsonName: "oldLeftCol",
      prop: "oldLeftCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "new_top_row",
      jsonName: "newTopRow",
      prop: "newTopRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "new_left_col",
      jsonName: "newLeftCol",
      prop: "newLeftCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldTopRow: number = 0;
  oldLeftCol: number = 0;
  newTopRow: number = 0;
  newLeftCol: number = 0;

  constructor(init?: Partial<BeforeScrollEvent>) {
    initMessage(this, BeforeScrollEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeScrollEvent {
    return decodeMessage(BeforeScrollEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeScrollEvent {
    return BeforeScrollEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeScrollEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeScrollEvent.fields);
  }
}
registerMessage(BeforeScrollEvent);
export class BeforeSortEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeSortEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  col: number = 0;

  constructor(init?: Partial<BeforeSortEvent>) {
    initMessage(this, BeforeSortEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeSortEvent {
    return decodeMessage(BeforeSortEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeSortEvent {
    return BeforeSortEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeSortEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeSortEvent.fields);
  }
}
registerMessage(BeforeSortEvent);
export class BeforeTreeNodeToggleEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeTreeNodeToggleEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "node_id",
      jsonName: "nodeId",
      prop: "nodeId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "collapse",
      jsonName: "collapse",
      prop: "collapse",
      kind: "bool" as ProtoKind,
    },
  ];
  nodeId: string = "";
  row: number = 0;
  collapse: boolean = false;

  constructor(init?: Partial<BeforeTreeNodeToggleEvent>) {
    initMessage(this, BeforeTreeNodeToggleEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeTreeNodeToggleEvent {
    return decodeMessage(BeforeTreeNodeToggleEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeTreeNodeToggleEvent {
    return BeforeTreeNodeToggleEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeTreeNodeToggleEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeTreeNodeToggleEvent.fields);
  }
}
registerMessage(BeforeTreeNodeToggleEvent);
export class BeforeUserResizeEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BeforeUserResizeEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<BeforeUserResizeEvent>) {
    initMessage(this, BeforeUserResizeEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BeforeUserResizeEvent {
    return decodeMessage(BeforeUserResizeEvent, data);
  }

  static parseFrom(data: Uint8Array): BeforeUserResizeEvent {
    return BeforeUserResizeEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BeforeUserResizeEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BeforeUserResizeEvent.fields);
  }
}
registerMessage(BeforeUserResizeEvent);
export class Border implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Border" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: BorderStyle,
    },
    {
      no: 2,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  style: BorderStyle = 0;
  color: number = 0;

  constructor(init?: Partial<Border>) {
    initMessage(this, Border.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Border {
    return decodeMessage(Border, data);
  }

  static parseFrom(data: Uint8Array): Border {
    return Border.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Border.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Border.fields);
  }
}
registerMessage(Border);
export class Borders implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Borders" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "all",
      jsonName: "all",
      prop: "all",
      kind: "message" as ProtoKind,
      messageType: "Border",
    },
    {
      no: 2,
      name: "top",
      jsonName: "top",
      prop: "top",
      kind: "message" as ProtoKind,
      messageType: "Border",
    },
    {
      no: 3,
      name: "right",
      jsonName: "right",
      prop: "right",
      kind: "message" as ProtoKind,
      messageType: "Border",
    },
    {
      no: 4,
      name: "bottom",
      jsonName: "bottom",
      prop: "bottom",
      kind: "message" as ProtoKind,
      messageType: "Border",
    },
    {
      no: 5,
      name: "left",
      jsonName: "left",
      prop: "left",
      kind: "message" as ProtoKind,
      messageType: "Border",
    },
  ];
  all?: Border;
  top?: Border;
  right?: Border;
  bottom?: Border;
  left?: Border;

  constructor(init?: Partial<Borders>) {
    initMessage(this, Borders.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Borders {
    return decodeMessage(Borders, data);
  }

  static parseFrom(data: Uint8Array): Borders {
    return Borders.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Borders.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Borders.fields);
  }
}
registerMessage(Borders);
export class BufferReady implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.BufferReady" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "handle",
      jsonName: "handle",
      prop: "handle",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "stride",
      jsonName: "stride",
      prop: "stride",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "capacity",
      jsonName: "capacity",
      prop: "capacity",
      kind: "int32" as ProtoKind,
    },
  ];
  handle: bigint = 0n;
  stride: number = 0;
  width: number = 0;
  height: number = 0;
  capacity: number = 0;

  constructor(init?: Partial<BufferReady>) {
    initMessage(this, BufferReady.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): BufferReady {
    return decodeMessage(BufferReady, data);
  }

  static parseFrom(data: Uint8Array): BufferReady {
    return BufferReady.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, BufferReady.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, BufferReady.fields);
  }
}
registerMessage(BufferReady);
export class CellChangedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellChangedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "old_text",
      jsonName: "oldText",
      prop: "oldText",
      kind: "string" as ProtoKind,
    },
    {
      no: 4,
      name: "new_text",
      jsonName: "newText",
      prop: "newText",
      kind: "string" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  oldText: string = "";
  newText: string = "";

  constructor(init?: Partial<CellChangedEvent>) {
    initMessage(this, CellChangedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellChangedEvent {
    return decodeMessage(CellChangedEvent, data);
  }

  static parseFrom(data: Uint8Array): CellChangedEvent {
    return CellChangedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellChangedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellChangedEvent.fields);
  }
}
registerMessage(CellChangedEvent);
export class CellData implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellData" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "CellValue",
    },
    {
      no: 4,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "CellStyle",
    },
    {
      no: 5,
      name: "checked",
      jsonName: "checked",
      prop: "checked",
      kind: "enum" as ProtoKind,
      enumType: CheckedState,
    },
    {
      no: 6,
      name: "interaction",
      jsonName: "interaction",
      prop: "interaction",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CellInteraction,
    },
    {
      no: 7,
      name: "barcode",
      jsonName: "barcode",
      prop: "barcode",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "BarcodeData",
    },
    {
      no: 8,
      name: "barcode_status",
      jsonName: "barcodeStatus",
      prop: "barcodeStatus",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: BarcodeRenderStatus,
    },
    {
      no: 9,
      name: "rich_text",
      jsonName: "richText",
      prop: "richText",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "RichText",
    },
  ];
  row: number = 0;
  col: number = 0;
  value?: CellValue;
  style?: CellStyle;
  checked: CheckedState = 0;
  interaction: CellInteraction = 0;
  barcode?: BarcodeData;
  barcodeStatus: BarcodeRenderStatus = 0;
  richText?: RichText;

  constructor(init?: Partial<CellData>) {
    initMessage(this, CellData.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellData {
    return decodeMessage(CellData, data);
  }

  static parseFrom(data: Uint8Array): CellData {
    return CellData.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellData.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellData.fields);
  }
}
registerMessage(CellData);
export class CellEditChangeEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellEditChangeEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
  ];
  text: string = "";

  constructor(init?: Partial<CellEditChangeEvent>) {
    initMessage(this, CellEditChangeEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellEditChangeEvent {
    return decodeMessage(CellEditChangeEvent, data);
  }

  static parseFrom(data: Uint8Array): CellEditChangeEvent {
    return CellEditChangeEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellEditChangeEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellEditChangeEvent.fields);
  }
}
registerMessage(CellEditChangeEvent);
export class CellEditValidateEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellEditValidateEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "edit_text",
      jsonName: "editText",
      prop: "editText",
      kind: "string" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  editText: string = "";

  constructor(init?: Partial<CellEditValidateEvent>) {
    initMessage(this, CellEditValidateEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellEditValidateEvent {
    return decodeMessage(CellEditValidateEvent, data);
  }

  static parseFrom(data: Uint8Array): CellEditValidateEvent {
    return CellEditValidateEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellEditValidateEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellEditValidateEvent.fields);
  }
}
registerMessage(CellEditValidateEvent);
export class CellFocusChangedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellFocusChangedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_row",
      jsonName: "oldRow",
      prop: "oldRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_col",
      jsonName: "oldCol",
      prop: "oldCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "new_row",
      jsonName: "newRow",
      prop: "newRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "new_col",
      jsonName: "newCol",
      prop: "newCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldRow: number = 0;
  oldCol: number = 0;
  newRow: number = 0;
  newCol: number = 0;

  constructor(init?: Partial<CellFocusChangedEvent>) {
    initMessage(this, CellFocusChangedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellFocusChangedEvent {
    return decodeMessage(CellFocusChangedEvent, data);
  }

  static parseFrom(data: Uint8Array): CellFocusChangedEvent {
    return CellFocusChangedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellFocusChangedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellFocusChangedEvent.fields);
  }
}
registerMessage(CellFocusChangedEvent);
export class CellFocusChangingEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellFocusChangingEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_row",
      jsonName: "oldRow",
      prop: "oldRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "old_col",
      jsonName: "oldCol",
      prop: "oldCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "new_row",
      jsonName: "newRow",
      prop: "newRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "new_col",
      jsonName: "newCol",
      prop: "newCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldRow: number = 0;
  oldCol: number = 0;
  newRow: number = 0;
  newCol: number = 0;

  constructor(init?: Partial<CellFocusChangingEvent>) {
    initMessage(this, CellFocusChangingEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellFocusChangingEvent {
    return decodeMessage(CellFocusChangingEvent, data);
  }

  static parseFrom(data: Uint8Array): CellFocusChangingEvent {
    return CellFocusChangingEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellFocusChangingEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellFocusChangingEvent.fields);
  }
}
registerMessage(CellFocusChangingEvent);
export class CellRange implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellRange" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row1",
      jsonName: "row1",
      prop: "row1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col1",
      jsonName: "col1",
      prop: "col1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "row2",
      jsonName: "row2",
      prop: "row2",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "col2",
      jsonName: "col2",
      prop: "col2",
      kind: "int32" as ProtoKind,
    },
  ];
  row1: number = 0;
  col1: number = 0;
  row2: number = 0;
  col2: number = 0;

  constructor(init?: Partial<CellRange>) {
    initMessage(this, CellRange.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellRange {
    return decodeMessage(CellRange, data);
  }

  static parseFrom(data: Uint8Array): CellRange {
    return CellRange.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellRange.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellRange.fields);
  }
}
registerMessage(CellRange);
export class CellStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "align",
      jsonName: "align",
      prop: "align",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: Align,
    },
    {
      no: 4,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
    {
      no: 5,
      name: "padding",
      jsonName: "padding",
      prop: "padding",
      kind: "message" as ProtoKind,
      messageType: "Padding",
    },
    {
      no: 6,
      name: "borders",
      jsonName: "borders",
      prop: "borders",
      kind: "message" as ProtoKind,
      messageType: "Borders",
    },
    {
      no: 7,
      name: "text_effect",
      jsonName: "textEffect",
      prop: "textEffect",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextEffect,
    },
    {
      no: 8,
      name: "progress",
      jsonName: "progress",
      prop: "progress",
      kind: "float" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "progress_color",
      jsonName: "progressColor",
      prop: "progressColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "shrink_to_fit",
      jsonName: "shrinkToFit",
      prop: "shrinkToFit",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  background: number = 0;
  foreground: number = 0;
  align: Align = 0;
  font?: Font;
  padding?: Padding;
  borders?: Borders;
  textEffect: TextEffect = 0;
  progress: number = 0;
  progressColor: number = 0;
  shrinkToFit: boolean = false;

  constructor(init?: Partial<CellStyle>) {
    initMessage(this, CellStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellStyle {
    return decodeMessage(CellStyle, data);
  }

  static parseFrom(data: Uint8Array): CellStyle {
    return CellStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellStyle.fields);
  }
}
registerMessage(CellStyle);
export class CellUpdate implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellUpdate" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "CellValue",
    },
    {
      no: 4,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "CellStyle",
    },
    {
      no: 5,
      name: "checked",
      jsonName: "checked",
      prop: "checked",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CheckedState,
    },
    {
      no: 6,
      name: "picture",
      jsonName: "picture",
      prop: "picture",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 7,
      name: "picture_align",
      jsonName: "pictureAlign",
      prop: "pictureAlign",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ImageAlignment,
    },
    {
      no: 8,
      name: "button_picture",
      jsonName: "buttonPicture",
      prop: "buttonPicture",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 9,
      name: "editor",
      jsonName: "editor",
      prop: "editor",
      kind: "message" as ProtoKind,
      messageType: "EditorSpec",
    },
    {
      no: 10,
      name: "sticky_row",
      jsonName: "stickyRow",
      prop: "stickyRow",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: StickyEdge,
    },
    {
      no: 11,
      name: "sticky_col",
      jsonName: "stickyCol",
      prop: "stickyCol",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: StickyEdge,
    },
    {
      no: 12,
      name: "interaction",
      jsonName: "interaction",
      prop: "interaction",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CellInteraction,
    },
    {
      no: 13,
      name: "barcode",
      jsonName: "barcode",
      prop: "barcode",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "BarcodeData",
    },
    {
      no: 14,
      name: "rich_text",
      jsonName: "richText",
      prop: "richText",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "RichText",
    },
  ];
  row: number = 0;
  col: number = 0;
  value?: CellValue;
  style?: CellStyle;
  checked: CheckedState = 0;
  picture?: ImageData;
  pictureAlign: ImageAlignment = 0;
  buttonPicture?: ImageData;
  editor?: EditorSpec;
  stickyRow: StickyEdge = 0;
  stickyCol: StickyEdge = 0;
  interaction: CellInteraction = 0;
  barcode?: BarcodeData;
  richText?: RichText;

  constructor(init?: Partial<CellUpdate>) {
    initMessage(this, CellUpdate.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellUpdate {
    return decodeMessage(CellUpdate, data);
  }

  static parseFrom(data: Uint8Array): CellUpdate {
    return CellUpdate.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellUpdate.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellUpdate.fields);
  }
}
registerMessage(CellUpdate);
export enum CellValueValueOneofCase {
  None = 0,
  Text = 1,
  Number = 2,
  Flag = 3,
  Raw = 4,
  Timestamp = 5,
}
export class CellValue implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellValue" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
      oneof: "valueCase",
      oneofCase: CellValueValueOneofCase.Text,
    },
    {
      no: 2,
      name: "number",
      jsonName: "number",
      prop: "number",
      kind: "double" as ProtoKind,
      oneof: "valueCase",
      oneofCase: CellValueValueOneofCase.Number,
    },
    {
      no: 3,
      name: "flag",
      jsonName: "flag",
      prop: "flag",
      kind: "bool" as ProtoKind,
      oneof: "valueCase",
      oneofCase: CellValueValueOneofCase.Flag,
    },
    {
      no: 4,
      name: "raw",
      jsonName: "raw",
      prop: "raw",
      kind: "bytes" as ProtoKind,
      oneof: "valueCase",
      oneofCase: CellValueValueOneofCase.Raw,
    },
    {
      no: 5,
      name: "timestamp",
      jsonName: "timestamp",
      prop: "timestamp",
      kind: "int64" as ProtoKind,
      oneof: "valueCase",
      oneofCase: CellValueValueOneofCase.Timestamp,
    },
  ];
  valueCase: CellValueValueOneofCase = CellValueValueOneofCase.None;
  text?: string;
  number?: number;
  flag?: boolean;
  raw?: Uint8Array;
  timestamp?: bigint;

  constructor(init?: Partial<CellValue>) {
    initMessage(this, CellValue.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellValue {
    return decodeMessage(CellValue, data);
  }

  static parseFrom(data: Uint8Array): CellValue {
    return CellValue.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellValue.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellValue.fields);
  }
}
registerMessage(CellValue);
export class CellsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CellsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "cells",
      jsonName: "cells",
      prop: "cells",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellData",
    },
  ];
  cells: CellData[] = [];

  constructor(init?: Partial<CellsResponse>) {
    initMessage(this, CellsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CellsResponse {
    return decodeMessage(CellsResponse, data);
  }

  static parseFrom(data: Uint8Array): CellsResponse {
    return CellsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CellsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CellsResponse.fields);
  }
}
registerMessage(CellsResponse);
export class CheckboxEditorParams implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CheckboxEditorParams" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "three_state",
      jsonName: "threeState",
      prop: "threeState",
      kind: "bool" as ProtoKind,
    },
  ];
  threeState: boolean = false;

  constructor(init?: Partial<CheckboxEditorParams>) {
    initMessage(this, CheckboxEditorParams.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CheckboxEditorParams {
    return decodeMessage(CheckboxEditorParams, data);
  }

  static parseFrom(data: Uint8Array): CheckboxEditorParams {
    return CheckboxEditorParams.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CheckboxEditorParams.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CheckboxEditorParams.fields);
  }
}
registerMessage(CheckboxEditorParams);
export class ClearRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClearRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "scope",
      jsonName: "scope",
      prop: "scope",
      kind: "enum" as ProtoKind,
      enumType: ClearScope,
    },
    {
      no: 3,
      name: "region",
      jsonName: "region",
      prop: "region",
      kind: "enum" as ProtoKind,
      enumType: ClearRegion,
    },
  ];
  gridId: bigint = 0n;
  scope: ClearScope = 0;
  region: ClearRegion = 0;

  constructor(init?: Partial<ClearRequest>) {
    initMessage(this, ClearRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClearRequest {
    return decodeMessage(ClearRequest, data);
  }

  static parseFrom(data: Uint8Array): ClearRequest {
    return ClearRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClearRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClearRequest.fields);
  }
}
registerMessage(ClearRequest);
export class ClearResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClearResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "cleared_count",
      jsonName: "clearedCount",
      prop: "clearedCount",
      kind: "int32" as ProtoKind,
    },
  ];
  clearedCount: number = 0;

  constructor(init?: Partial<ClearResponse>) {
    initMessage(this, ClearResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClearResponse {
    return decodeMessage(ClearResponse, data);
  }

  static parseFrom(data: Uint8Array): ClearResponse {
    return ClearResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClearResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClearResponse.fields);
  }
}
registerMessage(ClearResponse);
export class ClickEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClickEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "hit_area",
      jsonName: "hitArea",
      prop: "hitArea",
      kind: "enum" as ProtoKind,
      enumType: CellHitArea,
    },
    {
      no: 4,
      name: "interaction",
      jsonName: "interaction",
      prop: "interaction",
      kind: "enum" as ProtoKind,
      enumType: CellInteraction,
    },
    {
      no: 5,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  row: number = 0;
  col: number = 0;
  hitArea: CellHitArea = 0;
  interaction: CellInteraction = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<ClickEvent>) {
    initMessage(this, ClickEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClickEvent {
    return decodeMessage(ClickEvent, data);
  }

  static parseFrom(data: Uint8Array): ClickEvent {
    return ClickEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClickEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClickEvent.fields);
  }
}
registerMessage(ClickEvent);
export enum ClipboardCommandCommandOneofCase {
  None = 0,
  Copy = 2,
  Cut = 3,
  Paste = 4,
  Delete = 5,
}
export class ClipboardCommand implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardCommand" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "copy",
      jsonName: "copy",
      prop: "copy",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: ClipboardCommandCommandOneofCase.Copy,
      messageType: "ClipboardCopy",
    },
    {
      no: 3,
      name: "cut",
      jsonName: "cut",
      prop: "cut",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: ClipboardCommandCommandOneofCase.Cut,
      messageType: "ClipboardCut",
    },
    {
      no: 4,
      name: "paste",
      jsonName: "paste",
      prop: "paste",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: ClipboardCommandCommandOneofCase.Paste,
      messageType: "ClipboardPaste",
    },
    {
      no: 5,
      name: "delete",
      jsonName: "delete",
      prop: "delete",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: ClipboardCommandCommandOneofCase.Delete,
      messageType: "ClipboardDelete",
    },
  ];
  commandCase: ClipboardCommandCommandOneofCase = ClipboardCommandCommandOneofCase.None;
  gridId: bigint = 0n;
  copy?: ClipboardCopy;
  cut?: ClipboardCut;
  paste?: ClipboardPaste;
  delete?: ClipboardDelete;

  constructor(init?: Partial<ClipboardCommand>) {
    initMessage(this, ClipboardCommand.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardCommand {
    return decodeMessage(ClipboardCommand, data);
  }

  static parseFrom(data: Uint8Array): ClipboardCommand {
    return ClipboardCommand.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardCommand.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardCommand.fields);
  }
}
registerMessage(ClipboardCommand);
export class ClipboardCopy implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardCopy" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<ClipboardCopy>) {
    initMessage(this, ClipboardCopy.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardCopy {
    return decodeMessage(ClipboardCopy, data);
  }

  static parseFrom(data: Uint8Array): ClipboardCopy {
    return ClipboardCopy.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardCopy.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardCopy.fields);
  }
}
registerMessage(ClipboardCopy);
export class ClipboardCut implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardCut" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<ClipboardCut>) {
    initMessage(this, ClipboardCut.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardCut {
    return decodeMessage(ClipboardCut, data);
  }

  static parseFrom(data: Uint8Array): ClipboardCut {
    return ClipboardCut.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardCut.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardCut.fields);
  }
}
registerMessage(ClipboardCut);
export class ClipboardDelete implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardDelete" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<ClipboardDelete>) {
    initMessage(this, ClipboardDelete.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardDelete {
    return decodeMessage(ClipboardDelete, data);
  }

  static parseFrom(data: Uint8Array): ClipboardDelete {
    return ClipboardDelete.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardDelete.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardDelete.fields);
  }
}
registerMessage(ClipboardDelete);
export class ClipboardPaste implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardPaste" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "rich_data",
      jsonName: "richData",
      prop: "richData",
      kind: "bytes" as ProtoKind,
    },
  ];
  text: string = "";
  richData?: Uint8Array;

  constructor(init?: Partial<ClipboardPaste>) {
    initMessage(this, ClipboardPaste.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardPaste {
    return decodeMessage(ClipboardPaste, data);
  }

  static parseFrom(data: Uint8Array): ClipboardPaste {
    return ClipboardPaste.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardPaste.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardPaste.fields);
  }
}
registerMessage(ClipboardPaste);
export class ClipboardResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ClipboardResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "rich_data",
      jsonName: "richData",
      prop: "richData",
      kind: "bytes" as ProtoKind,
    },
  ];
  text: string = "";
  richData?: Uint8Array;

  constructor(init?: Partial<ClipboardResponse>) {
    initMessage(this, ClipboardResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ClipboardResponse {
    return decodeMessage(ClipboardResponse, data);
  }

  static parseFrom(data: Uint8Array): ClipboardResponse {
    return ClipboardResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ClipboardResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ClipboardResponse.fields);
  }
}
registerMessage(ClipboardResponse);
export class ColIndicatorCell implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ColIndicatorCell" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row1",
      jsonName: "row1",
      prop: "row1",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "row2",
      jsonName: "row2",
      prop: "row2",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "col1",
      jsonName: "col1",
      prop: "col1",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "col2",
      jsonName: "col2",
      prop: "col2",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "custom_key",
      jsonName: "customKey",
      prop: "customKey",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "modes",
      jsonName: "modes",
      prop: "modes",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "ColIndicatorCellModes",
    },
  ];
  row1: number = 0;
  row2: number = 0;
  col1: number = 0;
  col2: number = 0;
  text: string = "";
  customKey: string = "";
  data?: Uint8Array;
  modes?: ColIndicatorCellModes;

  constructor(init?: Partial<ColIndicatorCell>) {
    initMessage(this, ColIndicatorCell.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ColIndicatorCell {
    return decodeMessage(ColIndicatorCell, data);
  }

  static parseFrom(data: Uint8Array): ColIndicatorCell {
    return ColIndicatorCell.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ColIndicatorCell.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ColIndicatorCell.fields);
  }
}
registerMessage(ColIndicatorCell);
export class ColIndicatorCellModes implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ColIndicatorCellModes" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "modes",
      jsonName: "modes",
      prop: "modes",
      kind: "enum" as ProtoKind,
      repeated: true,
      enumType: ColIndicatorCellMode,
    },
  ];
  modes: ColIndicatorCellMode[] = [];

  constructor(init?: Partial<ColIndicatorCellModes>) {
    initMessage(this, ColIndicatorCellModes.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ColIndicatorCellModes {
    return decodeMessage(ColIndicatorCellModes, data);
  }

  static parseFrom(data: Uint8Array): ColIndicatorCellModes {
    return ColIndicatorCellModes.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ColIndicatorCellModes.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ColIndicatorCellModes.fields);
  }
}
registerMessage(ColIndicatorCellModes);
export class ColIndicatorConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ColIndicatorConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "default_row_height",
      jsonName: "defaultRowHeight",
      prop: "defaultRowHeight",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "band_rows",
      jsonName: "bandRows",
      prop: "bandRows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "grid_lines",
      jsonName: "gridLines",
      prop: "gridLines",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: GridLineStyle,
    },
    {
      no: 7,
      name: "grid_color",
      jsonName: "gridColor",
      prop: "gridColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "auto_size",
      jsonName: "autoSize",
      prop: "autoSize",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "allow_resize",
      jsonName: "allowResize",
      prop: "allowResize",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "allow_reorder",
      jsonName: "allowReorder",
      prop: "allowReorder",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "allow_menu",
      jsonName: "allowMenu",
      prop: "allowMenu",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 12,
      name: "row_defs",
      jsonName: "rowDefs",
      prop: "rowDefs",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ColIndicatorRowDef",
    },
    {
      no: 13,
      name: "cells",
      jsonName: "cells",
      prop: "cells",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ColIndicatorCell",
    },
    {
      no: 14,
      name: "cell_modes",
      jsonName: "cellModes",
      prop: "cellModes",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "ColIndicatorCellModes",
    },
  ];
  visible: boolean = false;
  defaultRowHeight: number = 0;
  bandRows: number = 0;
  background: number = 0;
  foreground: number = 0;
  gridLines: GridLineStyle = 0;
  gridColor: number = 0;
  autoSize: boolean = false;
  allowResize: boolean = false;
  allowReorder: boolean = false;
  allowMenu: boolean = false;
  rowDefs: ColIndicatorRowDef[] = [];
  cells: ColIndicatorCell[] = [];
  cellModes?: ColIndicatorCellModes;

  constructor(init?: Partial<ColIndicatorConfig>) {
    initMessage(this, ColIndicatorConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ColIndicatorConfig {
    return decodeMessage(ColIndicatorConfig, data);
  }

  static parseFrom(data: Uint8Array): ColIndicatorConfig {
    return ColIndicatorConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ColIndicatorConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ColIndicatorConfig.fields);
  }
}
registerMessage(ColIndicatorConfig);
export class ColIndicatorRowDef implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ColIndicatorRowDef" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "index",
      jsonName: "index",
      prop: "index",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  index: number = 0;
  height: number = 0;

  constructor(init?: Partial<ColIndicatorRowDef>) {
    initMessage(this, ColIndicatorRowDef.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ColIndicatorRowDef {
    return decodeMessage(ColIndicatorRowDef, data);
  }

  static parseFrom(data: Uint8Array): ColIndicatorRowDef {
    return ColIndicatorRowDef.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ColIndicatorRowDef.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ColIndicatorRowDef.fields);
  }
}
registerMessage(ColIndicatorRowDef);
export class ColumnDef implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ColumnDef" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "index",
      jsonName: "index",
      prop: "index",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "min_width",
      jsonName: "minWidth",
      prop: "minWidth",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "max_width",
      jsonName: "maxWidth",
      prop: "maxWidth",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "caption",
      jsonName: "caption",
      prop: "caption",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "align",
      jsonName: "align",
      prop: "align",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: Align,
    },
    {
      no: 7,
      name: "fixed_align",
      jsonName: "fixedAlign",
      prop: "fixedAlign",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: Align,
    },
    {
      no: 8,
      name: "data_type",
      jsonName: "dataType",
      prop: "dataType",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ColumnDataType,
    },
    {
      no: 9,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "key",
      jsonName: "key",
      prop: "key",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "sort_order",
      jsonName: "sortOrder",
      prop: "sortOrder",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SortOrder,
    },
    {
      no: 12,
      name: "sort_type",
      jsonName: "sortType",
      prop: "sortType",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SortType,
    },
    {
      no: 13,
      name: "editor",
      jsonName: "editor",
      prop: "editor",
      kind: "message" as ProtoKind,
      messageType: "EditorSpec",
    },
    {
      no: 14,
      name: "indent",
      jsonName: "indent",
      prop: "indent",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 15,
      name: "hidden",
      jsonName: "hidden",
      prop: "hidden",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 16,
      name: "span",
      jsonName: "span",
      prop: "span",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 17,
      name: "image_list",
      jsonName: "imageList",
      prop: "imageList",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ImageData",
    },
    {
      no: 18,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 19,
      name: "sticky",
      jsonName: "sticky",
      prop: "sticky",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: StickyEdge,
    },
    {
      no: 20,
      name: "padding",
      jsonName: "padding",
      prop: "padding",
      kind: "message" as ProtoKind,
      messageType: "Padding",
    },
    {
      no: 21,
      name: "fixed_padding",
      jsonName: "fixedPadding",
      prop: "fixedPadding",
      kind: "message" as ProtoKind,
      messageType: "Padding",
    },
    {
      no: 22,
      name: "nullable",
      jsonName: "nullable",
      prop: "nullable",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 23,
      name: "coercion_mode",
      jsonName: "coercionMode",
      prop: "coercionMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CoercionMode,
    },
    {
      no: 24,
      name: "error_mode",
      jsonName: "errorMode",
      prop: "errorMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: WriteErrorMode,
    },
    {
      no: 25,
      name: "interaction",
      jsonName: "interaction",
      prop: "interaction",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CellInteraction,
    },
    {
      no: 26,
      name: "progress_color",
      jsonName: "progressColor",
      prop: "progressColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  index: number = 0;
  width: number = 0;
  minWidth: number = 0;
  maxWidth: number = 0;
  caption: string = "";
  align: Align = 0;
  fixedAlign: Align = 0;
  dataType: ColumnDataType = 0;
  format: string = "";
  key: string = "";
  sortOrder: SortOrder = 0;
  sortType: SortType = 0;
  editor?: EditorSpec;
  indent: number = 0;
  hidden: boolean = false;
  span: boolean = false;
  imageList: ImageData[] = [];
  data?: Uint8Array;
  sticky: StickyEdge = 0;
  padding?: Padding;
  fixedPadding?: Padding;
  nullable: boolean = false;
  coercionMode: CoercionMode = 0;
  errorMode: WriteErrorMode = 0;
  interaction: CellInteraction = 0;
  progressColor: number = 0;

  constructor(init?: Partial<ColumnDef>) {
    initMessage(this, ColumnDef.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ColumnDef {
    return decodeMessage(ColumnDef, data);
  }

  static parseFrom(data: Uint8Array): ColumnDef {
    return ColumnDef.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ColumnDef.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ColumnDef.fields);
  }
}
registerMessage(ColumnDef);
export class CompareEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CompareEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row1",
      jsonName: "row1",
      prop: "row1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "row2",
      jsonName: "row2",
      prop: "row2",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  requestId: bigint = 0n;
  row1: number = 0;
  row2: number = 0;
  col: number = 0;

  constructor(init?: Partial<CompareEvent>) {
    initMessage(this, CompareEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CompareEvent {
    return decodeMessage(CompareEvent, data);
  }

  static parseFrom(data: Uint8Array): CompareEvent {
    return CompareEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CompareEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CompareEvent.fields);
  }
}
registerMessage(CompareEvent);
export class CompareResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CompareResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "result",
      jsonName: "result",
      prop: "result",
      kind: "int32" as ProtoKind,
    },
  ];
  requestId: bigint = 0n;
  result: number = 0;

  constructor(init?: Partial<CompareResponse>) {
    initMessage(this, CompareResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CompareResponse {
    return decodeMessage(CompareResponse, data);
  }

  static parseFrom(data: Uint8Array): CompareResponse {
    return CompareResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CompareResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CompareResponse.fields);
  }
}
registerMessage(CompareResponse);
export class ConfigureRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ConfigureRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "config",
      jsonName: "config",
      prop: "config",
      kind: "message" as ProtoKind,
      messageType: "GridConfig",
    },
  ];
  gridId: bigint = 0n;
  config?: GridConfig;

  constructor(init?: Partial<ConfigureRequest>) {
    initMessage(this, ConfigureRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ConfigureRequest {
    return decodeMessage(ConfigureRequest, data);
  }

  static parseFrom(data: Uint8Array): ConfigureRequest {
    return ConfigureRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ConfigureRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ConfigureRequest.fields);
  }
}
registerMessage(ConfigureRequest);
export class ConfigureResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ConfigureResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<ConfigureResponse>) {
    initMessage(this, ConfigureResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ConfigureResponse {
    return decodeMessage(ConfigureResponse, data);
  }

  static parseFrom(data: Uint8Array): ConfigureResponse {
    return ConfigureResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ConfigureResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ConfigureResponse.fields);
  }
}
registerMessage(ConfigureResponse);
export class CornerIndicatorConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CornerIndicatorConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "custom_key",
      jsonName: "customKey",
      prop: "customKey",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "slots",
      jsonName: "slots",
      prop: "slots",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CornerIndicatorSlot",
    },
  ];
  visible: boolean = false;
  background: number = 0;
  foreground: number = 0;
  customKey: string = "";
  data?: Uint8Array;
  slots: CornerIndicatorSlot[] = [];

  constructor(init?: Partial<CornerIndicatorConfig>) {
    initMessage(this, CornerIndicatorConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CornerIndicatorConfig {
    return decodeMessage(CornerIndicatorConfig, data);
  }

  static parseFrom(data: Uint8Array): CornerIndicatorConfig {
    return CornerIndicatorConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CornerIndicatorConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CornerIndicatorConfig.fields);
  }
}
registerMessage(CornerIndicatorConfig);
export class CornerIndicatorSlot implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CornerIndicatorSlot" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "kind",
      jsonName: "kind",
      prop: "kind",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CornerIndicatorSlotKind,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "custom_key",
      jsonName: "customKey",
      prop: "customKey",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "label_text",
      jsonName: "labelText",
      prop: "labelText",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  kind: CornerIndicatorSlotKind = 0;
  width: number = 0;
  visible: boolean = false;
  customKey: string = "";
  data?: Uint8Array;
  labelText: string = "";

  constructor(init?: Partial<CornerIndicatorSlot>) {
    initMessage(this, CornerIndicatorSlot.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CornerIndicatorSlot {
    return decodeMessage(CornerIndicatorSlot, data);
  }

  static parseFrom(data: Uint8Array): CornerIndicatorSlot {
    return CornerIndicatorSlot.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CornerIndicatorSlot.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CornerIndicatorSlot.fields);
  }
}
registerMessage(CornerIndicatorSlot);
export class CreateRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CreateRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "viewport_width",
      jsonName: "viewportWidth",
      prop: "viewportWidth",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "viewport_height",
      jsonName: "viewportHeight",
      prop: "viewportHeight",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "scale",
      jsonName: "scale",
      prop: "scale",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "config",
      jsonName: "config",
      prop: "config",
      kind: "message" as ProtoKind,
      messageType: "GridConfig",
    },
  ];
  viewportWidth: number = 0;
  viewportHeight: number = 0;
  scale: number = 0;
  config?: GridConfig;

  constructor(init?: Partial<CreateRequest>) {
    initMessage(this, CreateRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CreateRequest {
    return decodeMessage(CreateRequest, data);
  }

  static parseFrom(data: Uint8Array): CreateRequest {
    return CreateRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CreateRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CreateRequest.fields);
  }
}
registerMessage(CreateRequest);
export class CreateResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CreateResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "warnings",
      jsonName: "warnings",
      prop: "warnings",
      kind: "string" as ProtoKind,
      repeated: true,
    },
  ];
  gridId: bigint = 0n;
  warnings: string[] = [];

  constructor(init?: Partial<CreateResponse>) {
    initMessage(this, CreateResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CreateResponse {
    return decodeMessage(CreateResponse, data);
  }

  static parseFrom(data: Uint8Array): CreateResponse {
    return CreateResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CreateResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CreateResponse.fields);
  }
}
registerMessage(CreateResponse);
export class CsvOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CsvOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "delimiter",
      jsonName: "delimiter",
      prop: "delimiter",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "quote_char",
      jsonName: "quoteChar",
      prop: "quoteChar",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "trim_whitespace",
      jsonName: "trimWhitespace",
      prop: "trimWhitespace",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  delimiter: string = "";
  quoteChar: string = "";
  trimWhitespace: boolean = false;

  constructor(init?: Partial<CsvOptions>) {
    initMessage(this, CsvOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CsvOptions {
    return decodeMessage(CsvOptions, data);
  }

  static parseFrom(data: Uint8Array): CsvOptions {
    return CsvOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CsvOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CsvOptions.fields);
  }
}
registerMessage(CsvOptions);
export class CursorChange implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CursorChange" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "cursor",
      jsonName: "cursor",
      prop: "cursor",
      kind: "enum" as ProtoKind,
      enumType: CursorType,
    },
  ];
  cursor: CursorType = 0;

  constructor(init?: Partial<CursorChange>) {
    initMessage(this, CursorChange.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CursorChange {
    return decodeMessage(CursorChange, data);
  }

  static parseFrom(data: Uint8Array): CursorChange {
    return CursorChange.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CursorChange.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CursorChange.fields);
  }
}
registerMessage(CursorChange);
export class CustomEditorAction implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CustomEditorAction" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "action_id",
      jsonName: "actionId",
      prop: "actionId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "payload",
      jsonName: "payload",
      prop: "payload",
      kind: "message" as ProtoKind,
      messageType: "StructValue",
    },
  ];
  actionId: string = "";
  payload?: StructValue;

  constructor(init?: Partial<CustomEditorAction>) {
    initMessage(this, CustomEditorAction.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CustomEditorAction {
    return decodeMessage(CustomEditorAction, data);
  }

  static parseFrom(data: Uint8Array): CustomEditorAction {
    return CustomEditorAction.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CustomEditorAction.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CustomEditorAction.fields);
  }
}
registerMessage(CustomEditorAction);
export class CustomEditorActionEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CustomEditorActionEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "action_id",
      jsonName: "actionId",
      prop: "actionId",
      kind: "string" as ProtoKind,
    },
    {
      no: 5,
      name: "payload",
      jsonName: "payload",
      prop: "payload",
      kind: "message" as ProtoKind,
      messageType: "StructValue",
    },
  ];
  sessionId: bigint = 0n;
  row: number = 0;
  col: number = 0;
  actionId: string = "";
  payload?: StructValue;

  constructor(init?: Partial<CustomEditorActionEvent>) {
    initMessage(this, CustomEditorActionEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CustomEditorActionEvent {
    return decodeMessage(CustomEditorActionEvent, data);
  }

  static parseFrom(data: Uint8Array): CustomEditorActionEvent {
    return CustomEditorActionEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CustomEditorActionEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CustomEditorActionEvent.fields);
  }
}
registerMessage(CustomEditorActionEvent);
export class CustomRenderCellEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.CustomRenderCellEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
    {
      no: 5,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "float" as ProtoKind,
    },
    {
      no: 6,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "float" as ProtoKind,
    },
    {
      no: 7,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 8,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "CellStyle",
    },
    {
      no: 9,
      name: "done",
      jsonName: "done",
      prop: "done",
      kind: "bool" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  x: number = 0;
  y: number = 0;
  width: number = 0;
  height: number = 0;
  text: string = "";
  style?: CellStyle;
  done: boolean = false;

  constructor(init?: Partial<CustomRenderCellEvent>) {
    initMessage(this, CustomRenderCellEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): CustomRenderCellEvent {
    return decodeMessage(CustomRenderCellEvent, data);
  }

  static parseFrom(data: Uint8Array): CustomRenderCellEvent {
    return CustomRenderCellEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, CustomRenderCellEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, CustomRenderCellEvent.fields);
  }
}
registerMessage(CustomRenderCellEvent);
export class DataRefreshedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DataRefreshedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<DataRefreshedEvent>) {
    initMessage(this, DataRefreshedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DataRefreshedEvent {
    return decodeMessage(DataRefreshedEvent, data);
  }

  static parseFrom(data: Uint8Array): DataRefreshedEvent {
    return DataRefreshedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DataRefreshedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DataRefreshedEvent.fields);
  }
}
registerMessage(DataRefreshedEvent);
export class DataRefreshingEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DataRefreshingEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<DataRefreshingEvent>) {
    initMessage(this, DataRefreshingEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DataRefreshingEvent {
    return decodeMessage(DataRefreshingEvent, data);
  }

  static parseFrom(data: Uint8Array): DataRefreshingEvent {
    return DataRefreshingEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DataRefreshingEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DataRefreshingEvent.fields);
  }
}
registerMessage(DataRefreshingEvent);
export class DateTimeEditorParams implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DateTimeEditorParams" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "min_timestamp",
      jsonName: "minTimestamp",
      prop: "minTimestamp",
      kind: "int64" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "max_timestamp",
      jsonName: "maxTimestamp",
      prop: "maxTimestamp",
      kind: "int64" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "date_only",
      jsonName: "dateOnly",
      prop: "dateOnly",
      kind: "bool" as ProtoKind,
    },
    {
      no: 5,
      name: "time_only",
      jsonName: "timeOnly",
      prop: "timeOnly",
      kind: "bool" as ProtoKind,
    },
  ];
  format: string = "";
  minTimestamp: bigint = 0n;
  maxTimestamp: bigint = 0n;
  dateOnly: boolean = false;
  timeOnly: boolean = false;

  constructor(init?: Partial<DateTimeEditorParams>) {
    initMessage(this, DateTimeEditorParams.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DateTimeEditorParams {
    return decodeMessage(DateTimeEditorParams, data);
  }

  static parseFrom(data: Uint8Array): DateTimeEditorParams {
    return DateTimeEditorParams.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DateTimeEditorParams.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DateTimeEditorParams.fields);
  }
}
registerMessage(DateTimeEditorParams);
export class DblClickEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DblClickEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  row: number = 0;
  col: number = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<DblClickEvent>) {
    initMessage(this, DblClickEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DblClickEvent {
    return decodeMessage(DblClickEvent, data);
  }

  static parseFrom(data: Uint8Array): DblClickEvent {
    return DblClickEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DblClickEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DblClickEvent.fields);
  }
}
registerMessage(DblClickEvent);
export class DefineColumnsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DefineColumnsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ColumnDef",
    },
  ];
  gridId: bigint = 0n;
  columns: ColumnDef[] = [];

  constructor(init?: Partial<DefineColumnsRequest>) {
    initMessage(this, DefineColumnsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DefineColumnsRequest {
    return decodeMessage(DefineColumnsRequest, data);
  }

  static parseFrom(data: Uint8Array): DefineColumnsRequest {
    return DefineColumnsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DefineColumnsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DefineColumnsRequest.fields);
  }
}
registerMessage(DefineColumnsRequest);
export class DefineColumnsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DefineColumnsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<DefineColumnsResponse>) {
    initMessage(this, DefineColumnsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DefineColumnsResponse {
    return decodeMessage(DefineColumnsResponse, data);
  }

  static parseFrom(data: Uint8Array): DefineColumnsResponse {
    return DefineColumnsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DefineColumnsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DefineColumnsResponse.fields);
  }
}
registerMessage(DefineColumnsResponse);
export class DefineRowsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DefineRowsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "RowDef",
    },
  ];
  gridId: bigint = 0n;
  rows: RowDef[] = [];

  constructor(init?: Partial<DefineRowsRequest>) {
    initMessage(this, DefineRowsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DefineRowsRequest {
    return decodeMessage(DefineRowsRequest, data);
  }

  static parseFrom(data: Uint8Array): DefineRowsRequest {
    return DefineRowsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DefineRowsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DefineRowsRequest.fields);
  }
}
registerMessage(DefineRowsRequest);
export class DefineRowsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DefineRowsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<DefineRowsResponse>) {
    initMessage(this, DefineRowsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DefineRowsResponse {
    return decodeMessage(DefineRowsResponse, data);
  }

  static parseFrom(data: Uint8Array): DefineRowsResponse {
    return DefineRowsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DefineRowsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DefineRowsResponse.fields);
  }
}
registerMessage(DefineRowsResponse);
export class DestroyRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DestroyRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<DestroyRequest>) {
    initMessage(this, DestroyRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DestroyRequest {
    return decodeMessage(DestroyRequest, data);
  }

  static parseFrom(data: Uint8Array): DestroyRequest {
    return DestroyRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DestroyRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DestroyRequest.fields);
  }
}
registerMessage(DestroyRequest);
export class DestroyResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DestroyResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<DestroyResponse>) {
    initMessage(this, DestroyResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DestroyResponse {
    return decodeMessage(DestroyResponse, data);
  }

  static parseFrom(data: Uint8Array): DestroyResponse {
    return DestroyResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DestroyResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DestroyResponse.fields);
  }
}
registerMessage(DestroyResponse);
export class DragCompleteEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DragCompleteEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "success",
      jsonName: "success",
      prop: "success",
      kind: "bool" as ProtoKind,
    },
  ];
  success: boolean = false;

  constructor(init?: Partial<DragCompleteEvent>) {
    initMessage(this, DragCompleteEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DragCompleteEvent {
    return decodeMessage(DragCompleteEvent, data);
  }

  static parseFrom(data: Uint8Array): DragCompleteEvent {
    return DragCompleteEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DragCompleteEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DragCompleteEvent.fields);
  }
}
registerMessage(DragCompleteEvent);
export class DragDropEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DragDropEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<DragDropEvent>) {
    initMessage(this, DragDropEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DragDropEvent {
    return decodeMessage(DragDropEvent, data);
  }

  static parseFrom(data: Uint8Array): DragDropEvent {
    return DragDropEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DragDropEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DragDropEvent.fields);
  }
}
registerMessage(DragDropEvent);
export class DragOverEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DragOverEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  x: number = 0;
  y: number = 0;

  constructor(init?: Partial<DragOverEvent>) {
    initMessage(this, DragOverEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DragOverEvent {
    return decodeMessage(DragOverEvent, data);
  }

  static parseFrom(data: Uint8Array): DragOverEvent {
    return DragOverEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DragOverEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DragOverEvent.fields);
  }
}
registerMessage(DragOverEvent);
export class DragStartEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.DragStartEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<DragStartEvent>) {
    initMessage(this, DragStartEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): DragStartEvent {
    return decodeMessage(DragStartEvent, data);
  }

  static parseFrom(data: Uint8Array): DragStartEvent {
    return DragStartEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, DragStartEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, DragStartEvent.fields);
  }
}
registerMessage(DragStartEvent);
export class EditActivation implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditActivation" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "trigger",
      jsonName: "trigger",
      prop: "trigger",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: EditTrigger,
    },
    {
      no: 2,
      name: "tab_behavior",
      jsonName: "tabBehavior",
      prop: "tabBehavior",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TabBehavior,
    },
    {
      no: 3,
      name: "single_click_edit",
      jsonName: "singleClickEdit",
      prop: "singleClickEdit",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "suppress_click_edit",
      jsonName: "suppressClickEdit",
      prop: "suppressClickEdit",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "commit_on_focus_lost",
      jsonName: "commitOnFocusLost",
      prop: "commitOnFocusLost",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "preserve_edit_on_navigation",
      jsonName: "preserveEditOnNavigation",
      prop: "preserveEditOnNavigation",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  trigger: EditTrigger = 0;
  tabBehavior: TabBehavior = 0;
  singleClickEdit: boolean = false;
  suppressClickEdit: boolean = false;
  commitOnFocusLost: boolean = false;
  preserveEditOnNavigation: boolean = false;

  constructor(init?: Partial<EditActivation>) {
    initMessage(this, EditActivation.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditActivation {
    return decodeMessage(EditActivation, data);
  }

  static parseFrom(data: Uint8Array): EditActivation {
    return EditActivation.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditActivation.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditActivation.fields);
  }
}
registerMessage(EditActivation);
export class EditCancel implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditCancel" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<EditCancel>) {
    initMessage(this, EditCancel.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditCancel {
    return decodeMessage(EditCancel, data);
  }

  static parseFrom(data: Uint8Array): EditCancel {
    return EditCancel.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditCancel.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditCancel.fields);
  }
}
registerMessage(EditCancel);
export enum EditCommandCommandOneofCase {
  None = 0,
  Start = 2,
  Session = 3,
  GetState = 4,
}
export class EditCommand implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditCommand" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "start",
      jsonName: "start",
      prop: "start",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditCommandCommandOneofCase.Start,
      messageType: "EditStart",
    },
    {
      no: 3,
      name: "session",
      jsonName: "session",
      prop: "session",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditCommandCommandOneofCase.Session,
      messageType: "EditorSessionCommand",
    },
    {
      no: 4,
      name: "get_state",
      jsonName: "getState",
      prop: "getState",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditCommandCommandOneofCase.GetState,
      messageType: "EditGetState",
    },
  ];
  commandCase: EditCommandCommandOneofCase = EditCommandCommandOneofCase.None;
  gridId: bigint = 0n;
  start?: EditStart;
  session?: EditorSessionCommand;
  getState?: EditGetState;

  constructor(init?: Partial<EditCommand>) {
    initMessage(this, EditCommand.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditCommand {
    return decodeMessage(EditCommand, data);
  }

  static parseFrom(data: Uint8Array): EditCommand {
    return EditCommand.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditCommand.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditCommand.fields);
  }
}
registerMessage(EditCommand);
export class EditCommit implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditCommit" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "EditorValue",
    },
  ];
  value?: EditorValue;

  constructor(init?: Partial<EditCommit>) {
    initMessage(this, EditCommit.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditCommit {
    return decodeMessage(EditCommit, data);
  }

  static parseFrom(data: Uint8Array): EditCommit {
    return EditCommit.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditCommit.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditCommit.fields);
  }
}
registerMessage(EditCommit);
export class EditConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "activation",
      jsonName: "activation",
      prop: "activation",
      kind: "message" as ProtoKind,
      messageType: "EditActivation",
    },
    {
      no: 2,
      name: "default_editor",
      jsonName: "defaultEditor",
      prop: "defaultEditor",
      kind: "message" as ProtoKind,
      messageType: "EditorSpec",
    },
    {
      no: 3,
      name: "compose_method",
      jsonName: "composeMethod",
      prop: "composeMethod",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ComposeMethod,
    },
  ];
  activation?: EditActivation;
  defaultEditor?: EditorSpec;
  composeMethod: ComposeMethod = 0;

  constructor(init?: Partial<EditConfig>) {
    initMessage(this, EditConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditConfig {
    return decodeMessage(EditConfig, data);
  }

  static parseFrom(data: Uint8Array): EditConfig {
    return EditConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditConfig.fields);
  }
}
registerMessage(EditConfig);
export class EditGetState implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditGetState" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<EditGetState>) {
    initMessage(this, EditGetState.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditGetState {
    return decodeMessage(EditGetState, data);
  }

  static parseFrom(data: Uint8Array): EditGetState {
    return EditGetState.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditGetState.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditGetState.fields);
  }
}
registerMessage(EditGetState);
export class EditSetHighlights implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditSetHighlights" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "regions",
      jsonName: "regions",
      prop: "regions",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "HighlightRegion",
    },
  ];
  regions: HighlightRegion[] = [];

  constructor(init?: Partial<EditSetHighlights>) {
    initMessage(this, EditSetHighlights.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditSetHighlights {
    return decodeMessage(EditSetHighlights, data);
  }

  static parseFrom(data: Uint8Array): EditSetHighlights {
    return EditSetHighlights.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditSetHighlights.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditSetHighlights.fields);
  }
}
registerMessage(EditSetHighlights);
export class EditStart implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditStart" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "reason",
      jsonName: "reason",
      prop: "reason",
      kind: "enum" as ProtoKind,
      enumType: EditStartReason,
    },
    {
      no: 4,
      name: "seed_value",
      jsonName: "seedValue",
      prop: "seedValue",
      kind: "message" as ProtoKind,
      messageType: "EditorValue",
    },
    {
      no: 5,
      name: "caret_position",
      jsonName: "caretPosition",
      prop: "caretPosition",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  row: number = 0;
  col: number = 0;
  reason: EditStartReason = 0;
  seedValue?: EditorValue;
  caretPosition: number = 0;

  constructor(init?: Partial<EditStart>) {
    initMessage(this, EditStart.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditStart {
    return decodeMessage(EditStart, data);
  }

  static parseFrom(data: Uint8Array): EditStart {
    return EditStart.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditStart.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditStart.fields);
  }
}
registerMessage(EditStart);
export class EditState implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditState" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "active",
      jsonName: "active",
      prop: "active",
      kind: "bool" as ProtoKind,
    },
    {
      no: 2,
      name: "session",
      jsonName: "session",
      prop: "session",
      kind: "message" as ProtoKind,
      messageType: "EditorSession",
    },
  ];
  active: boolean = false;
  session?: EditorSession;

  constructor(init?: Partial<EditState>) {
    initMessage(this, EditState.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditState {
    return decodeMessage(EditState, data);
  }

  static parseFrom(data: Uint8Array): EditState {
    return EditState.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditState.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditState.fields);
  }
}
registerMessage(EditState);
export class EditValidationRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditValidationRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "EditorValue",
    },
  ];
  requestId: bigint = 0n;
  sessionId: bigint = 0n;
  row: number = 0;
  col: number = 0;
  value?: EditorValue;

  constructor(init?: Partial<EditValidationRequest>) {
    initMessage(this, EditValidationRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditValidationRequest {
    return decodeMessage(EditValidationRequest, data);
  }

  static parseFrom(data: Uint8Array): EditValidationRequest {
    return EditValidationRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditValidationRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditValidationRequest.fields);
  }
}
registerMessage(EditValidationRequest);
export class EditValidationResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditValidationResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "errors",
      jsonName: "errors",
      prop: "errors",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ValidationError",
    },
    {
      no: 4,
      name: "normalized_value",
      jsonName: "normalizedValue",
      prop: "normalizedValue",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "EditorValue",
    },
  ];
  requestId: bigint = 0n;
  sessionId: bigint = 0n;
  errors: ValidationError[] = [];
  normalizedValue?: EditorValue;

  constructor(init?: Partial<EditValidationResponse>) {
    initMessage(this, EditValidationResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditValidationResponse {
    return decodeMessage(EditValidationResponse, data);
  }

  static parseFrom(data: Uint8Array): EditValidationResponse {
    return EditValidationResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditValidationResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditValidationResponse.fields);
  }
}
registerMessage(EditValidationResponse);
export class EditorAction implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorAction" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "action_id",
      jsonName: "actionId",
      prop: "actionId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "label",
      jsonName: "label",
      prop: "label",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "role",
      jsonName: "role",
      prop: "role",
      kind: "enum" as ProtoKind,
      enumType: ButtonRole,
    },
    {
      no: 4,
      name: "icon",
      jsonName: "icon",
      prop: "icon",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
  ];
  actionId: string = "";
  label: string = "";
  role: ButtonRole = 0;
  icon?: ImageData;

  constructor(init?: Partial<EditorAction>) {
    initMessage(this, EditorAction.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorAction {
    return decodeMessage(EditorAction, data);
  }

  static parseFrom(data: Uint8Array): EditorAction {
    return EditorAction.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorAction.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorAction.fields);
  }
}
registerMessage(EditorAction);
export class EditorCapabilities implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorCapabilities" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "accepts_text_input",
      jsonName: "acceptsTextInput",
      prop: "acceptsTextInput",
      kind: "bool" as ProtoKind,
    },
    {
      no: 2,
      name: "supports_selection",
      jsonName: "supportsSelection",
      prop: "supportsSelection",
      kind: "bool" as ProtoKind,
    },
    {
      no: 3,
      name: "supports_cut",
      jsonName: "supportsCut",
      prop: "supportsCut",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "supports_paste",
      jsonName: "supportsPaste",
      prop: "supportsPaste",
      kind: "bool" as ProtoKind,
    },
    {
      no: 5,
      name: "supports_undo",
      jsonName: "supportsUndo",
      prop: "supportsUndo",
      kind: "bool" as ProtoKind,
    },
  ];
  acceptsTextInput: boolean = false;
  supportsSelection: boolean = false;
  supportsCut: boolean = false;
  supportsPaste: boolean = false;
  supportsUndo: boolean = false;

  constructor(init?: Partial<EditorCapabilities>) {
    initMessage(this, EditorCapabilities.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorCapabilities {
    return decodeMessage(EditorCapabilities, data);
  }

  static parseFrom(data: Uint8Array): EditorCapabilities {
    return EditorCapabilities.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorCapabilities.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorCapabilities.fields);
  }
}
registerMessage(EditorCapabilities);
export class EditorListItemsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorListItemsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "data_source_id",
      jsonName: "dataSourceId",
      prop: "dataSourceId",
      kind: "string" as ProtoKind,
    },
    {
      no: 4,
      name: "filter_text",
      jsonName: "filterText",
      prop: "filterText",
      kind: "string" as ProtoKind,
    },
    {
      no: 5,
      name: "offset",
      jsonName: "offset",
      prop: "offset",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "limit",
      jsonName: "limit",
      prop: "limit",
      kind: "int32" as ProtoKind,
    },
  ];
  requestId: bigint = 0n;
  sessionId: bigint = 0n;
  dataSourceId: string = "";
  filterText: string = "";
  offset: number = 0;
  limit: number = 0;

  constructor(init?: Partial<EditorListItemsRequest>) {
    initMessage(this, EditorListItemsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorListItemsRequest {
    return decodeMessage(EditorListItemsRequest, data);
  }

  static parseFrom(data: Uint8Array): EditorListItemsRequest {
    return EditorListItemsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorListItemsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorListItemsRequest.fields);
  }
}
registerMessage(EditorListItemsRequest);
export class EditorListItemsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorListItemsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "items",
      jsonName: "items",
      prop: "items",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ListItem",
    },
    {
      no: 4,
      name: "has_more",
      jsonName: "hasMore",
      prop: "hasMore",
      kind: "bool" as ProtoKind,
    },
  ];
  requestId: bigint = 0n;
  sessionId: bigint = 0n;
  items: ListItem[] = [];
  hasMore: boolean = false;

  constructor(init?: Partial<EditorListItemsResponse>) {
    initMessage(this, EditorListItemsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorListItemsResponse {
    return decodeMessage(EditorListItemsResponse, data);
  }

  static parseFrom(data: Uint8Array): EditorListItemsResponse {
    return EditorListItemsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorListItemsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorListItemsResponse.fields);
  }
}
registerMessage(EditorListItemsResponse);
export class EditorPreeditChanged implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorPreeditChanged" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "cursor",
      jsonName: "cursor",
      prop: "cursor",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "commit",
      jsonName: "commit",
      prop: "commit",
      kind: "bool" as ProtoKind,
    },
  ];
  text: string = "";
  cursor: number = 0;
  commit: boolean = false;

  constructor(init?: Partial<EditorPreeditChanged>) {
    initMessage(this, EditorPreeditChanged.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorPreeditChanged {
    return decodeMessage(EditorPreeditChanged, data);
  }

  static parseFrom(data: Uint8Array): EditorPreeditChanged {
    return EditorPreeditChanged.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorPreeditChanged.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorPreeditChanged.fields);
  }
}
registerMessage(EditorPreeditChanged);
export class EditorSession implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSession" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "viewport_rect",
      jsonName: "viewportRect",
      prop: "viewportRect",
      kind: "message" as ProtoKind,
      messageType: "Rect",
    },
    {
      no: 5,
      name: "editor",
      jsonName: "editor",
      prop: "editor",
      kind: "message" as ProtoKind,
      messageType: "EditorSpec",
    },
    {
      no: 6,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "EditorValue",
    },
    {
      no: 7,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      messageType: "TextSelection",
    },
    {
      no: 8,
      name: "ui_mode",
      jsonName: "uiMode",
      prop: "uiMode",
      kind: "enum" as ProtoKind,
      enumType: EditUiMode,
    },
    {
      no: 9,
      name: "capabilities",
      jsonName: "capabilities",
      prop: "capabilities",
      kind: "message" as ProtoKind,
      messageType: "EditorCapabilities",
    },
    {
      no: 10,
      name: "reason",
      jsonName: "reason",
      prop: "reason",
      kind: "enum" as ProtoKind,
      enumType: EditStartReason,
    },
    {
      no: 11,
      name: "state_version",
      jsonName: "stateVersion",
      prop: "stateVersion",
      kind: "uint64" as ProtoKind,
    },
    {
      no: 12,
      name: "composing",
      jsonName: "composing",
      prop: "composing",
      kind: "bool" as ProtoKind,
    },
    {
      no: 13,
      name: "preedit_text",
      jsonName: "preeditText",
      prop: "preeditText",
      kind: "string" as ProtoKind,
    },
    {
      no: 14,
      name: "validation_errors",
      jsonName: "validationErrors",
      prop: "validationErrors",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ValidationError",
    },
  ];
  sessionId: bigint = 0n;
  row: number = 0;
  col: number = 0;
  viewportRect?: Rect;
  editor?: EditorSpec;
  value?: EditorValue;
  selection?: TextSelection;
  uiMode: EditUiMode = 0;
  capabilities?: EditorCapabilities;
  reason: EditStartReason = 0;
  stateVersion: bigint = 0n;
  composing: boolean = false;
  preeditText: string = "";
  validationErrors: ValidationError[] = [];

  constructor(init?: Partial<EditorSession>) {
    initMessage(this, EditorSession.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSession {
    return decodeMessage(EditorSession, data);
  }

  static parseFrom(data: Uint8Array): EditorSession {
    return EditorSession.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSession.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSession.fields);
  }
}
registerMessage(EditorSession);
export enum EditorSessionCommandCommandOneofCase {
  None = 0,
  ValueChanged = 3,
  SelectionChanged = 4,
  PreeditChanged = 5,
  Commit = 6,
  Cancel = 7,
  CustomAction = 8,
}
export class EditorSessionCommand implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSessionCommand" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "state_version",
      jsonName: "stateVersion",
      prop: "stateVersion",
      kind: "uint64" as ProtoKind,
    },
    {
      no: 3,
      name: "value_changed",
      jsonName: "valueChanged",
      prop: "valueChanged",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.ValueChanged,
      messageType: "EditorValueChanged",
    },
    {
      no: 4,
      name: "selection_changed",
      jsonName: "selectionChanged",
      prop: "selectionChanged",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.SelectionChanged,
      messageType: "TextSelectionChanged",
    },
    {
      no: 5,
      name: "preedit_changed",
      jsonName: "preeditChanged",
      prop: "preeditChanged",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.PreeditChanged,
      messageType: "EditorPreeditChanged",
    },
    {
      no: 6,
      name: "commit",
      jsonName: "commit",
      prop: "commit",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.Commit,
      messageType: "EditCommit",
    },
    {
      no: 7,
      name: "cancel",
      jsonName: "cancel",
      prop: "cancel",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.Cancel,
      messageType: "EditCancel",
    },
    {
      no: 8,
      name: "custom_action",
      jsonName: "customAction",
      prop: "customAction",
      kind: "message" as ProtoKind,
      oneof: "commandCase",
      oneofCase: EditorSessionCommandCommandOneofCase.CustomAction,
      messageType: "CustomEditorAction",
    },
  ];
  commandCase: EditorSessionCommandCommandOneofCase = EditorSessionCommandCommandOneofCase.None;
  sessionId: bigint = 0n;
  stateVersion: bigint = 0n;
  valueChanged?: EditorValueChanged;
  selectionChanged?: TextSelectionChanged;
  preeditChanged?: EditorPreeditChanged;
  commit?: EditCommit;
  cancel?: EditCancel;
  customAction?: CustomEditorAction;

  constructor(init?: Partial<EditorSessionCommand>) {
    initMessage(this, EditorSessionCommand.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSessionCommand {
    return decodeMessage(EditorSessionCommand, data);
  }

  static parseFrom(data: Uint8Array): EditorSessionCommand {
    return EditorSessionCommand.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSessionCommand.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSessionCommand.fields);
  }
}
registerMessage(EditorSessionCommand);
export class EditorSessionEnded implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSessionEnded" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "reason",
      jsonName: "reason",
      prop: "reason",
      kind: "enum" as ProtoKind,
      enumType: EditEndReason,
    },
    {
      no: 3,
      name: "committed_value",
      jsonName: "committedValue",
      prop: "committedValue",
      kind: "message" as ProtoKind,
      messageType: "EditorValue",
    },
    {
      no: 4,
      name: "state_version",
      jsonName: "stateVersion",
      prop: "stateVersion",
      kind: "uint64" as ProtoKind,
    },
  ];
  sessionId: bigint = 0n;
  reason: EditEndReason = 0;
  committedValue?: EditorValue;
  stateVersion: bigint = 0n;

  constructor(init?: Partial<EditorSessionEnded>) {
    initMessage(this, EditorSessionEnded.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSessionEnded {
    return decodeMessage(EditorSessionEnded, data);
  }

  static parseFrom(data: Uint8Array): EditorSessionEnded {
    return EditorSessionEnded.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSessionEnded.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSessionEnded.fields);
  }
}
registerMessage(EditorSessionEnded);
export class EditorSessionStarted implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSessionStarted" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session",
      jsonName: "session",
      prop: "session",
      kind: "message" as ProtoKind,
      messageType: "EditorSession",
    },
  ];
  session?: EditorSession;

  constructor(init?: Partial<EditorSessionStarted>) {
    initMessage(this, EditorSessionStarted.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSessionStarted {
    return decodeMessage(EditorSessionStarted, data);
  }

  static parseFrom(data: Uint8Array): EditorSessionStarted {
    return EditorSessionStarted.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSessionStarted.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSessionStarted.fields);
  }
}
registerMessage(EditorSessionStarted);
export class EditorSessionUpdated implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSessionUpdated" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "state_version",
      jsonName: "stateVersion",
      prop: "stateVersion",
      kind: "uint64" as ProtoKind,
    },
    {
      no: 3,
      name: "reason",
      jsonName: "reason",
      prop: "reason",
      kind: "enum" as ProtoKind,
      enumType: EditorUpdateReason,
    },
    {
      no: 4,
      name: "viewport_rect",
      jsonName: "viewportRect",
      prop: "viewportRect",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "Rect",
    },
    {
      no: 5,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "EditorValue",
    },
    {
      no: 6,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "TextSelection",
    },
    {
      no: 7,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "force_refocus",
      jsonName: "forceRefocus",
      prop: "forceRefocus",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "validation_errors",
      jsonName: "validationErrors",
      prop: "validationErrors",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ValidationError",
    },
    {
      no: 10,
      name: "custom_payload",
      jsonName: "customPayload",
      prop: "customPayload",
      kind: "message" as ProtoKind,
      messageType: "StructValue",
    },
  ];
  sessionId: bigint = 0n;
  stateVersion: bigint = 0n;
  reason: EditorUpdateReason = 0;
  viewportRect?: Rect;
  value?: EditorValue;
  selection?: TextSelection;
  visible: boolean = false;
  forceRefocus: boolean = false;
  validationErrors: ValidationError[] = [];
  customPayload?: StructValue;

  constructor(init?: Partial<EditorSessionUpdated>) {
    initMessage(this, EditorSessionUpdated.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSessionUpdated {
    return decodeMessage(EditorSessionUpdated, data);
  }

  static parseFrom(data: Uint8Array): EditorSessionUpdated {
    return EditorSessionUpdated.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSessionUpdated.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSessionUpdated.fields);
  }
}
registerMessage(EditorSessionUpdated);
export class EditorSpec implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorSpec" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "kind",
      jsonName: "kind",
      prop: "kind",
      kind: "enum" as ProtoKind,
      enumType: EditorKind,
    },
    {
      no: 2,
      name: "owner",
      jsonName: "owner",
      prop: "owner",
      kind: "enum" as ProtoKind,
      enumType: EditorOwner,
    },
    {
      no: 3,
      name: "presentation",
      jsonName: "presentation",
      prop: "presentation",
      kind: "enum" as ProtoKind,
      enumType: EditorPresentation,
    },
    {
      no: 4,
      name: "validation_mode",
      jsonName: "validationMode",
      prop: "validationMode",
      kind: "enum" as ProtoKind,
      enumType: ValidationMode,
    },
    {
      no: 5,
      name: "validation_trigger",
      jsonName: "validationTrigger",
      prop: "validationTrigger",
      kind: "enum" as ProtoKind,
      enumType: ValidationTrigger,
    },
    {
      no: 6,
      name: "validation_debounce_ms",
      jsonName: "validationDebounceMs",
      prop: "validationDebounceMs",
      kind: "int32" as ProtoKind,
    },
    {
      no: 10,
      name: "custom_editor_id",
      jsonName: "customEditorId",
      prop: "customEditorId",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "message" as ProtoKind,
      messageType: "TextEditorParams",
    },
    {
      no: 12,
      name: "number",
      jsonName: "number",
      prop: "number",
      kind: "message" as ProtoKind,
      messageType: "NumberEditorParams",
    },
    {
      no: 13,
      name: "checkbox",
      jsonName: "checkbox",
      prop: "checkbox",
      kind: "message" as ProtoKind,
      messageType: "CheckboxEditorParams",
    },
    {
      no: 14,
      name: "list",
      jsonName: "list",
      prop: "list",
      kind: "message" as ProtoKind,
      messageType: "ListEditorParams",
    },
    {
      no: 15,
      name: "date_time",
      jsonName: "dateTime",
      prop: "dateTime",
      kind: "message" as ProtoKind,
      messageType: "DateTimeEditorParams",
    },
    {
      no: 16,
      name: "actions",
      jsonName: "actions",
      prop: "actions",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "EditorAction",
    },
    {
      no: 17,
      name: "custom_props",
      jsonName: "customProps",
      prop: "customProps",
      kind: "message" as ProtoKind,
      messageType: "StructValue",
    },
  ];
  kind: EditorKind = 0;
  owner: EditorOwner = 0;
  presentation: EditorPresentation = 0;
  validationMode: ValidationMode = 0;
  validationTrigger: ValidationTrigger = 0;
  validationDebounceMs: number = 0;
  customEditorId: string = "";
  text?: TextEditorParams;
  number?: NumberEditorParams;
  checkbox?: CheckboxEditorParams;
  list?: ListEditorParams;
  dateTime?: DateTimeEditorParams;
  actions: EditorAction[] = [];
  customProps?: StructValue;

  constructor(init?: Partial<EditorSpec>) {
    initMessage(this, EditorSpec.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorSpec {
    return decodeMessage(EditorSpec, data);
  }

  static parseFrom(data: Uint8Array): EditorSpec {
    return EditorSpec.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorSpec.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorSpec.fields);
  }
}
registerMessage(EditorSpec);
export class EditorValue implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorValue" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "CellValue",
    },
    {
      no: 2,
      name: "edit_text",
      jsonName: "editText",
      prop: "editText",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "display_text",
      jsonName: "displayText",
      prop: "displayText",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  value?: CellValue;
  editText: string = "";
  displayText: string = "";

  constructor(init?: Partial<EditorValue>) {
    initMessage(this, EditorValue.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorValue {
    return decodeMessage(EditorValue, data);
  }

  static parseFrom(data: Uint8Array): EditorValue {
    return EditorValue.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorValue.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorValue.fields);
  }
}
registerMessage(EditorValue);
export class EditorValueChanged implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EditorValueChanged" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "EditorValue",
    },
  ];
  value?: EditorValue;

  constructor(init?: Partial<EditorValueChanged>) {
    initMessage(this, EditorValueChanged.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EditorValueChanged {
    return decodeMessage(EditorValueChanged, data);
  }

  static parseFrom(data: Uint8Array): EditorValueChanged {
    return EditorValueChanged.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EditorValueChanged.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EditorValueChanged.fields);
  }
}
registerMessage(EditorValueChanged);
export class EnterCellEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EnterCellEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  row: number = 0;
  col: number = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<EnterCellEvent>) {
    initMessage(this, EnterCellEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EnterCellEvent {
    return decodeMessage(EnterCellEvent, data);
  }

  static parseFrom(data: Uint8Array): EnterCellEvent {
    return EnterCellEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EnterCellEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EnterCellEvent.fields);
  }
}
registerMessage(EnterCellEvent);
export class ErrorEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ErrorEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "code",
      jsonName: "code",
      prop: "code",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "message",
      jsonName: "message",
      prop: "message",
      kind: "string" as ProtoKind,
    },
  ];
  code: number = 0;
  message: string = "";

  constructor(init?: Partial<ErrorEvent>) {
    initMessage(this, ErrorEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ErrorEvent {
    return decodeMessage(ErrorEvent, data);
  }

  static parseFrom(data: Uint8Array): ErrorEvent {
    return ErrorEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ErrorEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ErrorEvent.fields);
  }
}
registerMessage(ErrorEvent);
export class EventDecision implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EventDecision" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "event_id",
      jsonName: "eventId",
      prop: "eventId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "cancel",
      jsonName: "cancel",
      prop: "cancel",
      kind: "bool" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  eventId: bigint = 0n;
  cancel: boolean = false;

  constructor(init?: Partial<EventDecision>) {
    initMessage(this, EventDecision.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EventDecision {
    return decodeMessage(EventDecision, data);
  }

  static parseFrom(data: Uint8Array): EventDecision {
    return EventDecision.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EventDecision.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EventDecision.fields);
  }
}
registerMessage(EventDecision);
export class EventStreamRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.EventStreamRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<EventStreamRequest>) {
    initMessage(this, EventStreamRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): EventStreamRequest {
    return decodeMessage(EventStreamRequest, data);
  }

  static parseFrom(data: Uint8Array): EventStreamRequest {
    return EventStreamRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, EventStreamRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, EventStreamRequest.fields);
  }
}
registerMessage(EventStreamRequest);
export class ExportRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ExportRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "enum" as ProtoKind,
      enumType: ExportFormat,
    },
    {
      no: 3,
      name: "scope",
      jsonName: "scope",
      prop: "scope",
      kind: "enum" as ProtoKind,
      enumType: ExportScope,
    },
  ];
  gridId: bigint = 0n;
  format: ExportFormat = 0;
  scope: ExportScope = 0;

  constructor(init?: Partial<ExportRequest>) {
    initMessage(this, ExportRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ExportRequest {
    return decodeMessage(ExportRequest, data);
  }

  static parseFrom(data: Uint8Array): ExportRequest {
    return ExportRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ExportRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ExportRequest.fields);
  }
}
registerMessage(ExportRequest);
export class ExportResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ExportResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 2,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "enum" as ProtoKind,
      enumType: ExportFormat,
    },
  ];
  data?: Uint8Array;
  format: ExportFormat = 0;

  constructor(init?: Partial<ExportResponse>) {
    initMessage(this, ExportResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ExportResponse {
    return decodeMessage(ExportResponse, data);
  }

  static parseFrom(data: Uint8Array): ExportResponse {
    return ExportResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ExportResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ExportResponse.fields);
  }
}
registerMessage(ExportResponse);
export enum FieldMappingTargetOneofCase {
  None = 0,
  ColIndex = 2,
  ColKey = 3,
}
export class FieldMapping implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FieldMapping" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "field",
      jsonName: "field",
      prop: "field",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "col_index",
      jsonName: "colIndex",
      prop: "colIndex",
      kind: "int32" as ProtoKind,
      oneof: "targetCase",
      oneofCase: FieldMappingTargetOneofCase.ColIndex,
    },
    {
      no: 3,
      name: "col_key",
      jsonName: "colKey",
      prop: "colKey",
      kind: "string" as ProtoKind,
      oneof: "targetCase",
      oneofCase: FieldMappingTargetOneofCase.ColKey,
    },
  ];
  targetCase: FieldMappingTargetOneofCase = FieldMappingTargetOneofCase.None;
  field: string = "";
  colIndex?: number;
  colKey?: string;

  constructor(init?: Partial<FieldMapping>) {
    initMessage(this, FieldMapping.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FieldMapping {
    return decodeMessage(FieldMapping, data);
  }

  static parseFrom(data: Uint8Array): FieldMapping {
    return FieldMapping.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FieldMapping.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FieldMapping.fields);
  }
}
registerMessage(FieldMapping);
export class FilterDataEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FilterDataEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  text: string = "";

  constructor(init?: Partial<FilterDataEvent>) {
    initMessage(this, FilterDataEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FilterDataEvent {
    return decodeMessage(FilterDataEvent, data);
  }

  static parseFrom(data: Uint8Array): FilterDataEvent {
    return FilterDataEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FilterDataEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FilterDataEvent.fields);
  }
}
registerMessage(FilterDataEvent);
export enum FindRequestQueryOneofCase {
  None = 0,
  TextQuery = 4,
  RegexQuery = 5,
}
export class FindRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FindRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "start_row",
      jsonName: "startRow",
      prop: "startRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "text_query",
      jsonName: "textQuery",
      prop: "textQuery",
      kind: "message" as ProtoKind,
      oneof: "queryCase",
      oneofCase: FindRequestQueryOneofCase.TextQuery,
      messageType: "TextQuery",
    },
    {
      no: 5,
      name: "regex_query",
      jsonName: "regexQuery",
      prop: "regexQuery",
      kind: "message" as ProtoKind,
      oneof: "queryCase",
      oneofCase: FindRequestQueryOneofCase.RegexQuery,
      messageType: "RegexQuery",
    },
  ];
  queryCase: FindRequestQueryOneofCase = FindRequestQueryOneofCase.None;
  gridId: bigint = 0n;
  col: number = 0;
  startRow: number = 0;
  textQuery?: TextQuery;
  regexQuery?: RegexQuery;

  constructor(init?: Partial<FindRequest>) {
    initMessage(this, FindRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FindRequest {
    return decodeMessage(FindRequest, data);
  }

  static parseFrom(data: Uint8Array): FindRequest {
    return FindRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FindRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FindRequest.fields);
  }
}
registerMessage(FindRequest);
export class FindResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FindResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;

  constructor(init?: Partial<FindResponse>) {
    initMessage(this, FindResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FindResponse {
    return decodeMessage(FindResponse, data);
  }

  static parseFrom(data: Uint8Array): FindResponse {
    return FindResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FindResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FindResponse.fields);
  }
}
registerMessage(FindResponse);
export class Font implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Font" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "family",
      jsonName: "family",
      prop: "family",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "families",
      jsonName: "families",
      prop: "families",
      kind: "string" as ProtoKind,
      repeated: true,
    },
    {
      no: 3,
      name: "size",
      jsonName: "size",
      prop: "size",
      kind: "float" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "bold",
      jsonName: "bold",
      prop: "bold",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "italic",
      jsonName: "italic",
      prop: "italic",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "underline",
      jsonName: "underline",
      prop: "underline",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "strikethrough",
      jsonName: "strikethrough",
      prop: "strikethrough",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "stretch",
      jsonName: "stretch",
      prop: "stretch",
      kind: "float" as ProtoKind,
      optional: true,
    },
  ];
  family: string = "";
  families: string[] = [];
  size: number = 0;
  bold: boolean = false;
  italic: boolean = false;
  underline: boolean = false;
  strikethrough: boolean = false;
  stretch: number = 0;

  constructor(init?: Partial<Font>) {
    initMessage(this, Font.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Font {
    return decodeMessage(Font, data);
  }

  static parseFrom(data: Uint8Array): Font {
    return Font.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Font.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Font.fields);
  }
}
registerMessage(Font);
export class FrameDone implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FrameDone" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "handle",
      jsonName: "handle",
      prop: "handle",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "dirty_x",
      jsonName: "dirtyX",
      prop: "dirtyX",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "dirty_y",
      jsonName: "dirtyY",
      prop: "dirtyY",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "dirty_w",
      jsonName: "dirtyW",
      prop: "dirtyW",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "dirty_h",
      jsonName: "dirtyH",
      prop: "dirtyH",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "metrics",
      jsonName: "metrics",
      prop: "metrics",
      kind: "message" as ProtoKind,
      messageType: "FrameMetrics",
    },
    {
      no: 7,
      name: "bytes_written",
      jsonName: "bytesWritten",
      prop: "bytesWritten",
      kind: "int32" as ProtoKind,
    },
    {
      no: 8,
      name: "required_capacity",
      jsonName: "requiredCapacity",
      prop: "requiredCapacity",
      kind: "int32" as ProtoKind,
    },
    {
      no: 9,
      name: "frame_kind",
      jsonName: "frameKind",
      prop: "frameKind",
      kind: "enum" as ProtoKind,
      enumType: FrameKind,
    },
  ];
  handle: bigint = 0n;
  dirtyX: number = 0;
  dirtyY: number = 0;
  dirtyW: number = 0;
  dirtyH: number = 0;
  metrics?: FrameMetrics;
  bytesWritten: number = 0;
  requiredCapacity: number = 0;
  frameKind: FrameKind = 0;

  constructor(init?: Partial<FrameDone>) {
    initMessage(this, FrameDone.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FrameDone {
    return decodeMessage(FrameDone, data);
  }

  static parseFrom(data: Uint8Array): FrameDone {
    return FrameDone.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FrameDone.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FrameDone.fields);
  }
}
registerMessage(FrameDone);
export class FrameMetrics implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FrameMetrics" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "frame_time_ms",
      jsonName: "frameTimeMs",
      prop: "frameTimeMs",
      kind: "float" as ProtoKind,
    },
    {
      no: 2,
      name: "fps",
      jsonName: "fps",
      prop: "fps",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "layer_times_us",
      jsonName: "layerTimesUs",
      prop: "layerTimesUs",
      kind: "float" as ProtoKind,
      repeated: true,
    },
    {
      no: 4,
      name: "zone_cell_counts",
      jsonName: "zoneCellCounts",
      prop: "zoneCellCounts",
      kind: "uint32" as ProtoKind,
      repeated: true,
    },
    {
      no: 5,
      name: "instance_count",
      jsonName: "instanceCount",
      prop: "instanceCount",
      kind: "int32" as ProtoKind,
    },
  ];
  frameTimeMs: number = 0;
  fps: number = 0;
  layerTimesUs: number[] = [];
  zoneCellCounts: number[] = [];
  instanceCount: number = 0;

  constructor(init?: Partial<FrameMetrics>) {
    initMessage(this, FrameMetrics.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FrameMetrics {
    return decodeMessage(FrameMetrics, data);
  }

  static parseFrom(data: Uint8Array): FrameMetrics {
    return FrameMetrics.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FrameMetrics.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FrameMetrics.fields);
  }
}
registerMessage(FrameMetrics);
export class FreezePolicy implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.FreezePolicy" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  columns: boolean = false;
  rows: boolean = false;

  constructor(init?: Partial<FreezePolicy>) {
    initMessage(this, FreezePolicy.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): FreezePolicy {
    return decodeMessage(FreezePolicy, data);
  }

  static parseFrom(data: Uint8Array): FreezePolicy {
    return FreezePolicy.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, FreezePolicy.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, FreezePolicy.fields);
  }
}
registerMessage(FreezePolicy);
export class GetCellsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetCellsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row1",
      jsonName: "row1",
      prop: "row1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col1",
      jsonName: "col1",
      prop: "col1",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "row2",
      jsonName: "row2",
      prop: "row2",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "col2",
      jsonName: "col2",
      prop: "col2",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "include_style",
      jsonName: "includeStyle",
      prop: "includeStyle",
      kind: "bool" as ProtoKind,
    },
    {
      no: 7,
      name: "include_checked",
      jsonName: "includeChecked",
      prop: "includeChecked",
      kind: "bool" as ProtoKind,
    },
    {
      no: 8,
      name: "include_typed",
      jsonName: "includeTyped",
      prop: "includeTyped",
      kind: "bool" as ProtoKind,
    },
    {
      no: 9,
      name: "include_barcode_status",
      jsonName: "includeBarcodeStatus",
      prop: "includeBarcodeStatus",
      kind: "bool" as ProtoKind,
    },
    {
      no: 10,
      name: "include_rich_text",
      jsonName: "includeRichText",
      prop: "includeRichText",
      kind: "bool" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  row1: number = 0;
  col1: number = 0;
  row2: number = 0;
  col2: number = 0;
  includeStyle: boolean = false;
  includeChecked: boolean = false;
  includeTyped: boolean = false;
  includeBarcodeStatus: boolean = false;
  includeRichText: boolean = false;

  constructor(init?: Partial<GetCellsRequest>) {
    initMessage(this, GetCellsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetCellsRequest {
    return decodeMessage(GetCellsRequest, data);
  }

  static parseFrom(data: Uint8Array): GetCellsRequest {
    return GetCellsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetCellsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetCellsRequest.fields);
  }
}
registerMessage(GetCellsRequest);
export class GetConfigRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetConfigRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<GetConfigRequest>) {
    initMessage(this, GetConfigRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetConfigRequest {
    return decodeMessage(GetConfigRequest, data);
  }

  static parseFrom(data: Uint8Array): GetConfigRequest {
    return GetConfigRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetConfigRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetConfigRequest.fields);
  }
}
registerMessage(GetConfigRequest);
export class GetDemoDataRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetDemoDataRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "demo",
      jsonName: "demo",
      prop: "demo",
      kind: "string" as ProtoKind,
    },
  ];
  demo: string = "";

  constructor(init?: Partial<GetDemoDataRequest>) {
    initMessage(this, GetDemoDataRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetDemoDataRequest {
    return decodeMessage(GetDemoDataRequest, data);
  }

  static parseFrom(data: Uint8Array): GetDemoDataRequest {
    return GetDemoDataRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetDemoDataRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetDemoDataRequest.fields);
  }
}
registerMessage(GetDemoDataRequest);
export class GetDemoDataResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetDemoDataResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "demo",
      jsonName: "demo",
      prop: "demo",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "enum" as ProtoKind,
      enumType: DemoDataFormat,
    },
    {
      no: 3,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
  ];
  demo: string = "";
  format: DemoDataFormat = 0;
  data?: Uint8Array;

  constructor(init?: Partial<GetDemoDataResponse>) {
    initMessage(this, GetDemoDataResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetDemoDataResponse {
    return decodeMessage(GetDemoDataResponse, data);
  }

  static parseFrom(data: Uint8Array): GetDemoDataResponse {
    return GetDemoDataResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetDemoDataResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetDemoDataResponse.fields);
  }
}
registerMessage(GetDemoDataResponse);
export class GetHeaderRowEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetHeaderRowEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "page",
      jsonName: "page",
      prop: "page",
      kind: "int32" as ProtoKind,
    },
  ];
  page: number = 0;

  constructor(init?: Partial<GetHeaderRowEvent>) {
    initMessage(this, GetHeaderRowEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetHeaderRowEvent {
    return decodeMessage(GetHeaderRowEvent, data);
  }

  static parseFrom(data: Uint8Array): GetHeaderRowEvent {
    return GetHeaderRowEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetHeaderRowEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetHeaderRowEvent.fields);
  }
}
registerMessage(GetHeaderRowEvent);
export class GetMemoryUsageRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetMemoryUsageRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<GetMemoryUsageRequest>) {
    initMessage(this, GetMemoryUsageRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetMemoryUsageRequest {
    return decodeMessage(GetMemoryUsageRequest, data);
  }

  static parseFrom(data: Uint8Array): GetMemoryUsageRequest {
    return GetMemoryUsageRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetMemoryUsageRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetMemoryUsageRequest.fields);
  }
}
registerMessage(GetMemoryUsageRequest);
export class GetMergedRangeRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetMergedRangeRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<GetMergedRangeRequest>) {
    initMessage(this, GetMergedRangeRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetMergedRangeRequest {
    return decodeMessage(GetMergedRangeRequest, data);
  }

  static parseFrom(data: Uint8Array): GetMergedRangeRequest {
    return GetMergedRangeRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetMergedRangeRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetMergedRangeRequest.fields);
  }
}
registerMessage(GetMergedRangeRequest);
export class GetMergedRegionsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetMergedRegionsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<GetMergedRegionsRequest>) {
    initMessage(this, GetMergedRegionsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetMergedRegionsRequest {
    return decodeMessage(GetMergedRegionsRequest, data);
  }

  static parseFrom(data: Uint8Array): GetMergedRegionsRequest {
    return GetMergedRegionsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetMergedRegionsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetMergedRegionsRequest.fields);
  }
}
registerMessage(GetMergedRegionsRequest);
export class GetNodeRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetNodeRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "relation",
      jsonName: "relation",
      prop: "relation",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: NodeRelation,
    },
  ];
  gridId: bigint = 0n;
  row: number = 0;
  relation: NodeRelation = 0;

  constructor(init?: Partial<GetNodeRequest>) {
    initMessage(this, GetNodeRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetNodeRequest {
    return decodeMessage(GetNodeRequest, data);
  }

  static parseFrom(data: Uint8Array): GetNodeRequest {
    return GetNodeRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetNodeRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetNodeRequest.fields);
  }
}
registerMessage(GetNodeRequest);
export class GetSchemaRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetSchemaRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<GetSchemaRequest>) {
    initMessage(this, GetSchemaRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetSchemaRequest {
    return decodeMessage(GetSchemaRequest, data);
  }

  static parseFrom(data: Uint8Array): GetSchemaRequest {
    return GetSchemaRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetSchemaRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetSchemaRequest.fields);
  }
}
registerMessage(GetSchemaRequest);
export class GetSelectionRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GetSelectionRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<GetSelectionRequest>) {
    initMessage(this, GetSelectionRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GetSelectionRequest {
    return decodeMessage(GetSelectionRequest, data);
  }

  static parseFrom(data: Uint8Array): GetSelectionRequest {
    return GetSelectionRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GetSelectionRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GetSelectionRequest.fields);
  }
}
registerMessage(GetSelectionRequest);
export class GpuFrameDone implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GpuFrameDone" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "dirty_x",
      jsonName: "dirtyX",
      prop: "dirtyX",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "dirty_y",
      jsonName: "dirtyY",
      prop: "dirtyY",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "dirty_w",
      jsonName: "dirtyW",
      prop: "dirtyW",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "dirty_h",
      jsonName: "dirtyH",
      prop: "dirtyH",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "metrics",
      jsonName: "metrics",
      prop: "metrics",
      kind: "message" as ProtoKind,
      messageType: "FrameMetrics",
    },
  ];
  dirtyX: number = 0;
  dirtyY: number = 0;
  dirtyW: number = 0;
  dirtyH: number = 0;
  metrics?: FrameMetrics;

  constructor(init?: Partial<GpuFrameDone>) {
    initMessage(this, GpuFrameDone.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GpuFrameDone {
    return decodeMessage(GpuFrameDone, data);
  }

  static parseFrom(data: Uint8Array): GpuFrameDone {
    return GpuFrameDone.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GpuFrameDone.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GpuFrameDone.fields);
  }
}
registerMessage(GpuFrameDone);
export class GpuSurfaceReady implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GpuSurfaceReady" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "surface_handle",
      jsonName: "surfaceHandle",
      prop: "surfaceHandle",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
  ];
  surfaceHandle: bigint = 0n;
  width: number = 0;
  height: number = 0;

  constructor(init?: Partial<GpuSurfaceReady>) {
    initMessage(this, GpuSurfaceReady.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GpuSurfaceReady {
    return decodeMessage(GpuSurfaceReady, data);
  }

  static parseFrom(data: Uint8Array): GpuSurfaceReady {
    return GpuSurfaceReady.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GpuSurfaceReady.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GpuSurfaceReady.fields);
  }
}
registerMessage(GpuSurfaceReady);
export class GridConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GridConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "layout",
      jsonName: "layout",
      prop: "layout",
      kind: "message" as ProtoKind,
      messageType: "LayoutConfig",
    },
    {
      no: 2,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "StyleConfig",
    },
    {
      no: 3,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      messageType: "SelectionConfig",
    },
    {
      no: 4,
      name: "editing",
      jsonName: "editing",
      prop: "editing",
      kind: "message" as ProtoKind,
      messageType: "EditConfig",
    },
    {
      no: 5,
      name: "scrolling",
      jsonName: "scrolling",
      prop: "scrolling",
      kind: "message" as ProtoKind,
      messageType: "ScrollConfig",
    },
    {
      no: 6,
      name: "outline",
      jsonName: "outline",
      prop: "outline",
      kind: "message" as ProtoKind,
      messageType: "OutlineConfig",
    },
    {
      no: 7,
      name: "span",
      jsonName: "span",
      prop: "span",
      kind: "message" as ProtoKind,
      messageType: "SpanConfig",
    },
    {
      no: 8,
      name: "interaction",
      jsonName: "interaction",
      prop: "interaction",
      kind: "message" as ProtoKind,
      messageType: "InteractionConfig",
    },
    {
      no: 9,
      name: "rendering",
      jsonName: "rendering",
      prop: "rendering",
      kind: "message" as ProtoKind,
      messageType: "RenderConfig",
    },
    {
      no: 10,
      name: "version",
      jsonName: "version",
      prop: "version",
      kind: "string" as ProtoKind,
    },
    {
      no: 11,
      name: "indicators",
      jsonName: "indicators",
      prop: "indicators",
      kind: "message" as ProtoKind,
      messageType: "IndicatorsConfig",
    },
    {
      no: 12,
      name: "theme_preset",
      jsonName: "themePreset",
      prop: "themePreset",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ThemePreset,
    },
  ];
  layout?: LayoutConfig;
  style?: StyleConfig;
  selection?: SelectionConfig;
  editing?: EditConfig;
  scrolling?: ScrollConfig;
  outline?: OutlineConfig;
  span?: SpanConfig;
  interaction?: InteractionConfig;
  rendering?: RenderConfig;
  version: string = "";
  indicators?: IndicatorsConfig;
  themePreset: ThemePreset = 0;

  constructor(init?: Partial<GridConfig>) {
    initMessage(this, GridConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GridConfig {
    return decodeMessage(GridConfig, data);
  }

  static parseFrom(data: Uint8Array): GridConfig {
    return GridConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GridConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GridConfig.fields);
  }
}
registerMessage(GridConfig);
export enum GridEventEventOneofCase {
  None = 0,
  CellFocusChanging = 2,
  CellFocusChanged = 3,
  SelectionChanging = 4,
  SelectionChanged = 5,
  EnterCell = 6,
  LeaveCell = 7,
  BeforeEdit = 8,
  StartEdit = 9,
  AfterEdit = 10,
  CellEditValidate = 11,
  CellEditChange = 12,
  KeyDownEdit = 13,
  KeyPressEdit = 14,
  KeyUpEdit = 15,
  EditValidationRequest = 16,
  EditorListItemsRequest = 17,
  CustomEditorAction = 18,
  CellChanged = 19,
  RowStatusChange = 20,
  BeforeSort = 21,
  AfterSort = 22,
  Compare = 23,
  BeforeNodeToggle = 24,
  AfterNodeToggle = 25,
  BeforeScroll = 26,
  AfterScroll = 27,
  ScrollTooltip = 28,
  BeforeUserResize = 29,
  AfterUserResize = 30,
  AfterUserFreeze = 31,
  BeforeMoveColumn = 32,
  AfterMoveColumn = 33,
  BeforeMoveRow = 34,
  AfterMoveRow = 35,
  BeforeMouseDown = 36,
  MouseDown = 37,
  MouseUp = 38,
  MouseMove = 39,
  Click = 40,
  DblClick = 41,
  KeyDown = 42,
  KeyPress = 43,
  KeyUp = 44,
  CustomRenderCell = 45,
  DragStart = 46,
  DragOver = 47,
  DragDrop = 48,
  DragComplete = 49,
  TypeAheadStarted = 50,
  TypeAheadEnded = 51,
  DataRefreshing = 52,
  DataRefreshed = 53,
  FilterData = 54,
  Error = 55,
  BeforePageBreak = 56,
  StartPage = 57,
  GetHeaderRow = 58,
  PullToRefreshTriggered = 59,
  PullToRefreshCanceled = 60,
  TreeChildrenRequested = 61,
  BeforeTreeNodeToggle = 62,
  AfterTreeNodeToggle = 63,
  TreeNodeActivate = 64,
  TreeNodeContextMenu = 65,
}
export class GridEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GridEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 100,
      name: "event_id",
      jsonName: "eventId",
      prop: "eventId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "cell_focus_changing",
      jsonName: "cellFocusChanging",
      prop: "cellFocusChanging",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CellFocusChanging,
      messageType: "CellFocusChangingEvent",
    },
    {
      no: 3,
      name: "cell_focus_changed",
      jsonName: "cellFocusChanged",
      prop: "cellFocusChanged",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CellFocusChanged,
      messageType: "CellFocusChangedEvent",
    },
    {
      no: 4,
      name: "selection_changing",
      jsonName: "selectionChanging",
      prop: "selectionChanging",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.SelectionChanging,
      messageType: "SelectionChangingEvent",
    },
    {
      no: 5,
      name: "selection_changed",
      jsonName: "selectionChanged",
      prop: "selectionChanged",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.SelectionChanged,
      messageType: "SelectionChangedEvent",
    },
    {
      no: 6,
      name: "enter_cell",
      jsonName: "enterCell",
      prop: "enterCell",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.EnterCell,
      messageType: "EnterCellEvent",
    },
    {
      no: 7,
      name: "leave_cell",
      jsonName: "leaveCell",
      prop: "leaveCell",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.LeaveCell,
      messageType: "LeaveCellEvent",
    },
    {
      no: 8,
      name: "before_edit",
      jsonName: "beforeEdit",
      prop: "beforeEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeEdit,
      messageType: "BeforeEditEvent",
    },
    {
      no: 9,
      name: "start_edit",
      jsonName: "startEdit",
      prop: "startEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.StartEdit,
      messageType: "StartEditEvent",
    },
    {
      no: 10,
      name: "after_edit",
      jsonName: "afterEdit",
      prop: "afterEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterEdit,
      messageType: "AfterEditEvent",
    },
    {
      no: 11,
      name: "cell_edit_validate",
      jsonName: "cellEditValidate",
      prop: "cellEditValidate",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CellEditValidate,
      messageType: "CellEditValidateEvent",
    },
    {
      no: 12,
      name: "cell_edit_change",
      jsonName: "cellEditChange",
      prop: "cellEditChange",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CellEditChange,
      messageType: "CellEditChangeEvent",
    },
    {
      no: 13,
      name: "key_down_edit",
      jsonName: "keyDownEdit",
      prop: "keyDownEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyDownEdit,
      messageType: "KeyDownEditEvent",
    },
    {
      no: 14,
      name: "key_press_edit",
      jsonName: "keyPressEdit",
      prop: "keyPressEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyPressEdit,
      messageType: "KeyPressEditEvent",
    },
    {
      no: 15,
      name: "key_up_edit",
      jsonName: "keyUpEdit",
      prop: "keyUpEdit",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyUpEdit,
      messageType: "KeyUpEditEvent",
    },
    {
      no: 16,
      name: "edit_validation_request",
      jsonName: "editValidationRequest",
      prop: "editValidationRequest",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.EditValidationRequest,
      messageType: "EditValidationRequest",
    },
    {
      no: 17,
      name: "editor_list_items_request",
      jsonName: "editorListItemsRequest",
      prop: "editorListItemsRequest",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.EditorListItemsRequest,
      messageType: "EditorListItemsRequest",
    },
    {
      no: 18,
      name: "custom_editor_action",
      jsonName: "customEditorAction",
      prop: "customEditorAction",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CustomEditorAction,
      messageType: "CustomEditorActionEvent",
    },
    {
      no: 19,
      name: "cell_changed",
      jsonName: "cellChanged",
      prop: "cellChanged",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CellChanged,
      messageType: "CellChangedEvent",
    },
    {
      no: 20,
      name: "row_status_change",
      jsonName: "rowStatusChange",
      prop: "rowStatusChange",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.RowStatusChange,
      messageType: "RowStatusChangeEvent",
    },
    {
      no: 21,
      name: "before_sort",
      jsonName: "beforeSort",
      prop: "beforeSort",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeSort,
      messageType: "BeforeSortEvent",
    },
    {
      no: 22,
      name: "after_sort",
      jsonName: "afterSort",
      prop: "afterSort",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterSort,
      messageType: "AfterSortEvent",
    },
    {
      no: 23,
      name: "compare",
      jsonName: "compare",
      prop: "compare",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.Compare,
      messageType: "CompareEvent",
    },
    {
      no: 24,
      name: "before_node_toggle",
      jsonName: "beforeNodeToggle",
      prop: "beforeNodeToggle",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeNodeToggle,
      messageType: "BeforeNodeToggleEvent",
    },
    {
      no: 25,
      name: "after_node_toggle",
      jsonName: "afterNodeToggle",
      prop: "afterNodeToggle",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterNodeToggle,
      messageType: "AfterNodeToggleEvent",
    },
    {
      no: 26,
      name: "before_scroll",
      jsonName: "beforeScroll",
      prop: "beforeScroll",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeScroll,
      messageType: "BeforeScrollEvent",
    },
    {
      no: 27,
      name: "after_scroll",
      jsonName: "afterScroll",
      prop: "afterScroll",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterScroll,
      messageType: "AfterScrollEvent",
    },
    {
      no: 28,
      name: "scroll_tooltip",
      jsonName: "scrollTooltip",
      prop: "scrollTooltip",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.ScrollTooltip,
      messageType: "ScrollTooltipEvent",
    },
    {
      no: 29,
      name: "before_user_resize",
      jsonName: "beforeUserResize",
      prop: "beforeUserResize",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeUserResize,
      messageType: "BeforeUserResizeEvent",
    },
    {
      no: 30,
      name: "after_user_resize",
      jsonName: "afterUserResize",
      prop: "afterUserResize",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterUserResize,
      messageType: "AfterUserResizeEvent",
    },
    {
      no: 31,
      name: "after_user_freeze",
      jsonName: "afterUserFreeze",
      prop: "afterUserFreeze",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterUserFreeze,
      messageType: "AfterUserFreezeEvent",
    },
    {
      no: 32,
      name: "before_move_column",
      jsonName: "beforeMoveColumn",
      prop: "beforeMoveColumn",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeMoveColumn,
      messageType: "BeforeMoveColumnEvent",
    },
    {
      no: 33,
      name: "after_move_column",
      jsonName: "afterMoveColumn",
      prop: "afterMoveColumn",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterMoveColumn,
      messageType: "AfterMoveColumnEvent",
    },
    {
      no: 34,
      name: "before_move_row",
      jsonName: "beforeMoveRow",
      prop: "beforeMoveRow",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeMoveRow,
      messageType: "BeforeMoveRowEvent",
    },
    {
      no: 35,
      name: "after_move_row",
      jsonName: "afterMoveRow",
      prop: "afterMoveRow",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterMoveRow,
      messageType: "AfterMoveRowEvent",
    },
    {
      no: 36,
      name: "before_mouse_down",
      jsonName: "beforeMouseDown",
      prop: "beforeMouseDown",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeMouseDown,
      messageType: "BeforeMouseDownEvent",
    },
    {
      no: 37,
      name: "mouse_down",
      jsonName: "mouseDown",
      prop: "mouseDown",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.MouseDown,
      messageType: "MouseDownEvent",
    },
    {
      no: 38,
      name: "mouse_up",
      jsonName: "mouseUp",
      prop: "mouseUp",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.MouseUp,
      messageType: "MouseUpEvent",
    },
    {
      no: 39,
      name: "mouse_move",
      jsonName: "mouseMove",
      prop: "mouseMove",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.MouseMove,
      messageType: "MouseMoveEvent",
    },
    {
      no: 40,
      name: "click",
      jsonName: "click",
      prop: "click",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.Click,
      messageType: "ClickEvent",
    },
    {
      no: 41,
      name: "dbl_click",
      jsonName: "dblClick",
      prop: "dblClick",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DblClick,
      messageType: "DblClickEvent",
    },
    {
      no: 42,
      name: "key_down",
      jsonName: "keyDown",
      prop: "keyDown",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyDown,
      messageType: "KeyDownEvent",
    },
    {
      no: 43,
      name: "key_press",
      jsonName: "keyPress",
      prop: "keyPress",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyPress,
      messageType: "KeyPressEvent",
    },
    {
      no: 44,
      name: "key_up",
      jsonName: "keyUp",
      prop: "keyUp",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.KeyUp,
      messageType: "KeyUpEvent",
    },
    {
      no: 45,
      name: "custom_render_cell",
      jsonName: "customRenderCell",
      prop: "customRenderCell",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.CustomRenderCell,
      messageType: "CustomRenderCellEvent",
    },
    {
      no: 46,
      name: "drag_start",
      jsonName: "dragStart",
      prop: "dragStart",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DragStart,
      messageType: "DragStartEvent",
    },
    {
      no: 47,
      name: "drag_over",
      jsonName: "dragOver",
      prop: "dragOver",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DragOver,
      messageType: "DragOverEvent",
    },
    {
      no: 48,
      name: "drag_drop",
      jsonName: "dragDrop",
      prop: "dragDrop",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DragDrop,
      messageType: "DragDropEvent",
    },
    {
      no: 49,
      name: "drag_complete",
      jsonName: "dragComplete",
      prop: "dragComplete",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DragComplete,
      messageType: "DragCompleteEvent",
    },
    {
      no: 50,
      name: "type_ahead_started",
      jsonName: "typeAheadStarted",
      prop: "typeAheadStarted",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.TypeAheadStarted,
      messageType: "TypeAheadStartedEvent",
    },
    {
      no: 51,
      name: "type_ahead_ended",
      jsonName: "typeAheadEnded",
      prop: "typeAheadEnded",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.TypeAheadEnded,
      messageType: "TypeAheadEndedEvent",
    },
    {
      no: 52,
      name: "data_refreshing",
      jsonName: "dataRefreshing",
      prop: "dataRefreshing",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DataRefreshing,
      messageType: "DataRefreshingEvent",
    },
    {
      no: 53,
      name: "data_refreshed",
      jsonName: "dataRefreshed",
      prop: "dataRefreshed",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.DataRefreshed,
      messageType: "DataRefreshedEvent",
    },
    {
      no: 54,
      name: "filter_data",
      jsonName: "filterData",
      prop: "filterData",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.FilterData,
      messageType: "FilterDataEvent",
    },
    {
      no: 55,
      name: "error",
      jsonName: "error",
      prop: "error",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.Error,
      messageType: "ErrorEvent",
    },
    {
      no: 56,
      name: "before_page_break",
      jsonName: "beforePageBreak",
      prop: "beforePageBreak",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforePageBreak,
      messageType: "BeforePageBreakEvent",
    },
    {
      no: 57,
      name: "start_page",
      jsonName: "startPage",
      prop: "startPage",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.StartPage,
      messageType: "StartPageEvent",
    },
    {
      no: 58,
      name: "get_header_row",
      jsonName: "getHeaderRow",
      prop: "getHeaderRow",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.GetHeaderRow,
      messageType: "GetHeaderRowEvent",
    },
    {
      no: 59,
      name: "pull_to_refresh_triggered",
      jsonName: "pullToRefreshTriggered",
      prop: "pullToRefreshTriggered",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.PullToRefreshTriggered,
      messageType: "PullToRefreshTriggeredEvent",
    },
    {
      no: 60,
      name: "pull_to_refresh_canceled",
      jsonName: "pullToRefreshCanceled",
      prop: "pullToRefreshCanceled",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.PullToRefreshCanceled,
      messageType: "PullToRefreshCanceledEvent",
    },
    {
      no: 61,
      name: "tree_children_requested",
      jsonName: "treeChildrenRequested",
      prop: "treeChildrenRequested",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.TreeChildrenRequested,
      messageType: "TreeChildrenRequestedEvent",
    },
    {
      no: 62,
      name: "before_tree_node_toggle",
      jsonName: "beforeTreeNodeToggle",
      prop: "beforeTreeNodeToggle",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.BeforeTreeNodeToggle,
      messageType: "BeforeTreeNodeToggleEvent",
    },
    {
      no: 63,
      name: "after_tree_node_toggle",
      jsonName: "afterTreeNodeToggle",
      prop: "afterTreeNodeToggle",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.AfterTreeNodeToggle,
      messageType: "AfterTreeNodeToggleEvent",
    },
    {
      no: 64,
      name: "tree_node_activate",
      jsonName: "treeNodeActivate",
      prop: "treeNodeActivate",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.TreeNodeActivate,
      messageType: "TreeNodeActivateEvent",
    },
    {
      no: 65,
      name: "tree_node_context_menu",
      jsonName: "treeNodeContextMenu",
      prop: "treeNodeContextMenu",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: GridEventEventOneofCase.TreeNodeContextMenu,
      messageType: "TreeNodeContextMenuEvent",
    },
  ];
  eventCase: GridEventEventOneofCase = GridEventEventOneofCase.None;
  gridId: bigint = 0n;
  eventId: bigint = 0n;
  cellFocusChanging?: CellFocusChangingEvent;
  cellFocusChanged?: CellFocusChangedEvent;
  selectionChanging?: SelectionChangingEvent;
  selectionChanged?: SelectionChangedEvent;
  enterCell?: EnterCellEvent;
  leaveCell?: LeaveCellEvent;
  beforeEdit?: BeforeEditEvent;
  startEdit?: StartEditEvent;
  afterEdit?: AfterEditEvent;
  cellEditValidate?: CellEditValidateEvent;
  cellEditChange?: CellEditChangeEvent;
  keyDownEdit?: KeyDownEditEvent;
  keyPressEdit?: KeyPressEditEvent;
  keyUpEdit?: KeyUpEditEvent;
  editValidationRequest?: EditValidationRequest;
  editorListItemsRequest?: EditorListItemsRequest;
  customEditorAction?: CustomEditorActionEvent;
  cellChanged?: CellChangedEvent;
  rowStatusChange?: RowStatusChangeEvent;
  beforeSort?: BeforeSortEvent;
  afterSort?: AfterSortEvent;
  compare?: CompareEvent;
  beforeNodeToggle?: BeforeNodeToggleEvent;
  afterNodeToggle?: AfterNodeToggleEvent;
  beforeScroll?: BeforeScrollEvent;
  afterScroll?: AfterScrollEvent;
  scrollTooltip?: ScrollTooltipEvent;
  beforeUserResize?: BeforeUserResizeEvent;
  afterUserResize?: AfterUserResizeEvent;
  afterUserFreeze?: AfterUserFreezeEvent;
  beforeMoveColumn?: BeforeMoveColumnEvent;
  afterMoveColumn?: AfterMoveColumnEvent;
  beforeMoveRow?: BeforeMoveRowEvent;
  afterMoveRow?: AfterMoveRowEvent;
  beforeMouseDown?: BeforeMouseDownEvent;
  mouseDown?: MouseDownEvent;
  mouseUp?: MouseUpEvent;
  mouseMove?: MouseMoveEvent;
  click?: ClickEvent;
  dblClick?: DblClickEvent;
  keyDown?: KeyDownEvent;
  keyPress?: KeyPressEvent;
  keyUp?: KeyUpEvent;
  customRenderCell?: CustomRenderCellEvent;
  dragStart?: DragStartEvent;
  dragOver?: DragOverEvent;
  dragDrop?: DragDropEvent;
  dragComplete?: DragCompleteEvent;
  typeAheadStarted?: TypeAheadStartedEvent;
  typeAheadEnded?: TypeAheadEndedEvent;
  dataRefreshing?: DataRefreshingEvent;
  dataRefreshed?: DataRefreshedEvent;
  filterData?: FilterDataEvent;
  error?: ErrorEvent;
  beforePageBreak?: BeforePageBreakEvent;
  startPage?: StartPageEvent;
  getHeaderRow?: GetHeaderRowEvent;
  pullToRefreshTriggered?: PullToRefreshTriggeredEvent;
  pullToRefreshCanceled?: PullToRefreshCanceledEvent;
  treeChildrenRequested?: TreeChildrenRequestedEvent;
  beforeTreeNodeToggle?: BeforeTreeNodeToggleEvent;
  afterTreeNodeToggle?: AfterTreeNodeToggleEvent;
  treeNodeActivate?: TreeNodeActivateEvent;
  treeNodeContextMenu?: TreeNodeContextMenuEvent;

  constructor(init?: Partial<GridEvent>) {
    initMessage(this, GridEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GridEvent {
    return decodeMessage(GridEvent, data);
  }

  static parseFrom(data: Uint8Array): GridEvent {
    return GridEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GridEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GridEvent.fields);
  }
}
registerMessage(GridEvent);
export class GridEventTarget implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GridEventTarget" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "kind",
      jsonName: "kind",
      prop: "kind",
      kind: "enum" as ProtoKind,
      enumType: GridTargetKind,
    },
    {
      no: 2,
      name: "band",
      jsonName: "band",
      prop: "band",
      kind: "enum" as ProtoKind,
      enumType: IndicatorBand,
    },
    {
      no: 3,
      name: "slot_index",
      jsonName: "slotIndex",
      prop: "slotIndex",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "slot_kind",
      jsonName: "slotKind",
      prop: "slotKind",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "custom_key",
      jsonName: "customKey",
      prop: "customKey",
      kind: "string" as ProtoKind,
    },
    {
      no: 6,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 7,
      name: "int_value",
      jsonName: "intValue",
      prop: "intValue",
      kind: "int64" as ProtoKind,
    },
    {
      no: 8,
      name: "status_flags",
      jsonName: "statusFlags",
      prop: "statusFlags",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 9,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 10,
      name: "sub_mode",
      jsonName: "subMode",
      prop: "subMode",
      kind: "int32" as ProtoKind,
    },
  ];
  kind: GridTargetKind = 0;
  band: IndicatorBand = 0;
  slotIndex: number = 0;
  slotKind: number = 0;
  customKey: string = "";
  text: string = "";
  intValue: bigint = 0n;
  statusFlags: number = 0;
  data?: Uint8Array;
  subMode: number = 0;

  constructor(init?: Partial<GridEventTarget>) {
    initMessage(this, GridEventTarget.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GridEventTarget {
    return decodeMessage(GridEventTarget, data);
  }

  static parseFrom(data: Uint8Array): GridEventTarget {
    return GridEventTarget.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GridEventTarget.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GridEventTarget.fields);
  }
}
registerMessage(GridEventTarget);
export class GridLines implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.GridLines" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: GridLineStyle,
    },
    {
      no: 2,
      name: "direction",
      jsonName: "direction",
      prop: "direction",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: GridLineDirection,
    },
    {
      no: 3,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  style: GridLineStyle = 0;
  direction: GridLineDirection = 0;
  color: number = 0;
  width: number = 0;

  constructor(init?: Partial<GridLines>) {
    initMessage(this, GridLines.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): GridLines {
    return decodeMessage(GridLines, data);
  }

  static parseFrom(data: Uint8Array): GridLines {
    return GridLines.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, GridLines.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, GridLines.fields);
  }
}
registerMessage(GridLines);
export class HeaderFeatures implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HeaderFeatures" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "sort",
      jsonName: "sort",
      prop: "sort",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "reorder",
      jsonName: "reorder",
      prop: "reorder",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "chooser",
      jsonName: "chooser",
      prop: "chooser",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  sort: boolean = false;
  reorder: boolean = false;
  chooser: boolean = false;

  constructor(init?: Partial<HeaderFeatures>) {
    initMessage(this, HeaderFeatures.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HeaderFeatures {
    return decodeMessage(HeaderFeatures, data);
  }

  static parseFrom(data: Uint8Array): HeaderFeatures {
    return HeaderFeatures.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HeaderFeatures.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HeaderFeatures.fields);
  }
}
registerMessage(HeaderFeatures);
export enum HeaderMarkSizeValueOneofCase {
  None = 0,
  Ratio = 1,
  Px = 2,
}
export class HeaderMarkSize implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HeaderMarkSize" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "ratio",
      jsonName: "ratio",
      prop: "ratio",
      kind: "float" as ProtoKind,
      oneof: "valueCase",
      oneofCase: HeaderMarkSizeValueOneofCase.Ratio,
    },
    {
      no: 2,
      name: "px",
      jsonName: "px",
      prop: "px",
      kind: "int32" as ProtoKind,
      oneof: "valueCase",
      oneofCase: HeaderMarkSizeValueOneofCase.Px,
    },
  ];
  valueCase: HeaderMarkSizeValueOneofCase = HeaderMarkSizeValueOneofCase.None;
  ratio?: number;
  px?: number;

  constructor(init?: Partial<HeaderMarkSize>) {
    initMessage(this, HeaderMarkSize.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HeaderMarkSize {
    return decodeMessage(HeaderMarkSize, data);
  }

  static parseFrom(data: Uint8Array): HeaderMarkSize {
    return HeaderMarkSize.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HeaderMarkSize.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HeaderMarkSize.fields);
  }
}
registerMessage(HeaderMarkSize);
export class HeaderResizeHandle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HeaderResizeHandle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "enabled",
      jsonName: "enabled",
      prop: "enabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "message" as ProtoKind,
      messageType: "HeaderMarkSize",
    },
    {
      no: 5,
      name: "hit_width",
      jsonName: "hitWidth",
      prop: "hitWidth",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "show_only_when_resizable",
      jsonName: "showOnlyWhenResizable",
      prop: "showOnlyWhenResizable",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  enabled: boolean = false;
  color: number = 0;
  width: number = 0;
  height?: HeaderMarkSize;
  hitWidth: number = 0;
  showOnlyWhenResizable: boolean = false;

  constructor(init?: Partial<HeaderResizeHandle>) {
    initMessage(this, HeaderResizeHandle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HeaderResizeHandle {
    return decodeMessage(HeaderResizeHandle, data);
  }

  static parseFrom(data: Uint8Array): HeaderResizeHandle {
    return HeaderResizeHandle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HeaderResizeHandle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HeaderResizeHandle.fields);
  }
}
registerMessage(HeaderResizeHandle);
export class HeaderSeparator implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HeaderSeparator" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "enabled",
      jsonName: "enabled",
      prop: "enabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "message" as ProtoKind,
      messageType: "HeaderMarkSize",
    },
    {
      no: 5,
      name: "skip_merged",
      jsonName: "skipMerged",
      prop: "skipMerged",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  enabled: boolean = false;
  color: number = 0;
  width: number = 0;
  height?: HeaderMarkSize;
  skipMerged: boolean = false;

  constructor(init?: Partial<HeaderSeparator>) {
    initMessage(this, HeaderSeparator.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HeaderSeparator {
    return decodeMessage(HeaderSeparator, data);
  }

  static parseFrom(data: Uint8Array): HeaderSeparator {
    return HeaderSeparator.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HeaderSeparator.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HeaderSeparator.fields);
  }
}
registerMessage(HeaderSeparator);
export class HeaderStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HeaderStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "separator",
      jsonName: "separator",
      prop: "separator",
      kind: "message" as ProtoKind,
      messageType: "HeaderSeparator",
    },
    {
      no: 2,
      name: "resize_handle",
      jsonName: "resizeHandle",
      prop: "resizeHandle",
      kind: "message" as ProtoKind,
      messageType: "HeaderResizeHandle",
    },
  ];
  separator?: HeaderSeparator;
  resizeHandle?: HeaderResizeHandle;

  constructor(init?: Partial<HeaderStyle>) {
    initMessage(this, HeaderStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HeaderStyle {
    return decodeMessage(HeaderStyle, data);
  }

  static parseFrom(data: Uint8Array): HeaderStyle {
    return HeaderStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HeaderStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HeaderStyle.fields);
  }
}
registerMessage(HeaderStyle);
export class HighlightRegion implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HighlightRegion" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "range",
      jsonName: "range",
      prop: "range",
      kind: "message" as ProtoKind,
      messageType: "CellRange",
    },
    {
      no: 2,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 3,
      name: "ref_id",
      jsonName: "refId",
      prop: "refId",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "text_start",
      jsonName: "textStart",
      prop: "textStart",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "text_length",
      jsonName: "textLength",
      prop: "textLength",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  range?: CellRange;
  style?: HighlightStyle;
  refId: number = 0;
  textStart: number = 0;
  textLength: number = 0;

  constructor(init?: Partial<HighlightRegion>) {
    initMessage(this, HighlightRegion.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HighlightRegion {
    return decodeMessage(HighlightRegion, data);
  }

  static parseFrom(data: Uint8Array): HighlightRegion {
    return HighlightRegion.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HighlightRegion.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HighlightRegion.fields);
  }
}
registerMessage(HighlightRegion);
export class HighlightStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HighlightStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "borders",
      jsonName: "borders",
      prop: "borders",
      kind: "message" as ProtoKind,
      messageType: "Borders",
    },
    {
      no: 4,
      name: "fill_handle",
      jsonName: "fillHandle",
      prop: "fillHandle",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: FillHandlePosition,
    },
    {
      no: 5,
      name: "fill_handle_color",
      jsonName: "fillHandleColor",
      prop: "fillHandleColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  background: number = 0;
  foreground: number = 0;
  borders?: Borders;
  fillHandle: FillHandlePosition = 0;
  fillHandleColor: number = 0;

  constructor(init?: Partial<HighlightStyle>) {
    initMessage(this, HighlightStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HighlightStyle {
    return decodeMessage(HighlightStyle, data);
  }

  static parseFrom(data: Uint8Array): HighlightStyle {
    return HighlightStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HighlightStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HighlightStyle.fields);
  }
}
registerMessage(HighlightStyle);
export class HoverConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.HoverConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "column",
      jsonName: "column",
      prop: "column",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "cell",
      jsonName: "cell",
      prop: "cell",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "row_style",
      jsonName: "rowStyle",
      prop: "rowStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 5,
      name: "column_style",
      jsonName: "columnStyle",
      prop: "columnStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 6,
      name: "cell_style",
      jsonName: "cellStyle",
      prop: "cellStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
  ];
  row: boolean = false;
  column: boolean = false;
  cell: boolean = false;
  rowStyle?: HighlightStyle;
  columnStyle?: HighlightStyle;
  cellStyle?: HighlightStyle;

  constructor(init?: Partial<HoverConfig>) {
    initMessage(this, HoverConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): HoverConfig {
    return decodeMessage(HoverConfig, data);
  }

  static parseFrom(data: Uint8Array): HoverConfig {
    return HoverConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, HoverConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, HoverConfig.fields);
  }
}
registerMessage(HoverConfig);
export class IconPictures implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IconPictures" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "sort_ascending",
      jsonName: "sortAscending",
      prop: "sortAscending",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 2,
      name: "sort_descending",
      jsonName: "sortDescending",
      prop: "sortDescending",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 3,
      name: "node_open",
      jsonName: "nodeOpen",
      prop: "nodeOpen",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 4,
      name: "node_closed",
      jsonName: "nodeClosed",
      prop: "nodeClosed",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 5,
      name: "checkbox_checked",
      jsonName: "checkboxChecked",
      prop: "checkboxChecked",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 6,
      name: "checkbox_unchecked",
      jsonName: "checkboxUnchecked",
      prop: "checkboxUnchecked",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
    {
      no: 7,
      name: "checkbox_indeterminate",
      jsonName: "checkboxIndeterminate",
      prop: "checkboxIndeterminate",
      kind: "message" as ProtoKind,
      messageType: "ImageData",
    },
  ];
  sortAscending?: ImageData;
  sortDescending?: ImageData;
  nodeOpen?: ImageData;
  nodeClosed?: ImageData;
  checkboxChecked?: ImageData;
  checkboxUnchecked?: ImageData;
  checkboxIndeterminate?: ImageData;

  constructor(init?: Partial<IconPictures>) {
    initMessage(this, IconPictures.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IconPictures {
    return decodeMessage(IconPictures, data);
  }

  static parseFrom(data: Uint8Array): IconPictures {
    return IconPictures.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IconPictures.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IconPictures.fields);
  }
}
registerMessage(IconPictures);
export class IconSlotStyles implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IconSlotStyles" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "sort_ascending",
      jsonName: "sortAscending",
      prop: "sortAscending",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 2,
      name: "sort_descending",
      jsonName: "sortDescending",
      prop: "sortDescending",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 3,
      name: "sort_none",
      jsonName: "sortNone",
      prop: "sortNone",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 4,
      name: "tree_expanded",
      jsonName: "treeExpanded",
      prop: "treeExpanded",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 5,
      name: "tree_collapsed",
      jsonName: "treeCollapsed",
      prop: "treeCollapsed",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 6,
      name: "menu",
      jsonName: "menu",
      prop: "menu",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 7,
      name: "filter",
      jsonName: "filter",
      prop: "filter",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 8,
      name: "filter_active",
      jsonName: "filterActive",
      prop: "filterActive",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 9,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 10,
      name: "drag_handle",
      jsonName: "dragHandle",
      prop: "dragHandle",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 11,
      name: "checkbox_checked",
      jsonName: "checkboxChecked",
      prop: "checkboxChecked",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 12,
      name: "checkbox_unchecked",
      jsonName: "checkboxUnchecked",
      prop: "checkboxUnchecked",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 13,
      name: "checkbox_indeterminate",
      jsonName: "checkboxIndeterminate",
      prop: "checkboxIndeterminate",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
  ];
  sortAscending?: IconStyle;
  sortDescending?: IconStyle;
  sortNone?: IconStyle;
  treeExpanded?: IconStyle;
  treeCollapsed?: IconStyle;
  menu?: IconStyle;
  filter?: IconStyle;
  filterActive?: IconStyle;
  columns?: IconStyle;
  dragHandle?: IconStyle;
  checkboxChecked?: IconStyle;
  checkboxUnchecked?: IconStyle;
  checkboxIndeterminate?: IconStyle;

  constructor(init?: Partial<IconSlotStyles>) {
    initMessage(this, IconSlotStyles.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IconSlotStyles {
    return decodeMessage(IconSlotStyles, data);
  }

  static parseFrom(data: Uint8Array): IconSlotStyles {
    return IconSlotStyles.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IconSlotStyles.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IconSlotStyles.fields);
  }
}
registerMessage(IconSlotStyles);
export class IconSlots implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IconSlots" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "sort_ascending",
      jsonName: "sortAscending",
      prop: "sortAscending",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "sort_descending",
      jsonName: "sortDescending",
      prop: "sortDescending",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "sort_none",
      jsonName: "sortNone",
      prop: "sortNone",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "tree_expanded",
      jsonName: "treeExpanded",
      prop: "treeExpanded",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "tree_collapsed",
      jsonName: "treeCollapsed",
      prop: "treeCollapsed",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "menu",
      jsonName: "menu",
      prop: "menu",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "filter",
      jsonName: "filter",
      prop: "filter",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "filter_active",
      jsonName: "filterActive",
      prop: "filterActive",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "drag_handle",
      jsonName: "dragHandle",
      prop: "dragHandle",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "checkbox_checked",
      jsonName: "checkboxChecked",
      prop: "checkboxChecked",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 12,
      name: "checkbox_unchecked",
      jsonName: "checkboxUnchecked",
      prop: "checkboxUnchecked",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 13,
      name: "checkbox_indeterminate",
      jsonName: "checkboxIndeterminate",
      prop: "checkboxIndeterminate",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  sortAscending: string = "";
  sortDescending: string = "";
  sortNone: string = "";
  treeExpanded: string = "";
  treeCollapsed: string = "";
  menu: string = "";
  filter: string = "";
  filterActive: string = "";
  columns: string = "";
  dragHandle: string = "";
  checkboxChecked: string = "";
  checkboxUnchecked: string = "";
  checkboxIndeterminate: string = "";

  constructor(init?: Partial<IconSlots>) {
    initMessage(this, IconSlots.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IconSlots {
    return decodeMessage(IconSlots, data);
  }

  static parseFrom(data: Uint8Array): IconSlots {
    return IconSlots.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IconSlots.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IconSlots.fields);
  }
}
registerMessage(IconSlots);
export class IconStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IconStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
    {
      no: 2,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "align",
      jsonName: "align",
      prop: "align",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: IconAlign,
    },
    {
      no: 4,
      name: "gap",
      jsonName: "gap",
      prop: "gap",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  font?: Font;
  color: number = 0;
  align: IconAlign = 0;
  gap: number = 0;

  constructor(init?: Partial<IconStyle>) {
    initMessage(this, IconStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IconStyle {
    return decodeMessage(IconStyle, data);
  }

  static parseFrom(data: Uint8Array): IconStyle {
    return IconStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IconStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IconStyle.fields);
  }
}
registerMessage(IconStyle);
export class IconTheme implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IconTheme" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "slots",
      jsonName: "slots",
      prop: "slots",
      kind: "message" as ProtoKind,
      messageType: "IconSlots",
    },
    {
      no: 2,
      name: "defaults",
      jsonName: "defaults",
      prop: "defaults",
      kind: "message" as ProtoKind,
      messageType: "IconStyle",
    },
    {
      no: 3,
      name: "overrides",
      jsonName: "overrides",
      prop: "overrides",
      kind: "message" as ProtoKind,
      messageType: "IconSlotStyles",
    },
    {
      no: 4,
      name: "pictures",
      jsonName: "pictures",
      prop: "pictures",
      kind: "message" as ProtoKind,
      messageType: "IconPictures",
    },
  ];
  slots?: IconSlots;
  defaults?: IconStyle;
  overrides?: IconSlotStyles;
  pictures?: IconPictures;

  constructor(init?: Partial<IconTheme>) {
    initMessage(this, IconTheme.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IconTheme {
    return decodeMessage(IconTheme, data);
  }

  static parseFrom(data: Uint8Array): IconTheme {
    return IconTheme.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IconTheme.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IconTheme.fields);
  }
}
registerMessage(IconTheme);
export class ImageData implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ImageData" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 2,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "string" as ProtoKind,
    },
  ];
  data?: Uint8Array;
  format: string = "";

  constructor(init?: Partial<ImageData>) {
    initMessage(this, ImageData.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ImageData {
    return decodeMessage(ImageData, data);
  }

  static parseFrom(data: Uint8Array): ImageData {
    return ImageData.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ImageData.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ImageData.fields);
  }
}
registerMessage(ImageData);
export class IndicatorColors implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IndicatorColors" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "grid",
      jsonName: "grid",
      prop: "grid",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "button_background",
      jsonName: "buttonBackground",
      prop: "buttonBackground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "button_foreground",
      jsonName: "buttonForeground",
      prop: "buttonForeground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "button_border",
      jsonName: "buttonBorder",
      prop: "buttonBorder",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "button_pressed_background",
      jsonName: "buttonPressedBackground",
      prop: "buttonPressedBackground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "button_pressed_foreground",
      jsonName: "buttonPressedForeground",
      prop: "buttonPressedForeground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "button_pressed_border_dark",
      jsonName: "buttonPressedBorderDark",
      prop: "buttonPressedBorderDark",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "button_pressed_border_light",
      jsonName: "buttonPressedBorderLight",
      prop: "buttonPressedBorderLight",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "button_hover_background",
      jsonName: "buttonHoverBackground",
      prop: "buttonHoverBackground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 12,
      name: "button_hover_foreground",
      jsonName: "buttonHoverForeground",
      prop: "buttonHoverForeground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 13,
      name: "button_hover_border",
      jsonName: "buttonHoverBorder",
      prop: "buttonHoverBorder",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  background: number = 0;
  foreground: number = 0;
  grid: number = 0;
  buttonBackground: number = 0;
  buttonForeground: number = 0;
  buttonBorder: number = 0;
  buttonPressedBackground: number = 0;
  buttonPressedForeground: number = 0;
  buttonPressedBorderDark: number = 0;
  buttonPressedBorderLight: number = 0;
  buttonHoverBackground: number = 0;
  buttonHoverForeground: number = 0;
  buttonHoverBorder: number = 0;

  constructor(init?: Partial<IndicatorColors>) {
    initMessage(this, IndicatorColors.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IndicatorColors {
    return decodeMessage(IndicatorColors, data);
  }

  static parseFrom(data: Uint8Array): IndicatorColors {
    return IndicatorColors.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IndicatorColors.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IndicatorColors.fields);
  }
}
registerMessage(IndicatorColors);
export class IndicatorFocusConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IndicatorFocusConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "enable_keyboard_focus",
      jsonName: "enableKeyboardFocus",
      prop: "enableKeyboardFocus",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "enter_key_code",
      jsonName: "enterKeyCode",
      prop: "enterKeyCode",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "exit_key_code",
      jsonName: "exitKeyCode",
      prop: "exitKeyCode",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  enableKeyboardFocus: boolean = false;
  enterKeyCode: number = 0;
  exitKeyCode: number = 0;

  constructor(init?: Partial<IndicatorFocusConfig>) {
    initMessage(this, IndicatorFocusConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IndicatorFocusConfig {
    return decodeMessage(IndicatorFocusConfig, data);
  }

  static parseFrom(data: Uint8Array): IndicatorFocusConfig {
    return IndicatorFocusConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IndicatorFocusConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IndicatorFocusConfig.fields);
  }
}
registerMessage(IndicatorFocusConfig);
export class IndicatorsConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.IndicatorsConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row_start",
      jsonName: "rowStart",
      prop: "rowStart",
      kind: "message" as ProtoKind,
      messageType: "RowIndicatorConfig",
    },
    {
      no: 2,
      name: "row_end",
      jsonName: "rowEnd",
      prop: "rowEnd",
      kind: "message" as ProtoKind,
      messageType: "RowIndicatorConfig",
    },
    {
      no: 3,
      name: "col_top",
      jsonName: "colTop",
      prop: "colTop",
      kind: "message" as ProtoKind,
      messageType: "ColIndicatorConfig",
    },
    {
      no: 4,
      name: "col_bottom",
      jsonName: "colBottom",
      prop: "colBottom",
      kind: "message" as ProtoKind,
      messageType: "ColIndicatorConfig",
    },
    {
      no: 5,
      name: "corner_top_start",
      jsonName: "cornerTopStart",
      prop: "cornerTopStart",
      kind: "message" as ProtoKind,
      messageType: "CornerIndicatorConfig",
    },
    {
      no: 6,
      name: "corner_top_end",
      jsonName: "cornerTopEnd",
      prop: "cornerTopEnd",
      kind: "message" as ProtoKind,
      messageType: "CornerIndicatorConfig",
    },
    {
      no: 7,
      name: "corner_bottom_start",
      jsonName: "cornerBottomStart",
      prop: "cornerBottomStart",
      kind: "message" as ProtoKind,
      messageType: "CornerIndicatorConfig",
    },
    {
      no: 8,
      name: "corner_bottom_end",
      jsonName: "cornerBottomEnd",
      prop: "cornerBottomEnd",
      kind: "message" as ProtoKind,
      messageType: "CornerIndicatorConfig",
    },
    {
      no: 9,
      name: "focus",
      jsonName: "focus",
      prop: "focus",
      kind: "message" as ProtoKind,
      messageType: "IndicatorFocusConfig",
    },
    {
      no: 10,
      name: "appearance",
      jsonName: "appearance",
      prop: "appearance",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: IndicatorAppearance,
    },
    {
      no: 11,
      name: "colors",
      jsonName: "colors",
      prop: "colors",
      kind: "message" as ProtoKind,
      messageType: "IndicatorColors",
    },
  ];
  rowStart?: RowIndicatorConfig;
  rowEnd?: RowIndicatorConfig;
  colTop?: ColIndicatorConfig;
  colBottom?: ColIndicatorConfig;
  cornerTopStart?: CornerIndicatorConfig;
  cornerTopEnd?: CornerIndicatorConfig;
  cornerBottomStart?: CornerIndicatorConfig;
  cornerBottomEnd?: CornerIndicatorConfig;
  focus?: IndicatorFocusConfig;
  appearance: IndicatorAppearance = 0;
  colors?: IndicatorColors;

  constructor(init?: Partial<IndicatorsConfig>) {
    initMessage(this, IndicatorsConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): IndicatorsConfig {
    return decodeMessage(IndicatorsConfig, data);
  }

  static parseFrom(data: Uint8Array): IndicatorsConfig {
    return IndicatorsConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, IndicatorsConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, IndicatorsConfig.fields);
  }
}
registerMessage(IndicatorsConfig);
export class InsertRowsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.InsertRowsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "index",
      jsonName: "index",
      prop: "index",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "count",
      jsonName: "count",
      prop: "count",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
      repeated: true,
    },
  ];
  gridId: bigint = 0n;
  index: number = 0;
  count: number = 0;
  text: string[] = [];

  constructor(init?: Partial<InsertRowsRequest>) {
    initMessage(this, InsertRowsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): InsertRowsRequest {
    return decodeMessage(InsertRowsRequest, data);
  }

  static parseFrom(data: Uint8Array): InsertRowsRequest {
    return InsertRowsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, InsertRowsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, InsertRowsRequest.fields);
  }
}
registerMessage(InsertRowsRequest);
export class InsertRowsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.InsertRowsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "inserted_count",
      jsonName: "insertedCount",
      prop: "insertedCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "new_row_count",
      jsonName: "newRowCount",
      prop: "newRowCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "first_row",
      jsonName: "firstRow",
      prop: "firstRow",
      kind: "int32" as ProtoKind,
    },
  ];
  insertedCount: number = 0;
  newRowCount: number = 0;
  firstRow: number = 0;

  constructor(init?: Partial<InsertRowsResponse>) {
    initMessage(this, InsertRowsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): InsertRowsResponse {
    return decodeMessage(InsertRowsResponse, data);
  }

  static parseFrom(data: Uint8Array): InsertRowsResponse {
    return InsertRowsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, InsertRowsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, InsertRowsResponse.fields);
  }
}
registerMessage(InsertRowsResponse);
export class InteractionConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.InteractionConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "resize",
      jsonName: "resize",
      prop: "resize",
      kind: "message" as ProtoKind,
      messageType: "ResizePolicy",
    },
    {
      no: 2,
      name: "freeze",
      jsonName: "freeze",
      prop: "freeze",
      kind: "message" as ProtoKind,
      messageType: "FreezePolicy",
    },
    {
      no: 3,
      name: "type_ahead",
      jsonName: "typeAhead",
      prop: "typeAhead",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TypeAheadMode,
    },
    {
      no: 4,
      name: "type_ahead_delay",
      jsonName: "typeAheadDelay",
      prop: "typeAheadDelay",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "auto_size_mouse",
      jsonName: "autoSizeMouse",
      prop: "autoSizeMouse",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "auto_size_mode",
      jsonName: "autoSizeMode",
      prop: "autoSizeMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: AutoSizeMode,
    },
    {
      no: 7,
      name: "auto_resize",
      jsonName: "autoResize",
      prop: "autoResize",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "drag_mode",
      jsonName: "dragMode",
      prop: "dragMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: DragMode,
    },
    {
      no: 9,
      name: "drop_mode",
      jsonName: "dropMode",
      prop: "dropMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: DropMode,
    },
    {
      no: 10,
      name: "header_features",
      jsonName: "headerFeatures",
      prop: "headerFeatures",
      kind: "message" as ProtoKind,
      messageType: "HeaderFeatures",
    },
    {
      no: 11,
      name: "decision_timeout_ms",
      jsonName: "decisionTimeoutMs",
      prop: "decisionTimeoutMs",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 12,
      name: "compare_response_timeout_ms",
      jsonName: "compareResponseTimeoutMs",
      prop: "compareResponseTimeoutMs",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  resize?: ResizePolicy;
  freeze?: FreezePolicy;
  typeAhead: TypeAheadMode = 0;
  typeAheadDelay: number = 0;
  autoSizeMouse: boolean = false;
  autoSizeMode: AutoSizeMode = 0;
  autoResize: boolean = false;
  dragMode: DragMode = 0;
  dropMode: DropMode = 0;
  headerFeatures?: HeaderFeatures;
  decisionTimeoutMs: number = 0;
  compareResponseTimeoutMs: number = 0;

  constructor(init?: Partial<InteractionConfig>) {
    initMessage(this, InteractionConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): InteractionConfig {
    return decodeMessage(InteractionConfig, data);
  }

  static parseFrom(data: Uint8Array): InteractionConfig {
    return InteractionConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, InteractionConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, InteractionConfig.fields);
  }
}
registerMessage(InteractionConfig);
export class JsonOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.JsonOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data_path",
      jsonName: "dataPath",
      prop: "dataPath",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  dataPath: string = "";

  constructor(init?: Partial<JsonOptions>) {
    initMessage(this, JsonOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): JsonOptions {
    return decodeMessage(JsonOptions, data);
  }

  static parseFrom(data: Uint8Array): JsonOptions {
    return JsonOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, JsonOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, JsonOptions.fields);
  }
}
registerMessage(JsonOptions);
export class KeyDownEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyDownEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "key_code",
      jsonName: "keyCode",
      prop: "keyCode",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
  ];
  sessionId: bigint = 0n;
  keyCode: number = 0;
  modifier: number = 0;

  constructor(init?: Partial<KeyDownEditEvent>) {
    initMessage(this, KeyDownEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyDownEditEvent {
    return decodeMessage(KeyDownEditEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyDownEditEvent {
    return KeyDownEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyDownEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyDownEditEvent.fields);
  }
}
registerMessage(KeyDownEditEvent);
export class KeyDownEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyDownEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "key_code",
      jsonName: "keyCode",
      prop: "keyCode",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
  ];
  keyCode: number = 0;
  modifier: number = 0;

  constructor(init?: Partial<KeyDownEvent>) {
    initMessage(this, KeyDownEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyDownEvent {
    return decodeMessage(KeyDownEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyDownEvent {
    return KeyDownEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyDownEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyDownEvent.fields);
  }
}
registerMessage(KeyDownEvent);
export class KeyEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "type",
      jsonName: "type",
      prop: "type",
      kind: "enum" as ProtoKind,
      enumType: KeyEvent_Type,
    },
    {
      no: 2,
      name: "key_code",
      jsonName: "keyCode",
      prop: "keyCode",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "character",
      jsonName: "character",
      prop: "character",
      kind: "string" as ProtoKind,
    },
  ];
  type: KeyEvent_Type = 0;
  keyCode: number = 0;
  modifier: number = 0;
  character: string = "";

  constructor(init?: Partial<KeyEvent>) {
    initMessage(this, KeyEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyEvent {
    return decodeMessage(KeyEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyEvent {
    return KeyEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyEvent.fields);
  }
}
registerMessage(KeyEvent);
export class KeyPressEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyPressEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "key_ascii",
      jsonName: "keyAscii",
      prop: "keyAscii",
      kind: "int32" as ProtoKind,
    },
  ];
  sessionId: bigint = 0n;
  keyAscii: number = 0;

  constructor(init?: Partial<KeyPressEditEvent>) {
    initMessage(this, KeyPressEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyPressEditEvent {
    return decodeMessage(KeyPressEditEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyPressEditEvent {
    return KeyPressEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyPressEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyPressEditEvent.fields);
  }
}
registerMessage(KeyPressEditEvent);
export class KeyPressEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyPressEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "key_ascii",
      jsonName: "keyAscii",
      prop: "keyAscii",
      kind: "int32" as ProtoKind,
    },
  ];
  keyAscii: number = 0;

  constructor(init?: Partial<KeyPressEvent>) {
    initMessage(this, KeyPressEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyPressEvent {
    return decodeMessage(KeyPressEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyPressEvent {
    return KeyPressEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyPressEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyPressEvent.fields);
  }
}
registerMessage(KeyPressEvent);
export class KeyUpEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyUpEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "session_id",
      jsonName: "sessionId",
      prop: "sessionId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "key_code",
      jsonName: "keyCode",
      prop: "keyCode",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
  ];
  sessionId: bigint = 0n;
  keyCode: number = 0;
  modifier: number = 0;

  constructor(init?: Partial<KeyUpEditEvent>) {
    initMessage(this, KeyUpEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyUpEditEvent {
    return decodeMessage(KeyUpEditEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyUpEditEvent {
    return KeyUpEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyUpEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyUpEditEvent.fields);
  }
}
registerMessage(KeyUpEditEvent);
export class KeyUpEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.KeyUpEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "key_code",
      jsonName: "keyCode",
      prop: "keyCode",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
  ];
  keyCode: number = 0;
  modifier: number = 0;

  constructor(init?: Partial<KeyUpEvent>) {
    initMessage(this, KeyUpEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): KeyUpEvent {
    return decodeMessage(KeyUpEvent, data);
  }

  static parseFrom(data: Uint8Array): KeyUpEvent {
    return KeyUpEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, KeyUpEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, KeyUpEvent.fields);
  }
}
registerMessage(KeyUpEvent);
export class LayoutConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LayoutConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "cols",
      jsonName: "cols",
      prop: "cols",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "fixed_rows",
      jsonName: "fixedRows",
      prop: "fixedRows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "fixed_cols",
      jsonName: "fixedCols",
      prop: "fixedCols",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "frozen_rows",
      jsonName: "frozenRows",
      prop: "frozenRows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "frozen_cols",
      jsonName: "frozenCols",
      prop: "frozenCols",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "default_row_height",
      jsonName: "defaultRowHeight",
      prop: "defaultRowHeight",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "default_col_width",
      jsonName: "defaultColWidth",
      prop: "defaultColWidth",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "right_to_left",
      jsonName: "rightToLeft",
      prop: "rightToLeft",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "extend_last_col",
      jsonName: "extendLastCol",
      prop: "extendLastCol",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  rows: number = 0;
  cols: number = 0;
  fixedRows: number = 0;
  fixedCols: number = 0;
  frozenRows: number = 0;
  frozenCols: number = 0;
  defaultRowHeight: number = 0;
  defaultColWidth: number = 0;
  rightToLeft: boolean = false;
  extendLastCol: boolean = false;

  constructor(init?: Partial<LayoutConfig>) {
    initMessage(this, LayoutConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LayoutConfig {
    return decodeMessage(LayoutConfig, data);
  }

  static parseFrom(data: Uint8Array): LayoutConfig {
    return LayoutConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LayoutConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LayoutConfig.fields);
  }
}
registerMessage(LayoutConfig);
export class LeaveCellEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LeaveCellEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  row: number = 0;
  col: number = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<LeaveCellEvent>) {
    initMessage(this, LeaveCellEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LeaveCellEvent {
    return decodeMessage(LeaveCellEvent, data);
  }

  static parseFrom(data: Uint8Array): LeaveCellEvent {
    return LeaveCellEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LeaveCellEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LeaveCellEvent.fields);
  }
}
registerMessage(LeaveCellEvent);
export class ListDataSource implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ListDataSource" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data_source_id",
      jsonName: "dataSourceId",
      prop: "dataSourceId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "filterable",
      jsonName: "filterable",
      prop: "filterable",
      kind: "bool" as ProtoKind,
    },
    {
      no: 3,
      name: "pageable",
      jsonName: "pageable",
      prop: "pageable",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "page_size",
      jsonName: "pageSize",
      prop: "pageSize",
      kind: "int32" as ProtoKind,
    },
  ];
  dataSourceId: string = "";
  filterable: boolean = false;
  pageable: boolean = false;
  pageSize: number = 0;

  constructor(init?: Partial<ListDataSource>) {
    initMessage(this, ListDataSource.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ListDataSource {
    return decodeMessage(ListDataSource, data);
  }

  static parseFrom(data: Uint8Array): ListDataSource {
    return ListDataSource.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ListDataSource.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ListDataSource.fields);
  }
}
registerMessage(ListDataSource);
export class ListEditorParams implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ListEditorParams" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "static_items",
      jsonName: "staticItems",
      prop: "staticItems",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ListItem",
    },
    {
      no: 2,
      name: "data_source",
      jsonName: "dataSource",
      prop: "dataSource",
      kind: "message" as ProtoKind,
      messageType: "ListDataSource",
    },
    {
      no: 3,
      name: "allow_custom_value",
      jsonName: "allowCustomValue",
      prop: "allowCustomValue",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "searchable",
      jsonName: "searchable",
      prop: "searchable",
      kind: "bool" as ProtoKind,
    },
    {
      no: 5,
      name: "multi_select",
      jsonName: "multiSelect",
      prop: "multiSelect",
      kind: "bool" as ProtoKind,
    },
    {
      no: 6,
      name: "item_layout",
      jsonName: "itemLayout",
      prop: "itemLayout",
      kind: "enum" as ProtoKind,
      enumType: DropdownItemLayout,
    },
  ];
  staticItems: ListItem[] = [];
  dataSource?: ListDataSource;
  allowCustomValue: boolean = false;
  searchable: boolean = false;
  multiSelect: boolean = false;
  itemLayout: DropdownItemLayout = 0;

  constructor(init?: Partial<ListEditorParams>) {
    initMessage(this, ListEditorParams.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ListEditorParams {
    return decodeMessage(ListEditorParams, data);
  }

  static parseFrom(data: Uint8Array): ListEditorParams {
    return ListEditorParams.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ListEditorParams.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ListEditorParams.fields);
  }
}
registerMessage(ListEditorParams);
export class ListItem implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ListItem" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "CellValue",
    },
    {
      no: 2,
      name: "label",
      jsonName: "label",
      prop: "label",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "details",
      jsonName: "details",
      prop: "details",
      kind: "string" as ProtoKind,
      repeated: true,
    },
    {
      no: 4,
      name: "disabled",
      jsonName: "disabled",
      prop: "disabled",
      kind: "bool" as ProtoKind,
    },
  ];
  value?: CellValue;
  label: string = "";
  details: string[] = [];
  disabled: boolean = false;

  constructor(init?: Partial<ListItem>) {
    initMessage(this, ListItem.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ListItem {
    return decodeMessage(ListItem, data);
  }

  static parseFrom(data: Uint8Array): ListItem {
    return ListItem.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ListItem.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ListItem.fields);
  }
}
registerMessage(ListItem);
export enum LoadDataOptionsFormatOneofCase {
  None = 0,
  Csv = 1,
  Json = 2,
}
export class LoadDataOptions implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadDataOptions" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "csv",
      jsonName: "csv",
      prop: "csv",
      kind: "message" as ProtoKind,
      oneof: "formatCase",
      oneofCase: LoadDataOptionsFormatOneofCase.Csv,
      messageType: "CsvOptions",
    },
    {
      no: 2,
      name: "json",
      jsonName: "json",
      prop: "json",
      kind: "message" as ProtoKind,
      oneof: "formatCase",
      oneofCase: LoadDataOptionsFormatOneofCase.Json,
      messageType: "JsonOptions",
    },
    {
      no: 10,
      name: "header_policy",
      jsonName: "headerPolicy",
      prop: "headerPolicy",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: HeaderPolicy,
    },
    {
      no: 11,
      name: "field_map",
      jsonName: "fieldMap",
      prop: "fieldMap",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "FieldMapping",
    },
    {
      no: 12,
      name: "type_policy",
      jsonName: "typePolicy",
      prop: "typePolicy",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TypePolicy,
    },
    {
      no: 13,
      name: "coercion",
      jsonName: "coercion",
      prop: "coercion",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CoercionMode,
    },
    {
      no: 14,
      name: "error_mode",
      jsonName: "errorMode",
      prop: "errorMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: WriteErrorMode,
    },
    {
      no: 15,
      name: "date_format",
      jsonName: "dateFormat",
      prop: "dateFormat",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 16,
      name: "decimal_char",
      jsonName: "decimalChar",
      prop: "decimalChar",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 17,
      name: "auto_create_columns",
      jsonName: "autoCreateColumns",
      prop: "autoCreateColumns",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 19,
      name: "atomic",
      jsonName: "atomic",
      prop: "atomic",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 20,
      name: "skip_rows",
      jsonName: "skipRows",
      prop: "skipRows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 21,
      name: "max_rows",
      jsonName: "maxRows",
      prop: "maxRows",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  formatCase: LoadDataOptionsFormatOneofCase = LoadDataOptionsFormatOneofCase.None;
  csv?: CsvOptions;
  json?: JsonOptions;
  headerPolicy: HeaderPolicy = 0;
  fieldMap: FieldMapping[] = [];
  typePolicy: TypePolicy = 0;
  coercion: CoercionMode = 0;
  errorMode: WriteErrorMode = 0;
  dateFormat: string = "";
  decimalChar: string = "";
  autoCreateColumns: boolean = false;
  atomic: boolean = false;
  skipRows: number = 0;
  maxRows: number = 0;

  constructor(init?: Partial<LoadDataOptions>) {
    initMessage(this, LoadDataOptions.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadDataOptions {
    return decodeMessage(LoadDataOptions, data);
  }

  static parseFrom(data: Uint8Array): LoadDataOptions {
    return LoadDataOptions.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadDataOptions.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadDataOptions.fields);
  }
}
registerMessage(LoadDataOptions);
export class LoadDataRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadDataRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 3,
      name: "options",
      jsonName: "options",
      prop: "options",
      kind: "message" as ProtoKind,
      optional: true,
      messageType: "LoadDataOptions",
    },
  ];
  gridId: bigint = 0n;
  data?: Uint8Array;
  options?: LoadDataOptions;

  constructor(init?: Partial<LoadDataRequest>) {
    initMessage(this, LoadDataRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadDataRequest {
    return decodeMessage(LoadDataRequest, data);
  }

  static parseFrom(data: Uint8Array): LoadDataRequest {
    return LoadDataRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadDataRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadDataRequest.fields);
  }
}
registerMessage(LoadDataRequest);
export class LoadDataResult implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadDataResult" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "status",
      jsonName: "status",
      prop: "status",
      kind: "enum" as ProtoKind,
      enumType: LoadDataStatus,
    },
    {
      no: 2,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "cols",
      jsonName: "cols",
      prop: "cols",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "rejected",
      jsonName: "rejected",
      prop: "rejected",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "violations",
      jsonName: "violations",
      prop: "violations",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "TypeViolation",
    },
    {
      no: 6,
      name: "warnings",
      jsonName: "warnings",
      prop: "warnings",
      kind: "string" as ProtoKind,
      repeated: true,
    },
    {
      no: 7,
      name: "inferred_columns",
      jsonName: "inferredColumns",
      prop: "inferredColumns",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ColumnDef",
    },
  ];
  status: LoadDataStatus = 0;
  rows: number = 0;
  cols: number = 0;
  rejected: number = 0;
  violations: TypeViolation[] = [];
  warnings: string[] = [];
  inferredColumns: ColumnDef[] = [];

  constructor(init?: Partial<LoadDataResult>) {
    initMessage(this, LoadDataResult.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadDataResult {
    return decodeMessage(LoadDataResult, data);
  }

  static parseFrom(data: Uint8Array): LoadDataResult {
    return LoadDataResult.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadDataResult.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadDataResult.fields);
  }
}
registerMessage(LoadDataResult);
export class LoadDemoRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadDemoRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "demo",
      jsonName: "demo",
      prop: "demo",
      kind: "string" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  demo: string = "";

  constructor(init?: Partial<LoadDemoRequest>) {
    initMessage(this, LoadDemoRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadDemoRequest {
    return decodeMessage(LoadDemoRequest, data);
  }

  static parseFrom(data: Uint8Array): LoadDemoRequest {
    return LoadDemoRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadDemoRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadDemoRequest.fields);
  }
}
registerMessage(LoadDemoRequest);
export class LoadDemoResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadDemoResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<LoadDemoResponse>) {
    initMessage(this, LoadDemoResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadDemoResponse {
    return decodeMessage(LoadDemoResponse, data);
  }

  static parseFrom(data: Uint8Array): LoadDemoResponse {
    return LoadDemoResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadDemoResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadDemoResponse.fields);
  }
}
registerMessage(LoadDemoResponse);
export class LoadFontDataRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadFontDataRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 2,
      name: "font_name",
      jsonName: "fontName",
      prop: "fontName",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "font_names",
      jsonName: "fontNames",
      prop: "fontNames",
      kind: "string" as ProtoKind,
      repeated: true,
    },
  ];
  data?: Uint8Array;
  fontName: string = "";
  fontNames: string[] = [];

  constructor(init?: Partial<LoadFontDataRequest>) {
    initMessage(this, LoadFontDataRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadFontDataRequest {
    return decodeMessage(LoadFontDataRequest, data);
  }

  static parseFrom(data: Uint8Array): LoadFontDataRequest {
    return LoadFontDataRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadFontDataRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadFontDataRequest.fields);
  }
}
registerMessage(LoadFontDataRequest);
export class LoadFontDataResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadFontDataResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<LoadFontDataResponse>) {
    initMessage(this, LoadFontDataResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadFontDataResponse {
    return decodeMessage(LoadFontDataResponse, data);
  }

  static parseFrom(data: Uint8Array): LoadFontDataResponse {
    return LoadFontDataResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadFontDataResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadFontDataResponse.fields);
  }
}
registerMessage(LoadFontDataResponse);
export class LoadTableRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.LoadTableRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "cols",
      jsonName: "cols",
      prop: "cols",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "values",
      jsonName: "values",
      prop: "values",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellValue",
    },
    {
      no: 5,
      name: "atomic",
      jsonName: "atomic",
      prop: "atomic",
      kind: "bool" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  rows: number = 0;
  cols: number = 0;
  values: CellValue[] = [];
  atomic: boolean = false;

  constructor(init?: Partial<LoadTableRequest>) {
    initMessage(this, LoadTableRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): LoadTableRequest {
    return decodeMessage(LoadTableRequest, data);
  }

  static parseFrom(data: Uint8Array): LoadTableRequest {
    return LoadTableRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, LoadTableRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, LoadTableRequest.fields);
  }
}
registerMessage(LoadTableRequest);
export class MemoryUsageResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MemoryUsageResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "total_bytes",
      jsonName: "totalBytes",
      prop: "totalBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "cell_data_bytes",
      jsonName: "cellDataBytes",
      prop: "cellDataBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 3,
      name: "style_bytes",
      jsonName: "styleBytes",
      prop: "styleBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 4,
      name: "layout_bytes",
      jsonName: "layoutBytes",
      prop: "layoutBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 5,
      name: "column_bytes",
      jsonName: "columnBytes",
      prop: "columnBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 6,
      name: "row_bytes",
      jsonName: "rowBytes",
      prop: "rowBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 7,
      name: "selection_bytes",
      jsonName: "selectionBytes",
      prop: "selectionBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 8,
      name: "animation_bytes",
      jsonName: "animationBytes",
      prop: "animationBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 9,
      name: "text_engine_bytes",
      jsonName: "textEngineBytes",
      prop: "textEngineBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 10,
      name: "event_bytes",
      jsonName: "eventBytes",
      prop: "eventBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 11,
      name: "misc_bytes",
      jsonName: "miscBytes",
      prop: "miscBytes",
      kind: "int64" as ProtoKind,
    },
    {
      no: 12,
      name: "cell_count",
      jsonName: "cellCount",
      prop: "cellCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 13,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "int32" as ProtoKind,
    },
    {
      no: 14,
      name: "cols",
      jsonName: "cols",
      prop: "cols",
      kind: "int32" as ProtoKind,
    },
  ];
  totalBytes: bigint = 0n;
  cellDataBytes: bigint = 0n;
  styleBytes: bigint = 0n;
  layoutBytes: bigint = 0n;
  columnBytes: bigint = 0n;
  rowBytes: bigint = 0n;
  selectionBytes: bigint = 0n;
  animationBytes: bigint = 0n;
  textEngineBytes: bigint = 0n;
  eventBytes: bigint = 0n;
  miscBytes: bigint = 0n;
  cellCount: number = 0;
  rows: number = 0;
  cols: number = 0;

  constructor(init?: Partial<MemoryUsageResponse>) {
    initMessage(this, MemoryUsageResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MemoryUsageResponse {
    return decodeMessage(MemoryUsageResponse, data);
  }

  static parseFrom(data: Uint8Array): MemoryUsageResponse {
    return MemoryUsageResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MemoryUsageResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MemoryUsageResponse.fields);
  }
}
registerMessage(MemoryUsageResponse);
export class MergeCellsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MergeCellsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "range",
      jsonName: "range",
      prop: "range",
      kind: "message" as ProtoKind,
      messageType: "CellRange",
    },
  ];
  gridId: bigint = 0n;
  range?: CellRange;

  constructor(init?: Partial<MergeCellsRequest>) {
    initMessage(this, MergeCellsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MergeCellsRequest {
    return decodeMessage(MergeCellsRequest, data);
  }

  static parseFrom(data: Uint8Array): MergeCellsRequest {
    return MergeCellsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MergeCellsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MergeCellsRequest.fields);
  }
}
registerMessage(MergeCellsRequest);
export class MergeCellsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MergeCellsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "merged",
      jsonName: "merged",
      prop: "merged",
      kind: "message" as ProtoKind,
      messageType: "CellRange",
    },
  ];
  merged?: CellRange;

  constructor(init?: Partial<MergeCellsResponse>) {
    initMessage(this, MergeCellsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MergeCellsResponse {
    return decodeMessage(MergeCellsResponse, data);
  }

  static parseFrom(data: Uint8Array): MergeCellsResponse {
    return MergeCellsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MergeCellsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MergeCellsResponse.fields);
  }
}
registerMessage(MergeCellsResponse);
export class MergedRegionsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MergedRegionsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "ranges",
      jsonName: "ranges",
      prop: "ranges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
  ];
  ranges: CellRange[] = [];

  constructor(init?: Partial<MergedRegionsResponse>) {
    initMessage(this, MergedRegionsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MergedRegionsResponse {
    return decodeMessage(MergedRegionsResponse, data);
  }

  static parseFrom(data: Uint8Array): MergedRegionsResponse {
    return MergedRegionsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MergedRegionsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MergedRegionsResponse.fields);
  }
}
registerMessage(MergedRegionsResponse);
export class MouseDownEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MouseDownEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "button",
      jsonName: "button",
      prop: "button",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
  ];
  button: number = 0;
  modifier: number = 0;
  x: number = 0;
  y: number = 0;

  constructor(init?: Partial<MouseDownEvent>) {
    initMessage(this, MouseDownEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MouseDownEvent {
    return decodeMessage(MouseDownEvent, data);
  }

  static parseFrom(data: Uint8Array): MouseDownEvent {
    return MouseDownEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MouseDownEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MouseDownEvent.fields);
  }
}
registerMessage(MouseDownEvent);
export class MouseMoveEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MouseMoveEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "button",
      jsonName: "button",
      prop: "button",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
    {
      no: 5,
      name: "target",
      jsonName: "target",
      prop: "target",
      kind: "message" as ProtoKind,
      messageType: "GridEventTarget",
    },
  ];
  button: number = 0;
  modifier: number = 0;
  x: number = 0;
  y: number = 0;
  target?: GridEventTarget;

  constructor(init?: Partial<MouseMoveEvent>) {
    initMessage(this, MouseMoveEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MouseMoveEvent {
    return decodeMessage(MouseMoveEvent, data);
  }

  static parseFrom(data: Uint8Array): MouseMoveEvent {
    return MouseMoveEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MouseMoveEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MouseMoveEvent.fields);
  }
}
registerMessage(MouseMoveEvent);
export class MouseUpEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MouseUpEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "button",
      jsonName: "button",
      prop: "button",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
  ];
  button: number = 0;
  modifier: number = 0;
  x: number = 0;
  y: number = 0;

  constructor(init?: Partial<MouseUpEvent>) {
    initMessage(this, MouseUpEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MouseUpEvent {
    return decodeMessage(MouseUpEvent, data);
  }

  static parseFrom(data: Uint8Array): MouseUpEvent {
    return MouseUpEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MouseUpEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MouseUpEvent.fields);
  }
}
registerMessage(MouseUpEvent);
export class MoveColumnRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MoveColumnRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "position",
      jsonName: "position",
      prop: "position",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  col: number = 0;
  position: number = 0;

  constructor(init?: Partial<MoveColumnRequest>) {
    initMessage(this, MoveColumnRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MoveColumnRequest {
    return decodeMessage(MoveColumnRequest, data);
  }

  static parseFrom(data: Uint8Array): MoveColumnRequest {
    return MoveColumnRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MoveColumnRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MoveColumnRequest.fields);
  }
}
registerMessage(MoveColumnRequest);
export class MoveColumnResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MoveColumnResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<MoveColumnResponse>) {
    initMessage(this, MoveColumnResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MoveColumnResponse {
    return decodeMessage(MoveColumnResponse, data);
  }

  static parseFrom(data: Uint8Array): MoveColumnResponse {
    return MoveColumnResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MoveColumnResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MoveColumnResponse.fields);
  }
}
registerMessage(MoveColumnResponse);
export class MoveRowRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MoveRowRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "position",
      jsonName: "position",
      prop: "position",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  row: number = 0;
  position: number = 0;

  constructor(init?: Partial<MoveRowRequest>) {
    initMessage(this, MoveRowRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MoveRowRequest {
    return decodeMessage(MoveRowRequest, data);
  }

  static parseFrom(data: Uint8Array): MoveRowRequest {
    return MoveRowRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MoveRowRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MoveRowRequest.fields);
  }
}
registerMessage(MoveRowRequest);
export class MoveRowResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.MoveRowResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<MoveRowResponse>) {
    initMessage(this, MoveRowResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): MoveRowResponse {
    return decodeMessage(MoveRowResponse, data);
  }

  static parseFrom(data: Uint8Array): MoveRowResponse {
    return MoveRowResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, MoveRowResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, MoveRowResponse.fields);
  }
}
registerMessage(MoveRowResponse);
export class NodeInfo implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.NodeInfo" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "level",
      jsonName: "level",
      prop: "level",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "is_expanded",
      jsonName: "isExpanded",
      prop: "isExpanded",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "child_count",
      jsonName: "childCount",
      prop: "childCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "parent_row",
      jsonName: "parentRow",
      prop: "parentRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "first_child",
      jsonName: "firstChild",
      prop: "firstChild",
      kind: "int32" as ProtoKind,
    },
    {
      no: 7,
      name: "last_child",
      jsonName: "lastChild",
      prop: "lastChild",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  level: number = 0;
  isExpanded: boolean = false;
  childCount: number = 0;
  parentRow: number = 0;
  firstChild: number = 0;
  lastChild: number = 0;

  constructor(init?: Partial<NodeInfo>) {
    initMessage(this, NodeInfo.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): NodeInfo {
    return decodeMessage(NodeInfo, data);
  }

  static parseFrom(data: Uint8Array): NodeInfo {
    return NodeInfo.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, NodeInfo.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, NodeInfo.fields);
  }
}
registerMessage(NodeInfo);
export class NumberEditorParams implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.NumberEditorParams" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "min",
      jsonName: "min",
      prop: "min",
      kind: "double" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "max",
      jsonName: "max",
      prop: "max",
      kind: "double" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "step",
      jsonName: "step",
      prop: "step",
      kind: "double" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "string" as ProtoKind,
    },
    {
      no: 5,
      name: "nullable",
      jsonName: "nullable",
      prop: "nullable",
      kind: "bool" as ProtoKind,
    },
  ];
  min: number = 0;
  max: number = 0;
  step: number = 0;
  format: string = "";
  nullable: boolean = false;

  constructor(init?: Partial<NumberEditorParams>) {
    initMessage(this, NumberEditorParams.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): NumberEditorParams {
    return decodeMessage(NumberEditorParams, data);
  }

  static parseFrom(data: Uint8Array): NumberEditorParams {
    return NumberEditorParams.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, NumberEditorParams.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, NumberEditorParams.fields);
  }
}
registerMessage(NumberEditorParams);
export class OutlineConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.OutlineConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "tree_indicator",
      jsonName: "treeIndicator",
      prop: "treeIndicator",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TreeIndicatorStyle,
    },
    {
      no: 2,
      name: "tree_color",
      jsonName: "treeColor",
      prop: "treeColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "group_total_position",
      jsonName: "groupTotalPosition",
      prop: "groupTotalPosition",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: GroupTotalPosition,
    },
    {
      no: 4,
      name: "multi_totals",
      jsonName: "multiTotals",
      prop: "multiTotals",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "indicator_indent",
      jsonName: "indicatorIndent",
      prop: "indicatorIndent",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "max_levels",
      jsonName: "maxLevels",
      prop: "maxLevels",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "show_level_buttons",
      jsonName: "showLevelButtons",
      prop: "showLevelButtons",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "label_column",
      jsonName: "labelColumn",
      prop: "labelColumn",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "icon_column",
      jsonName: "iconColumn",
      prop: "iconColumn",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  treeIndicator: TreeIndicatorStyle = 0;
  treeColor: number = 0;
  groupTotalPosition: GroupTotalPosition = 0;
  multiTotals: boolean = false;
  indicatorIndent: number = 0;
  maxLevels: number = 0;
  showLevelButtons: boolean = false;
  labelColumn: number = 0;
  iconColumn: number = 0;

  constructor(init?: Partial<OutlineConfig>) {
    initMessage(this, OutlineConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): OutlineConfig {
    return decodeMessage(OutlineConfig, data);
  }

  static parseFrom(data: Uint8Array): OutlineConfig {
    return OutlineConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, OutlineConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, OutlineConfig.fields);
  }
}
registerMessage(OutlineConfig);
export class OutlineRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.OutlineRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "level",
      jsonName: "level",
      prop: "level",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  level: number = 0;

  constructor(init?: Partial<OutlineRequest>) {
    initMessage(this, OutlineRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): OutlineRequest {
    return decodeMessage(OutlineRequest, data);
  }

  static parseFrom(data: Uint8Array): OutlineRequest {
    return OutlineRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, OutlineRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, OutlineRequest.fields);
  }
}
registerMessage(OutlineRequest);
export class OutlineResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.OutlineResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<OutlineResponse>) {
    initMessage(this, OutlineResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): OutlineResponse {
    return decodeMessage(OutlineResponse, data);
  }

  static parseFrom(data: Uint8Array): OutlineResponse {
    return OutlineResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, OutlineResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, OutlineResponse.fields);
  }
}
registerMessage(OutlineResponse);
export class Padding implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Padding" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "left",
      jsonName: "left",
      prop: "left",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "top",
      jsonName: "top",
      prop: "top",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "right",
      jsonName: "right",
      prop: "right",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "bottom",
      jsonName: "bottom",
      prop: "bottom",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  left: number = 0;
  top: number = 0;
  right: number = 0;
  bottom: number = 0;

  constructor(init?: Partial<Padding>) {
    initMessage(this, Padding.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Padding {
    return decodeMessage(Padding, data);
  }

  static parseFrom(data: Uint8Array): Padding {
    return Padding.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Padding.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Padding.fields);
  }
}
registerMessage(Padding);
export class PointerEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PointerEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "type",
      jsonName: "type",
      prop: "type",
      kind: "enum" as ProtoKind,
      enumType: PointerEvent_Type,
    },
    {
      no: 2,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "modifier",
      jsonName: "modifier",
      prop: "modifier",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "button",
      jsonName: "button",
      prop: "button",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "dbl_click",
      jsonName: "dblClick",
      prop: "dblClick",
      kind: "bool" as ProtoKind,
    },
  ];
  type: PointerEvent_Type = 0;
  x: number = 0;
  y: number = 0;
  modifier: number = 0;
  button: number = 0;
  dblClick: boolean = false;

  constructor(init?: Partial<PointerEvent>) {
    initMessage(this, PointerEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PointerEvent {
    return decodeMessage(PointerEvent, data);
  }

  static parseFrom(data: Uint8Array): PointerEvent {
    return PointerEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PointerEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PointerEvent.fields);
  }
}
registerMessage(PointerEvent);
export class PrintPage implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PrintPage" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "page_number",
      jsonName: "pageNumber",
      prop: "pageNumber",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "image_data",
      jsonName: "imageData",
      prop: "imageData",
      kind: "bytes" as ProtoKind,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
  ];
  pageNumber: number = 0;
  imageData?: Uint8Array;
  width: number = 0;
  height: number = 0;

  constructor(init?: Partial<PrintPage>) {
    initMessage(this, PrintPage.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PrintPage {
    return decodeMessage(PrintPage, data);
  }

  static parseFrom(data: Uint8Array): PrintPage {
    return PrintPage.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PrintPage.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PrintPage.fields);
  }
}
registerMessage(PrintPage);
export class PrintRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PrintRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "orientation",
      jsonName: "orientation",
      prop: "orientation",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: PrintOrientation,
    },
    {
      no: 3,
      name: "margin_left",
      jsonName: "marginLeft",
      prop: "marginLeft",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "margin_top",
      jsonName: "marginTop",
      prop: "marginTop",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "margin_right",
      jsonName: "marginRight",
      prop: "marginRight",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "margin_bottom",
      jsonName: "marginBottom",
      prop: "marginBottom",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "header",
      jsonName: "header",
      prop: "header",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "footer",
      jsonName: "footer",
      prop: "footer",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "show_page_numbers",
      jsonName: "showPageNumbers",
      prop: "showPageNumbers",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  gridId: bigint = 0n;
  orientation: PrintOrientation = 0;
  marginLeft: number = 0;
  marginTop: number = 0;
  marginRight: number = 0;
  marginBottom: number = 0;
  header: string = "";
  footer: string = "";
  showPageNumbers: boolean = false;

  constructor(init?: Partial<PrintRequest>) {
    initMessage(this, PrintRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PrintRequest {
    return decodeMessage(PrintRequest, data);
  }

  static parseFrom(data: Uint8Array): PrintRequest {
    return PrintRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PrintRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PrintRequest.fields);
  }
}
registerMessage(PrintRequest);
export class PrintResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PrintResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "pages",
      jsonName: "pages",
      prop: "pages",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "PrintPage",
    },
  ];
  pages: PrintPage[] = [];

  constructor(init?: Partial<PrintResponse>) {
    initMessage(this, PrintResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PrintResponse {
    return decodeMessage(PrintResponse, data);
  }

  static parseFrom(data: Uint8Array): PrintResponse {
    return PrintResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PrintResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PrintResponse.fields);
  }
}
registerMessage(PrintResponse);
export class PullToRefreshCanceledEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PullToRefreshCanceledEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<PullToRefreshCanceledEvent>) {
    initMessage(this, PullToRefreshCanceledEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PullToRefreshCanceledEvent {
    return decodeMessage(PullToRefreshCanceledEvent, data);
  }

  static parseFrom(data: Uint8Array): PullToRefreshCanceledEvent {
    return PullToRefreshCanceledEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PullToRefreshCanceledEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PullToRefreshCanceledEvent.fields);
  }
}
registerMessage(PullToRefreshCanceledEvent);
export class PullToRefreshConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PullToRefreshConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "enabled",
      jsonName: "enabled",
      prop: "enabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "theme",
      jsonName: "theme",
      prop: "theme",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: PullToRefreshTheme,
    },
    {
      no: 3,
      name: "text_pull",
      jsonName: "textPull",
      prop: "textPull",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "text_release",
      jsonName: "textRelease",
      prop: "textRelease",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  enabled: boolean = false;
  theme: PullToRefreshTheme = 0;
  textPull: string = "";
  textRelease: string = "";

  constructor(init?: Partial<PullToRefreshConfig>) {
    initMessage(this, PullToRefreshConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PullToRefreshConfig {
    return decodeMessage(PullToRefreshConfig, data);
  }

  static parseFrom(data: Uint8Array): PullToRefreshConfig {
    return PullToRefreshConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PullToRefreshConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PullToRefreshConfig.fields);
  }
}
registerMessage(PullToRefreshConfig);
export class PullToRefreshTriggeredEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.PullToRefreshTriggeredEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<PullToRefreshTriggeredEvent>) {
    initMessage(this, PullToRefreshTriggeredEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): PullToRefreshTriggeredEvent {
    return decodeMessage(PullToRefreshTriggeredEvent, data);
  }

  static parseFrom(data: Uint8Array): PullToRefreshTriggeredEvent {
    return PullToRefreshTriggeredEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, PullToRefreshTriggeredEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, PullToRefreshTriggeredEvent.fields);
  }
}
registerMessage(PullToRefreshTriggeredEvent);
export class Rect implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Rect" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 2,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "float" as ProtoKind,
    },
  ];
  x: number = 0;
  y: number = 0;
  width: number = 0;
  height: number = 0;

  constructor(init?: Partial<Rect>) {
    initMessage(this, Rect.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Rect {
    return decodeMessage(Rect, data);
  }

  static parseFrom(data: Uint8Array): Rect {
    return Rect.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Rect.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Rect.fields);
  }
}
registerMessage(Rect);
export class RefreshRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RefreshRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;

  constructor(init?: Partial<RefreshRequest>) {
    initMessage(this, RefreshRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RefreshRequest {
    return decodeMessage(RefreshRequest, data);
  }

  static parseFrom(data: Uint8Array): RefreshRequest {
    return RefreshRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RefreshRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RefreshRequest.fields);
  }
}
registerMessage(RefreshRequest);
export class RefreshResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RefreshResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<RefreshResponse>) {
    initMessage(this, RefreshResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RefreshResponse {
    return decodeMessage(RefreshResponse, data);
  }

  static parseFrom(data: Uint8Array): RefreshResponse {
    return RefreshResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RefreshResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RefreshResponse.fields);
  }
}
registerMessage(RefreshResponse);
export class RegexQuery implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RegexQuery" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "pattern",
      jsonName: "pattern",
      prop: "pattern",
      kind: "string" as ProtoKind,
    },
  ];
  pattern: string = "";

  constructor(init?: Partial<RegexQuery>) {
    initMessage(this, RegexQuery.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RegexQuery {
    return decodeMessage(RegexQuery, data);
  }

  static parseFrom(data: Uint8Array): RegexQuery {
    return RegexQuery.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RegexQuery.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RegexQuery.fields);
  }
}
registerMessage(RegexQuery);
export class RegionStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RegionStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
    {
      no: 4,
      name: "grid_lines",
      jsonName: "gridLines",
      prop: "gridLines",
      kind: "message" as ProtoKind,
      messageType: "GridLines",
    },
    {
      no: 5,
      name: "text_effect",
      jsonName: "textEffect",
      prop: "textEffect",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextEffect,
    },
    {
      no: 6,
      name: "separator",
      jsonName: "separator",
      prop: "separator",
      kind: "message" as ProtoKind,
      messageType: "Separator",
    },
    {
      no: 7,
      name: "cell_padding",
      jsonName: "cellPadding",
      prop: "cellPadding",
      kind: "message" as ProtoKind,
      messageType: "Padding",
    },
  ];
  background: number = 0;
  foreground: number = 0;
  font?: Font;
  gridLines?: GridLines;
  textEffect: TextEffect = 0;
  separator?: Separator;
  cellPadding?: Padding;

  constructor(init?: Partial<RegionStyle>) {
    initMessage(this, RegionStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RegionStyle {
    return decodeMessage(RegionStyle, data);
  }

  static parseFrom(data: Uint8Array): RegionStyle {
    return RegionStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RegionStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RegionStyle.fields);
  }
}
registerMessage(RegionStyle);
export class RemoveRowsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RemoveRowsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "index",
      jsonName: "index",
      prop: "index",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "count",
      jsonName: "count",
      prop: "count",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  index: number = 0;
  count: number = 0;

  constructor(init?: Partial<RemoveRowsRequest>) {
    initMessage(this, RemoveRowsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RemoveRowsRequest {
    return decodeMessage(RemoveRowsRequest, data);
  }

  static parseFrom(data: Uint8Array): RemoveRowsRequest {
    return RemoveRowsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RemoveRowsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RemoveRowsRequest.fields);
  }
}
registerMessage(RemoveRowsRequest);
export class RemoveRowsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RemoveRowsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "removed_count",
      jsonName: "removedCount",
      prop: "removedCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "new_row_count",
      jsonName: "newRowCount",
      prop: "newRowCount",
      kind: "int32" as ProtoKind,
    },
  ];
  removedCount: number = 0;
  newRowCount: number = 0;

  constructor(init?: Partial<RemoveRowsResponse>) {
    initMessage(this, RemoveRowsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RemoveRowsResponse {
    return decodeMessage(RemoveRowsResponse, data);
  }

  static parseFrom(data: Uint8Array): RemoveRowsResponse {
    return RemoveRowsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RemoveRowsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RemoveRowsResponse.fields);
  }
}
registerMessage(RemoveRowsResponse);
export class RenderConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RenderConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "renderer_mode",
      jsonName: "rendererMode",
      prop: "rendererMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: RendererMode,
    },
    {
      no: 2,
      name: "debug_overlay",
      jsonName: "debugOverlay",
      prop: "debugOverlay",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "animation_enabled",
      jsonName: "animationEnabled",
      prop: "animationEnabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "animation_duration_ms",
      jsonName: "animationDurationMs",
      prop: "animationDurationMs",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "text_layout_cache_cap",
      jsonName: "textLayoutCacheCap",
      prop: "textLayoutCacheCap",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "present_mode",
      jsonName: "presentMode",
      prop: "presentMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: PresentMode,
    },
    {
      no: 7,
      name: "frame_pacing_mode",
      jsonName: "framePacingMode",
      prop: "framePacingMode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: FramePacingMode,
    },
    {
      no: 8,
      name: "target_frame_rate_hz",
      jsonName: "targetFrameRateHz",
      prop: "targetFrameRateHz",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "render_layer_mask",
      jsonName: "renderLayerMask",
      prop: "renderLayerMask",
      kind: "int64" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "layer_profiling",
      jsonName: "layerProfiling",
      prop: "layerProfiling",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "scroll_blit",
      jsonName: "scrollBlit",
      prop: "scrollBlit",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 12,
      name: "font_fallback_enabled",
      jsonName: "fontFallbackEnabled",
      prop: "fontFallbackEnabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  rendererMode: RendererMode = 0;
  debugOverlay: boolean = false;
  animationEnabled: boolean = false;
  animationDurationMs: number = 0;
  textLayoutCacheCap: number = 0;
  presentMode: PresentMode = 0;
  framePacingMode: FramePacingMode = 0;
  targetFrameRateHz: number = 0;
  renderLayerMask: bigint = 0n;
  layerProfiling: boolean = false;
  scrollBlit: boolean = false;
  fontFallbackEnabled: boolean = false;

  constructor(init?: Partial<RenderConfig>) {
    initMessage(this, RenderConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RenderConfig {
    return decodeMessage(RenderConfig, data);
  }

  static parseFrom(data: Uint8Array): RenderConfig {
    return RenderConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RenderConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RenderConfig.fields);
  }
}
registerMessage(RenderConfig);
export enum RenderInputInputOneofCase {
  None = 0,
  Viewport = 2,
  Pointer = 3,
  Key = 4,
  Buffer = 5,
  Scroll = 6,
  EventDecision = 7,
  Zoom = 8,
  GpuSurface = 9,
  TerminalInput = 10,
  TerminalCapabilities = 11,
  TerminalViewport = 12,
  TerminalCommand = 13,
  CompareResponse = 14,
  EditValidationResponse = 15,
  EditorListItemsResponse = 16,
}
export class RenderInput implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RenderInput" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "viewport",
      jsonName: "viewport",
      prop: "viewport",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Viewport,
      messageType: "ViewportState",
    },
    {
      no: 3,
      name: "pointer",
      jsonName: "pointer",
      prop: "pointer",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Pointer,
      messageType: "PointerEvent",
    },
    {
      no: 4,
      name: "key",
      jsonName: "key",
      prop: "key",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Key,
      messageType: "KeyEvent",
    },
    {
      no: 5,
      name: "buffer",
      jsonName: "buffer",
      prop: "buffer",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Buffer,
      messageType: "BufferReady",
    },
    {
      no: 6,
      name: "scroll",
      jsonName: "scroll",
      prop: "scroll",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Scroll,
      messageType: "ScrollEvent",
    },
    {
      no: 7,
      name: "event_decision",
      jsonName: "eventDecision",
      prop: "eventDecision",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.EventDecision,
      messageType: "EventDecision",
    },
    {
      no: 8,
      name: "zoom",
      jsonName: "zoom",
      prop: "zoom",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.Zoom,
      messageType: "ZoomEvent",
    },
    {
      no: 9,
      name: "gpu_surface",
      jsonName: "gpuSurface",
      prop: "gpuSurface",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.GpuSurface,
      messageType: "GpuSurfaceReady",
    },
    {
      no: 10,
      name: "terminal_input",
      jsonName: "terminalInput",
      prop: "terminalInput",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.TerminalInput,
      messageType: "TerminalInputBytes",
    },
    {
      no: 11,
      name: "terminal_capabilities",
      jsonName: "terminalCapabilities",
      prop: "terminalCapabilities",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.TerminalCapabilities,
      messageType: "TerminalCapabilities",
    },
    {
      no: 12,
      name: "terminal_viewport",
      jsonName: "terminalViewport",
      prop: "terminalViewport",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.TerminalViewport,
      messageType: "TerminalViewport",
    },
    {
      no: 13,
      name: "terminal_command",
      jsonName: "terminalCommand",
      prop: "terminalCommand",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.TerminalCommand,
      messageType: "TerminalCommand",
    },
    {
      no: 14,
      name: "compare_response",
      jsonName: "compareResponse",
      prop: "compareResponse",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.CompareResponse,
      messageType: "CompareResponse",
    },
    {
      no: 15,
      name: "edit_validation_response",
      jsonName: "editValidationResponse",
      prop: "editValidationResponse",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.EditValidationResponse,
      messageType: "EditValidationResponse",
    },
    {
      no: 16,
      name: "editor_list_items_response",
      jsonName: "editorListItemsResponse",
      prop: "editorListItemsResponse",
      kind: "message" as ProtoKind,
      oneof: "inputCase",
      oneofCase: RenderInputInputOneofCase.EditorListItemsResponse,
      messageType: "EditorListItemsResponse",
    },
  ];
  inputCase: RenderInputInputOneofCase = RenderInputInputOneofCase.None;
  gridId: bigint = 0n;
  viewport?: ViewportState;
  pointer?: PointerEvent;
  key?: KeyEvent;
  buffer?: BufferReady;
  scroll?: ScrollEvent;
  eventDecision?: EventDecision;
  zoom?: ZoomEvent;
  gpuSurface?: GpuSurfaceReady;
  terminalInput?: TerminalInputBytes;
  terminalCapabilities?: TerminalCapabilities;
  terminalViewport?: TerminalViewport;
  terminalCommand?: TerminalCommand;
  compareResponse?: CompareResponse;
  editValidationResponse?: EditValidationResponse;
  editorListItemsResponse?: EditorListItemsResponse;

  constructor(init?: Partial<RenderInput>) {
    initMessage(this, RenderInput.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RenderInput {
    return decodeMessage(RenderInput, data);
  }

  static parseFrom(data: Uint8Array): RenderInput {
    return RenderInput.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RenderInput.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RenderInput.fields);
  }
}
registerMessage(RenderInput);
export enum RenderOutputEventOneofCase {
  None = 0,
  FrameDone = 2,
  Selection = 3,
  Cursor = 4,
  EditorStarted = 5,
  EditorUpdated = 6,
  EditorEnded = 7,
  TooltipRequest = 8,
  GpuFrameDone = 9,
}
export class RenderOutput implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RenderOutput" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "rendered",
      jsonName: "rendered",
      prop: "rendered",
      kind: "bool" as ProtoKind,
    },
    {
      no: 2,
      name: "frame_done",
      jsonName: "frameDone",
      prop: "frameDone",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.FrameDone,
      messageType: "FrameDone",
    },
    {
      no: 3,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.Selection,
      messageType: "SelectionUpdate",
    },
    {
      no: 4,
      name: "cursor",
      jsonName: "cursor",
      prop: "cursor",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.Cursor,
      messageType: "CursorChange",
    },
    {
      no: 5,
      name: "editor_started",
      jsonName: "editorStarted",
      prop: "editorStarted",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.EditorStarted,
      messageType: "EditorSessionStarted",
    },
    {
      no: 6,
      name: "editor_updated",
      jsonName: "editorUpdated",
      prop: "editorUpdated",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.EditorUpdated,
      messageType: "EditorSessionUpdated",
    },
    {
      no: 7,
      name: "editor_ended",
      jsonName: "editorEnded",
      prop: "editorEnded",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.EditorEnded,
      messageType: "EditorSessionEnded",
    },
    {
      no: 8,
      name: "tooltip_request",
      jsonName: "tooltipRequest",
      prop: "tooltipRequest",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.TooltipRequest,
      messageType: "TooltipRequest",
    },
    {
      no: 9,
      name: "gpu_frame_done",
      jsonName: "gpuFrameDone",
      prop: "gpuFrameDone",
      kind: "message" as ProtoKind,
      oneof: "eventCase",
      oneofCase: RenderOutputEventOneofCase.GpuFrameDone,
      messageType: "GpuFrameDone",
    },
  ];
  eventCase: RenderOutputEventOneofCase = RenderOutputEventOneofCase.None;
  rendered: boolean = false;
  frameDone?: FrameDone;
  selection?: SelectionUpdate;
  cursor?: CursorChange;
  editorStarted?: EditorSessionStarted;
  editorUpdated?: EditorSessionUpdated;
  editorEnded?: EditorSessionEnded;
  tooltipRequest?: TooltipRequest;
  gpuFrameDone?: GpuFrameDone;

  constructor(init?: Partial<RenderOutput>) {
    initMessage(this, RenderOutput.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RenderOutput {
    return decodeMessage(RenderOutput, data);
  }

  static parseFrom(data: Uint8Array): RenderOutput {
    return RenderOutput.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RenderOutput.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RenderOutput.fields);
  }
}
registerMessage(RenderOutput);
export class ResizePolicy implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ResizePolicy" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "uniform",
      jsonName: "uniform",
      prop: "uniform",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  columns: boolean = false;
  rows: boolean = false;
  uniform: boolean = false;

  constructor(init?: Partial<ResizePolicy>) {
    initMessage(this, ResizePolicy.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ResizePolicy {
    return decodeMessage(ResizePolicy, data);
  }

  static parseFrom(data: Uint8Array): ResizePolicy {
    return ResizePolicy.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ResizePolicy.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ResizePolicy.fields);
  }
}
registerMessage(ResizePolicy);
export class ResizeViewportRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ResizeViewportRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  width: number = 0;
  height: number = 0;

  constructor(init?: Partial<ResizeViewportRequest>) {
    initMessage(this, ResizeViewportRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ResizeViewportRequest {
    return decodeMessage(ResizeViewportRequest, data);
  }

  static parseFrom(data: Uint8Array): ResizeViewportRequest {
    return ResizeViewportRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ResizeViewportRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ResizeViewportRequest.fields);
  }
}
registerMessage(ResizeViewportRequest);
export class ResizeViewportResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ResizeViewportResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "viewport_width",
      jsonName: "viewportWidth",
      prop: "viewportWidth",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "viewport_height",
      jsonName: "viewportHeight",
      prop: "viewportHeight",
      kind: "int32" as ProtoKind,
    },
  ];
  viewportWidth: number = 0;
  viewportHeight: number = 0;

  constructor(init?: Partial<ResizeViewportResponse>) {
    initMessage(this, ResizeViewportResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ResizeViewportResponse {
    return decodeMessage(ResizeViewportResponse, data);
  }

  static parseFrom(data: Uint8Array): ResizeViewportResponse {
    return ResizeViewportResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ResizeViewportResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ResizeViewportResponse.fields);
  }
}
registerMessage(ResizeViewportResponse);
export class RichText implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RichText" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "runs",
      jsonName: "runs",
      prop: "runs",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "TextFormatRun",
    },
  ];
  runs: TextFormatRun[] = [];

  constructor(init?: Partial<RichText>) {
    initMessage(this, RichText.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RichText {
    return decodeMessage(RichText, data);
  }

  static parseFrom(data: Uint8Array): RichText {
    return RichText.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RichText.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RichText.fields);
  }
}
registerMessage(RichText);
export class RowDef implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RowDef" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "index",
      jsonName: "index",
      prop: "index",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "hidden",
      jsonName: "hidden",
      prop: "hidden",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "is_subtotal",
      jsonName: "isSubtotal",
      prop: "isSubtotal",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "outline_level",
      jsonName: "outlineLevel",
      prop: "outlineLevel",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "is_collapsed",
      jsonName: "isCollapsed",
      prop: "isCollapsed",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "status",
      jsonName: "status",
      prop: "status",
      kind: "message" as ProtoKind,
      messageType: "RowStatus",
    },
    {
      no: 9,
      name: "span",
      jsonName: "span",
      prop: "span",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "pin",
      jsonName: "pin",
      prop: "pin",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: PinPosition,
    },
    {
      no: 11,
      name: "sticky",
      jsonName: "sticky",
      prop: "sticky",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: StickyEdge,
    },
  ];
  index: number = 0;
  height: number = 0;
  hidden: boolean = false;
  isSubtotal: boolean = false;
  outlineLevel: number = 0;
  isCollapsed: boolean = false;
  data?: Uint8Array;
  status?: RowStatus;
  span: boolean = false;
  pin: PinPosition = 0;
  sticky: StickyEdge = 0;

  constructor(init?: Partial<RowDef>) {
    initMessage(this, RowDef.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RowDef {
    return decodeMessage(RowDef, data);
  }

  static parseFrom(data: Uint8Array): RowDef {
    return RowDef.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RowDef.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RowDef.fields);
  }
}
registerMessage(RowDef);
export class RowIndicatorConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RowIndicatorConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "grid_lines",
      jsonName: "gridLines",
      prop: "gridLines",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: GridLineStyle,
    },
    {
      no: 6,
      name: "grid_color",
      jsonName: "gridColor",
      prop: "gridColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "auto_size",
      jsonName: "autoSize",
      prop: "autoSize",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "allow_resize",
      jsonName: "allowResize",
      prop: "allowResize",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "allow_select",
      jsonName: "allowSelect",
      prop: "allowSelect",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "allow_reorder",
      jsonName: "allowReorder",
      prop: "allowReorder",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 11,
      name: "slots",
      jsonName: "slots",
      prop: "slots",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "RowIndicatorSlot",
    },
  ];
  visible: boolean = false;
  width: number = 0;
  background: number = 0;
  foreground: number = 0;
  gridLines: GridLineStyle = 0;
  gridColor: number = 0;
  autoSize: boolean = false;
  allowResize: boolean = false;
  allowSelect: boolean = false;
  allowReorder: boolean = false;
  slots: RowIndicatorSlot[] = [];

  constructor(init?: Partial<RowIndicatorConfig>) {
    initMessage(this, RowIndicatorConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RowIndicatorConfig {
    return decodeMessage(RowIndicatorConfig, data);
  }

  static parseFrom(data: Uint8Array): RowIndicatorConfig {
    return RowIndicatorConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RowIndicatorConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RowIndicatorConfig.fields);
  }
}
registerMessage(RowIndicatorConfig);
export class RowIndicatorSlot implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RowIndicatorSlot" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "kind",
      jsonName: "kind",
      prop: "kind",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: RowIndicatorSlotKind,
    },
    {
      no: 2,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "custom_key",
      jsonName: "customKey",
      prop: "customKey",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
  ];
  kind: RowIndicatorSlotKind = 0;
  width: number = 0;
  visible: boolean = false;
  customKey: string = "";
  data?: Uint8Array;

  constructor(init?: Partial<RowIndicatorSlot>) {
    initMessage(this, RowIndicatorSlot.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RowIndicatorSlot {
    return decodeMessage(RowIndicatorSlot, data);
  }

  static parseFrom(data: Uint8Array): RowIndicatorSlot {
    return RowIndicatorSlot.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RowIndicatorSlot.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RowIndicatorSlot.fields);
  }
}
registerMessage(RowIndicatorSlot);
export class RowStatus implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RowStatus" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "domain",
      jsonName: "domain",
      prop: "domain",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "code",
      jsonName: "code",
      prop: "code",
      kind: "int32" as ProtoKind,
    },
  ];
  domain: string = "";
  code: number = 0;

  constructor(init?: Partial<RowStatus>) {
    initMessage(this, RowStatus.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RowStatus {
    return decodeMessage(RowStatus, data);
  }

  static parseFrom(data: Uint8Array): RowStatus {
    return RowStatus.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RowStatus.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RowStatus.fields);
  }
}
registerMessage(RowStatus);
export class RowStatusChangeEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.RowStatusChangeEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "status",
      jsonName: "status",
      prop: "status",
      kind: "message" as ProtoKind,
      messageType: "RowStatus",
    },
  ];
  row: number = 0;
  status?: RowStatus;

  constructor(init?: Partial<RowStatusChangeEvent>) {
    initMessage(this, RowStatusChangeEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): RowStatusChangeEvent {
    return decodeMessage(RowStatusChangeEvent, data);
  }

  static parseFrom(data: Uint8Array): RowStatusChangeEvent {
    return RowStatusChangeEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, RowStatusChangeEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, RowStatusChangeEvent.fields);
  }
}
registerMessage(RowStatusChangeEvent);
export enum ScalarValueValueOneofCase {
  None = 0,
  StringValue = 1,
  NumberValue = 2,
  BoolValue = 3,
  BytesValue = 4,
}
export class ScalarValue implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScalarValue" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "string_value",
      jsonName: "stringValue",
      prop: "stringValue",
      kind: "string" as ProtoKind,
      oneof: "valueCase",
      oneofCase: ScalarValueValueOneofCase.StringValue,
    },
    {
      no: 2,
      name: "number_value",
      jsonName: "numberValue",
      prop: "numberValue",
      kind: "double" as ProtoKind,
      oneof: "valueCase",
      oneofCase: ScalarValueValueOneofCase.NumberValue,
    },
    {
      no: 3,
      name: "bool_value",
      jsonName: "boolValue",
      prop: "boolValue",
      kind: "bool" as ProtoKind,
      oneof: "valueCase",
      oneofCase: ScalarValueValueOneofCase.BoolValue,
    },
    {
      no: 4,
      name: "bytes_value",
      jsonName: "bytesValue",
      prop: "bytesValue",
      kind: "bytes" as ProtoKind,
      oneof: "valueCase",
      oneofCase: ScalarValueValueOneofCase.BytesValue,
    },
  ];
  valueCase: ScalarValueValueOneofCase = ScalarValueValueOneofCase.None;
  stringValue?: string;
  numberValue?: number;
  boolValue?: boolean;
  bytesValue?: Uint8Array;

  constructor(init?: Partial<ScalarValue>) {
    initMessage(this, ScalarValue.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScalarValue {
    return decodeMessage(ScalarValue, data);
  }

  static parseFrom(data: Uint8Array): ScalarValue {
    return ScalarValue.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScalarValue.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScalarValue.fields);
  }
}
registerMessage(ScalarValue);
export class SchemaResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SchemaResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "columns",
      jsonName: "columns",
      prop: "columns",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "ColumnDef",
    },
  ];
  columns: ColumnDef[] = [];

  constructor(init?: Partial<SchemaResponse>) {
    initMessage(this, SchemaResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SchemaResponse {
    return decodeMessage(SchemaResponse, data);
  }

  static parseFrom(data: Uint8Array): SchemaResponse {
    return SchemaResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SchemaResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SchemaResponse.fields);
  }
}
registerMessage(SchemaResponse);
export class ScrollBarColors implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScrollBarColors" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "thumb",
      jsonName: "thumb",
      prop: "thumb",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "thumb_hover",
      jsonName: "thumbHover",
      prop: "thumbHover",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "thumb_active",
      jsonName: "thumbActive",
      prop: "thumbActive",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "track",
      jsonName: "track",
      prop: "track",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "arrow",
      jsonName: "arrow",
      prop: "arrow",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "border",
      jsonName: "border",
      prop: "border",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
  ];
  thumb: number = 0;
  thumbHover: number = 0;
  thumbActive: number = 0;
  track: number = 0;
  arrow: number = 0;
  border: number = 0;

  constructor(init?: Partial<ScrollBarColors>) {
    initMessage(this, ScrollBarColors.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScrollBarColors {
    return decodeMessage(ScrollBarColors, data);
  }

  static parseFrom(data: Uint8Array): ScrollBarColors {
    return ScrollBarColors.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScrollBarColors.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScrollBarColors.fields);
  }
}
registerMessage(ScrollBarColors);
export class ScrollBarConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScrollBarConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "show_h",
      jsonName: "showH",
      prop: "showH",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ScrollBarMode,
    },
    {
      no: 2,
      name: "show_v",
      jsonName: "showV",
      prop: "showV",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ScrollBarMode,
    },
    {
      no: 3,
      name: "appearance",
      jsonName: "appearance",
      prop: "appearance",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ScrollBarAppearance,
    },
    {
      no: 4,
      name: "size",
      jsonName: "size",
      prop: "size",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "min_thumb",
      jsonName: "minThumb",
      prop: "minThumb",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "corner_radius",
      jsonName: "cornerRadius",
      prop: "cornerRadius",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "colors",
      jsonName: "colors",
      prop: "colors",
      kind: "message" as ProtoKind,
      messageType: "ScrollBarColors",
    },
    {
      no: 8,
      name: "fade_delay_ms",
      jsonName: "fadeDelayMs",
      prop: "fadeDelayMs",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "fade_duration_ms",
      jsonName: "fadeDurationMs",
      prop: "fadeDurationMs",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "margin",
      jsonName: "margin",
      prop: "margin",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  showH: ScrollBarMode = 0;
  showV: ScrollBarMode = 0;
  appearance: ScrollBarAppearance = 0;
  size: number = 0;
  minThumb: number = 0;
  cornerRadius: number = 0;
  colors?: ScrollBarColors;
  fadeDelayMs: number = 0;
  fadeDurationMs: number = 0;
  margin: number = 0;

  constructor(init?: Partial<ScrollBarConfig>) {
    initMessage(this, ScrollBarConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScrollBarConfig {
    return decodeMessage(ScrollBarConfig, data);
  }

  static parseFrom(data: Uint8Array): ScrollBarConfig {
    return ScrollBarConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScrollBarConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScrollBarConfig.fields);
  }
}
registerMessage(ScrollBarConfig);
export class ScrollConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScrollConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "scroll_bar",
      jsonName: "scrollBar",
      prop: "scrollBar",
      kind: "message" as ProtoKind,
      messageType: "ScrollBarConfig",
    },
    {
      no: 2,
      name: "scroll_track",
      jsonName: "scrollTrack",
      prop: "scrollTrack",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "scroll_tips",
      jsonName: "scrollTips",
      prop: "scrollTips",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "fling_enabled",
      jsonName: "flingEnabled",
      prop: "flingEnabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "fling_impulse_gain",
      jsonName: "flingImpulseGain",
      prop: "flingImpulseGain",
      kind: "float" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "fling_friction",
      jsonName: "flingFriction",
      prop: "flingFriction",
      kind: "float" as ProtoKind,
      optional: true,
    },
    {
      no: 7,
      name: "pinch_zoom_enabled",
      jsonName: "pinchZoomEnabled",
      prop: "pinchZoomEnabled",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 8,
      name: "fast_scroll",
      jsonName: "fastScroll",
      prop: "fastScroll",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 9,
      name: "scrollbars",
      jsonName: "scrollbars",
      prop: "scrollbars",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ScrollBarsMode,
    },
    {
      no: 10,
      name: "pull_to_refresh",
      jsonName: "pullToRefresh",
      prop: "pullToRefresh",
      kind: "message" as ProtoKind,
      messageType: "PullToRefreshConfig",
    },
  ];
  scrollBar?: ScrollBarConfig;
  scrollTrack: boolean = false;
  scrollTips: boolean = false;
  flingEnabled: boolean = false;
  flingImpulseGain: number = 0;
  flingFriction: number = 0;
  pinchZoomEnabled: boolean = false;
  fastScroll: boolean = false;
  scrollbars: ScrollBarsMode = 0;
  pullToRefresh?: PullToRefreshConfig;

  constructor(init?: Partial<ScrollConfig>) {
    initMessage(this, ScrollConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScrollConfig {
    return decodeMessage(ScrollConfig, data);
  }

  static parseFrom(data: Uint8Array): ScrollConfig {
    return ScrollConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScrollConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScrollConfig.fields);
  }
}
registerMessage(ScrollConfig);
export class ScrollEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScrollEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "delta_x",
      jsonName: "deltaX",
      prop: "deltaX",
      kind: "float" as ProtoKind,
    },
    {
      no: 2,
      name: "delta_y",
      jsonName: "deltaY",
      prop: "deltaY",
      kind: "float" as ProtoKind,
    },
  ];
  deltaX: number = 0;
  deltaY: number = 0;

  constructor(init?: Partial<ScrollEvent>) {
    initMessage(this, ScrollEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScrollEvent {
    return decodeMessage(ScrollEvent, data);
  }

  static parseFrom(data: Uint8Array): ScrollEvent {
    return ScrollEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScrollEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScrollEvent.fields);
  }
}
registerMessage(ScrollEvent);
export class ScrollTooltipEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ScrollTooltipEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
  ];
  text: string = "";

  constructor(init?: Partial<ScrollTooltipEvent>) {
    initMessage(this, ScrollTooltipEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ScrollTooltipEvent {
    return decodeMessage(ScrollTooltipEvent, data);
  }

  static parseFrom(data: Uint8Array): ScrollTooltipEvent {
    return ScrollTooltipEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ScrollTooltipEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ScrollTooltipEvent.fields);
  }
}
registerMessage(ScrollTooltipEvent);
export class SelectRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "active_row",
      jsonName: "activeRow",
      prop: "activeRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "active_col",
      jsonName: "activeCol",
      prop: "activeCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "ranges",
      jsonName: "ranges",
      prop: "ranges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 5,
      name: "show",
      jsonName: "show",
      prop: "show",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  gridId: bigint = 0n;
  activeRow: number = 0;
  activeCol: number = 0;
  ranges: CellRange[] = [];
  show: boolean = false;

  constructor(init?: Partial<SelectRequest>) {
    initMessage(this, SelectRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectRequest {
    return decodeMessage(SelectRequest, data);
  }

  static parseFrom(data: Uint8Array): SelectRequest {
    return SelectRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectRequest.fields);
  }
}
registerMessage(SelectRequest);
export class SelectResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      messageType: "SelectionState",
    },
  ];
  selection?: SelectionState;

  constructor(init?: Partial<SelectResponse>) {
    initMessage(this, SelectResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectResponse {
    return decodeMessage(SelectResponse, data);
  }

  static parseFrom(data: Uint8Array): SelectResponse {
    return SelectResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectResponse.fields);
  }
}
registerMessage(SelectResponse);
export class SelectionChangedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectionChangedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_ranges",
      jsonName: "oldRanges",
      prop: "oldRanges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 2,
      name: "new_ranges",
      jsonName: "newRanges",
      prop: "newRanges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 3,
      name: "active_row",
      jsonName: "activeRow",
      prop: "activeRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "active_col",
      jsonName: "activeCol",
      prop: "activeCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldRanges: CellRange[] = [];
  newRanges: CellRange[] = [];
  activeRow: number = 0;
  activeCol: number = 0;

  constructor(init?: Partial<SelectionChangedEvent>) {
    initMessage(this, SelectionChangedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectionChangedEvent {
    return decodeMessage(SelectionChangedEvent, data);
  }

  static parseFrom(data: Uint8Array): SelectionChangedEvent {
    return SelectionChangedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectionChangedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectionChangedEvent.fields);
  }
}
registerMessage(SelectionChangedEvent);
export class SelectionChangingEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectionChangingEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "old_ranges",
      jsonName: "oldRanges",
      prop: "oldRanges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 2,
      name: "new_ranges",
      jsonName: "newRanges",
      prop: "newRanges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 3,
      name: "active_row",
      jsonName: "activeRow",
      prop: "activeRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "active_col",
      jsonName: "activeCol",
      prop: "activeCol",
      kind: "int32" as ProtoKind,
    },
  ];
  oldRanges: CellRange[] = [];
  newRanges: CellRange[] = [];
  activeRow: number = 0;
  activeCol: number = 0;

  constructor(init?: Partial<SelectionChangingEvent>) {
    initMessage(this, SelectionChangingEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectionChangingEvent {
    return decodeMessage(SelectionChangingEvent, data);
  }

  static parseFrom(data: Uint8Array): SelectionChangingEvent {
    return SelectionChangingEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectionChangingEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectionChangingEvent.fields);
  }
}
registerMessage(SelectionChangingEvent);
export class SelectionConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectionConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "mode",
      jsonName: "mode",
      prop: "mode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SelectionMode,
    },
    {
      no: 2,
      name: "focus_border",
      jsonName: "focusBorder",
      prop: "focusBorder",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: FocusBorderStyle,
    },
    {
      no: 3,
      name: "visibility",
      jsonName: "visibility",
      prop: "visibility",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SelectionVisibility,
    },
    {
      no: 4,
      name: "allow",
      jsonName: "allow",
      prop: "allow",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 5,
      name: "header_click_select",
      jsonName: "headerClickSelect",
      prop: "headerClickSelect",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 6,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 7,
      name: "hover",
      jsonName: "hover",
      prop: "hover",
      kind: "message" as ProtoKind,
      messageType: "HoverConfig",
    },
    {
      no: 8,
      name: "indicator_row_style",
      jsonName: "indicatorRowStyle",
      prop: "indicatorRowStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 9,
      name: "indicator_col_style",
      jsonName: "indicatorColStyle",
      prop: "indicatorColStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
    {
      no: 10,
      name: "active_cell_style",
      jsonName: "activeCellStyle",
      prop: "activeCellStyle",
      kind: "message" as ProtoKind,
      messageType: "HighlightStyle",
    },
  ];
  mode: SelectionMode = 0;
  focusBorder: FocusBorderStyle = 0;
  visibility: SelectionVisibility = 0;
  allow: boolean = false;
  headerClickSelect: boolean = false;
  style?: HighlightStyle;
  hover?: HoverConfig;
  indicatorRowStyle?: HighlightStyle;
  indicatorColStyle?: HighlightStyle;
  activeCellStyle?: HighlightStyle;

  constructor(init?: Partial<SelectionConfig>) {
    initMessage(this, SelectionConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectionConfig {
    return decodeMessage(SelectionConfig, data);
  }

  static parseFrom(data: Uint8Array): SelectionConfig {
    return SelectionConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectionConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectionConfig.fields);
  }
}
registerMessage(SelectionConfig);
export class SelectionState implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectionState" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "active_row",
      jsonName: "activeRow",
      prop: "activeRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "active_col",
      jsonName: "activeCol",
      prop: "activeCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "ranges",
      jsonName: "ranges",
      prop: "ranges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
    {
      no: 4,
      name: "top_row",
      jsonName: "topRow",
      prop: "topRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "left_col",
      jsonName: "leftCol",
      prop: "leftCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 6,
      name: "bottom_row",
      jsonName: "bottomRow",
      prop: "bottomRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 7,
      name: "right_col",
      jsonName: "rightCol",
      prop: "rightCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 8,
      name: "mouse_row",
      jsonName: "mouseRow",
      prop: "mouseRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 9,
      name: "mouse_col",
      jsonName: "mouseCol",
      prop: "mouseCol",
      kind: "int32" as ProtoKind,
    },
  ];
  activeRow: number = 0;
  activeCol: number = 0;
  ranges: CellRange[] = [];
  topRow: number = 0;
  leftCol: number = 0;
  bottomRow: number = 0;
  rightCol: number = 0;
  mouseRow: number = 0;
  mouseCol: number = 0;

  constructor(init?: Partial<SelectionState>) {
    initMessage(this, SelectionState.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectionState {
    return decodeMessage(SelectionState, data);
  }

  static parseFrom(data: Uint8Array): SelectionState {
    return SelectionState.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectionState.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectionState.fields);
  }
}
registerMessage(SelectionState);
export class SelectionUpdate implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SelectionUpdate" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "active_row",
      jsonName: "activeRow",
      prop: "activeRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "active_col",
      jsonName: "activeCol",
      prop: "activeCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "ranges",
      jsonName: "ranges",
      prop: "ranges",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellRange",
    },
  ];
  activeRow: number = 0;
  activeCol: number = 0;
  ranges: CellRange[] = [];

  constructor(init?: Partial<SelectionUpdate>) {
    initMessage(this, SelectionUpdate.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SelectionUpdate {
    return decodeMessage(SelectionUpdate, data);
  }

  static parseFrom(data: Uint8Array): SelectionUpdate {
    return SelectionUpdate.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SelectionUpdate.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SelectionUpdate.fields);
  }
}
registerMessage(SelectionUpdate);
export class Separator implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.Separator" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "visible",
      jsonName: "visible",
      prop: "visible",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "color",
      jsonName: "color",
      prop: "color",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
      optional: true,
    },
  ];
  visible: boolean = false;
  color: number = 0;
  width: number = 0;

  constructor(init?: Partial<Separator>) {
    initMessage(this, Separator.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): Separator {
    return decodeMessage(Separator, data);
  }

  static parseFrom(data: Uint8Array): Separator {
    return Separator.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, Separator.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, Separator.fields);
  }
}
registerMessage(Separator);
export class SetColRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetColRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  col: number = 0;

  constructor(init?: Partial<SetColRequest>) {
    initMessage(this, SetColRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetColRequest {
    return decodeMessage(SetColRequest, data);
  }

  static parseFrom(data: Uint8Array): SetColRequest {
    return SetColRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetColRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetColRequest.fields);
  }
}
registerMessage(SetColRequest);
export class SetLeftColResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetLeftColResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "left_col",
      jsonName: "leftCol",
      prop: "leftCol",
      kind: "int32" as ProtoKind,
    },
  ];
  leftCol: number = 0;

  constructor(init?: Partial<SetLeftColResponse>) {
    initMessage(this, SetLeftColResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetLeftColResponse {
    return decodeMessage(SetLeftColResponse, data);
  }

  static parseFrom(data: Uint8Array): SetLeftColResponse {
    return SetLeftColResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetLeftColResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetLeftColResponse.fields);
  }
}
registerMessage(SetLeftColResponse);
export class SetRedrawRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetRedrawRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "enabled",
      jsonName: "enabled",
      prop: "enabled",
      kind: "bool" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  enabled: boolean = false;

  constructor(init?: Partial<SetRedrawRequest>) {
    initMessage(this, SetRedrawRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetRedrawRequest {
    return decodeMessage(SetRedrawRequest, data);
  }

  static parseFrom(data: Uint8Array): SetRedrawRequest {
    return SetRedrawRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetRedrawRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetRedrawRequest.fields);
  }
}
registerMessage(SetRedrawRequest);
export class SetRedrawResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetRedrawResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<SetRedrawResponse>) {
    initMessage(this, SetRedrawResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetRedrawResponse {
    return decodeMessage(SetRedrawResponse, data);
  }

  static parseFrom(data: Uint8Array): SetRedrawResponse {
    return SetRedrawResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetRedrawResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetRedrawResponse.fields);
  }
}
registerMessage(SetRedrawResponse);
export class SetRowRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetRowRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  row: number = 0;

  constructor(init?: Partial<SetRowRequest>) {
    initMessage(this, SetRowRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetRowRequest {
    return decodeMessage(SetRowRequest, data);
  }

  static parseFrom(data: Uint8Array): SetRowRequest {
    return SetRowRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetRowRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetRowRequest.fields);
  }
}
registerMessage(SetRowRequest);
export class SetTopRowResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SetTopRowResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "top_row",
      jsonName: "topRow",
      prop: "topRow",
      kind: "int32" as ProtoKind,
    },
  ];
  topRow: number = 0;

  constructor(init?: Partial<SetTopRowResponse>) {
    initMessage(this, SetTopRowResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SetTopRowResponse {
    return decodeMessage(SetTopRowResponse, data);
  }

  static parseFrom(data: Uint8Array): SetTopRowResponse {
    return SetTopRowResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SetTopRowResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SetTopRowResponse.fields);
  }
}
registerMessage(SetTopRowResponse);
export class ShowCellRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ShowCellRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<ShowCellRequest>) {
    initMessage(this, ShowCellRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ShowCellRequest {
    return decodeMessage(ShowCellRequest, data);
  }

  static parseFrom(data: Uint8Array): ShowCellRequest {
    return ShowCellRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ShowCellRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ShowCellRequest.fields);
  }
}
registerMessage(ShowCellRequest);
export class ShowCellResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ShowCellResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "top_row",
      jsonName: "topRow",
      prop: "topRow",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "left_col",
      jsonName: "leftCol",
      prop: "leftCol",
      kind: "int32" as ProtoKind,
    },
  ];
  topRow: number = 0;
  leftCol: number = 0;

  constructor(init?: Partial<ShowCellResponse>) {
    initMessage(this, ShowCellResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ShowCellResponse {
    return decodeMessage(ShowCellResponse, data);
  }

  static parseFrom(data: Uint8Array): ShowCellResponse {
    return ShowCellResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ShowCellResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ShowCellResponse.fields);
  }
}
registerMessage(ShowCellResponse);
export class SortColumn implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SortColumn" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "order",
      jsonName: "order",
      prop: "order",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SortOrder,
    },
    {
      no: 3,
      name: "type",
      jsonName: "type",
      prop: "type",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SortType,
    },
  ];
  col: number = 0;
  order: SortOrder = 0;
  type: SortType = 0;

  constructor(init?: Partial<SortColumn>) {
    initMessage(this, SortColumn.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SortColumn {
    return decodeMessage(SortColumn, data);
  }

  static parseFrom(data: Uint8Array): SortColumn {
    return SortColumn.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SortColumn.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SortColumn.fields);
  }
}
registerMessage(SortColumn);
export class SortRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SortRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "sort_columns",
      jsonName: "sortColumns",
      prop: "sortColumns",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "SortColumn",
    },
  ];
  gridId: bigint = 0n;
  sortColumns: SortColumn[] = [];

  constructor(init?: Partial<SortRequest>) {
    initMessage(this, SortRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SortRequest {
    return decodeMessage(SortRequest, data);
  }

  static parseFrom(data: Uint8Array): SortRequest {
    return SortRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SortRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SortRequest.fields);
  }
}
registerMessage(SortRequest);
export class SortResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SortResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<SortResponse>) {
    initMessage(this, SortResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SortResponse {
    return decodeMessage(SortResponse, data);
  }

  static parseFrom(data: Uint8Array): SortResponse {
    return SortResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SortResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SortResponse.fields);
  }
}
registerMessage(SortResponse);
export class SpanConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SpanConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "cell_span",
      jsonName: "cellSpan",
      prop: "cellSpan",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CellSpanMode,
    },
    {
      no: 2,
      name: "cell_span_fixed",
      jsonName: "cellSpanFixed",
      prop: "cellSpanFixed",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CellSpanMode,
    },
    {
      no: 3,
      name: "cell_span_compare",
      jsonName: "cellSpanCompare",
      prop: "cellSpanCompare",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SpanCompareMode,
    },
    {
      no: 4,
      name: "group_span_compare",
      jsonName: "groupSpanCompare",
      prop: "groupSpanCompare",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: SpanCompareMode,
    },
  ];
  cellSpan: CellSpanMode = 0;
  cellSpanFixed: CellSpanMode = 0;
  cellSpanCompare: SpanCompareMode = 0;
  groupSpanCompare: SpanCompareMode = 0;

  constructor(init?: Partial<SpanConfig>) {
    initMessage(this, SpanConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SpanConfig {
    return decodeMessage(SpanConfig, data);
  }

  static parseFrom(data: Uint8Array): SpanConfig {
    return SpanConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SpanConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SpanConfig.fields);
  }
}
registerMessage(SpanConfig);
export class StartEditEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.StartEditEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;

  constructor(init?: Partial<StartEditEvent>) {
    initMessage(this, StartEditEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): StartEditEvent {
    return decodeMessage(StartEditEvent, data);
  }

  static parseFrom(data: Uint8Array): StartEditEvent {
    return StartEditEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, StartEditEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, StartEditEvent.fields);
  }
}
registerMessage(StartEditEvent);
export class StartPageEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.StartPageEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "page",
      jsonName: "page",
      prop: "page",
      kind: "int32" as ProtoKind,
    },
  ];
  page: number = 0;

  constructor(init?: Partial<StartPageEvent>) {
    initMessage(this, StartPageEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): StartPageEvent {
    return decodeMessage(StartPageEvent, data);
  }

  static parseFrom(data: Uint8Array): StartPageEvent {
    return StartPageEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, StartPageEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, StartPageEvent.fields);
  }
}
registerMessage(StartPageEvent);
export class StructField implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.StructField" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "key",
      jsonName: "key",
      prop: "key",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "value",
      jsonName: "value",
      prop: "value",
      kind: "message" as ProtoKind,
      messageType: "ScalarValue",
    },
  ];
  key: string = "";
  value?: ScalarValue;

  constructor(init?: Partial<StructField>) {
    initMessage(this, StructField.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): StructField {
    return decodeMessage(StructField, data);
  }

  static parseFrom(data: Uint8Array): StructField {
    return StructField.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, StructField.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, StructField.fields);
  }
}
registerMessage(StructField);
export class StructValue implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.StructValue" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "fields",
      jsonName: "fields",
      prop: "fields",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "StructField",
    },
  ];
  fields: StructField[] = [];

  constructor(init?: Partial<StructValue>) {
    initMessage(this, StructValue.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): StructValue {
    return decodeMessage(StructValue, data);
  }

  static parseFrom(data: Uint8Array): StructValue {
    return StructValue.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, StructValue.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, StructValue.fields);
  }
}
registerMessage(StructValue);
export class StyleConfig implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.StyleConfig" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 3,
      name: "alternate_background",
      jsonName: "alternateBackground",
      prop: "alternateBackground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 4,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
    {
      no: 5,
      name: "cell_padding",
      jsonName: "cellPadding",
      prop: "cellPadding",
      kind: "message" as ProtoKind,
      messageType: "Padding",
    },
    {
      no: 6,
      name: "text_effect",
      jsonName: "textEffect",
      prop: "textEffect",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextEffect,
    },
    {
      no: 7,
      name: "progress_color",
      jsonName: "progressColor",
      prop: "progressColor",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 10,
      name: "grid_lines",
      jsonName: "gridLines",
      prop: "gridLines",
      kind: "message" as ProtoKind,
      messageType: "GridLines",
    },
    {
      no: 11,
      name: "fixed",
      jsonName: "fixed",
      prop: "fixed",
      kind: "message" as ProtoKind,
      messageType: "RegionStyle",
    },
    {
      no: 12,
      name: "frozen",
      jsonName: "frozen",
      prop: "frozen",
      kind: "message" as ProtoKind,
      messageType: "RegionStyle",
    },
    {
      no: 13,
      name: "header",
      jsonName: "header",
      prop: "header",
      kind: "message" as ProtoKind,
      messageType: "HeaderStyle",
    },
    {
      no: 20,
      name: "sheet_background",
      jsonName: "sheetBackground",
      prop: "sheetBackground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 21,
      name: "sheet_border",
      jsonName: "sheetBorder",
      prop: "sheetBorder",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 22,
      name: "appearance",
      jsonName: "appearance",
      prop: "appearance",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: BorderAppearance,
    },
    {
      no: 23,
      name: "background_image",
      jsonName: "backgroundImage",
      prop: "backgroundImage",
      kind: "bytes" as ProtoKind,
      optional: true,
    },
    {
      no: 24,
      name: "background_image_align",
      jsonName: "backgroundImageAlign",
      prop: "backgroundImageAlign",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ImageAlignment,
    },
    {
      no: 25,
      name: "text_rendering",
      jsonName: "textRendering",
      prop: "textRendering",
      kind: "message" as ProtoKind,
      messageType: "TextRendering",
    },
    {
      no: 30,
      name: "icons",
      jsonName: "icons",
      prop: "icons",
      kind: "message" as ProtoKind,
      messageType: "IconTheme",
    },
    {
      no: 31,
      name: "image_over_text",
      jsonName: "imageOverText",
      prop: "imageOverText",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 32,
      name: "show_sort_numbers",
      jsonName: "showSortNumbers",
      prop: "showSortNumbers",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 33,
      name: "apply_scope",
      jsonName: "applyScope",
      prop: "applyScope",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: ApplyScope,
    },
    {
      no: 34,
      name: "custom_render",
      jsonName: "customRender",
      prop: "customRender",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: CustomRenderMode,
    },
    {
      no: 40,
      name: "format",
      jsonName: "format",
      prop: "format",
      kind: "string" as ProtoKind,
      optional: true,
    },
    {
      no: 41,
      name: "word_wrap",
      jsonName: "wordWrap",
      prop: "wordWrap",
      kind: "bool" as ProtoKind,
      optional: true,
    },
    {
      no: 42,
      name: "ellipsis",
      jsonName: "ellipsis",
      prop: "ellipsis",
      kind: "int32" as ProtoKind,
      optional: true,
    },
    {
      no: 43,
      name: "text_overflow",
      jsonName: "textOverflow",
      prop: "textOverflow",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  background: number = 0;
  foreground: number = 0;
  alternateBackground: number = 0;
  font?: Font;
  cellPadding?: Padding;
  textEffect: TextEffect = 0;
  progressColor: number = 0;
  gridLines?: GridLines;
  fixed?: RegionStyle;
  frozen?: RegionStyle;
  header?: HeaderStyle;
  sheetBackground: number = 0;
  sheetBorder: number = 0;
  appearance: BorderAppearance = 0;
  backgroundImage?: Uint8Array;
  backgroundImageAlign: ImageAlignment = 0;
  textRendering?: TextRendering;
  icons?: IconTheme;
  imageOverText: boolean = false;
  showSortNumbers: boolean = false;
  applyScope: ApplyScope = 0;
  customRender: CustomRenderMode = 0;
  format: string = "";
  wordWrap: boolean = false;
  ellipsis: number = 0;
  textOverflow: boolean = false;

  constructor(init?: Partial<StyleConfig>) {
    initMessage(this, StyleConfig.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): StyleConfig {
    return decodeMessage(StyleConfig, data);
  }

  static parseFrom(data: Uint8Array): StyleConfig {
    return StyleConfig.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, StyleConfig.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, StyleConfig.fields);
  }
}
registerMessage(StyleConfig);
export class SubtotalRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SubtotalRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "aggregate",
      jsonName: "aggregate",
      prop: "aggregate",
      kind: "enum" as ProtoKind,
      enumType: AggregateType,
    },
    {
      no: 3,
      name: "group_on_col",
      jsonName: "groupOnCol",
      prop: "groupOnCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "aggregate_col",
      jsonName: "aggregateCol",
      prop: "aggregateCol",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "caption",
      jsonName: "caption",
      prop: "caption",
      kind: "string" as ProtoKind,
    },
    {
      no: 6,
      name: "background",
      jsonName: "background",
      prop: "background",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 7,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 8,
      name: "add_outline",
      jsonName: "addOutline",
      prop: "addOutline",
      kind: "bool" as ProtoKind,
    },
    {
      no: 9,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
  ];
  gridId: bigint = 0n;
  aggregate: AggregateType = 0;
  groupOnCol: number = 0;
  aggregateCol: number = 0;
  caption: string = "";
  background: number = 0;
  foreground: number = 0;
  addOutline: boolean = false;
  font?: Font;

  constructor(init?: Partial<SubtotalRequest>) {
    initMessage(this, SubtotalRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SubtotalRequest {
    return decodeMessage(SubtotalRequest, data);
  }

  static parseFrom(data: Uint8Array): SubtotalRequest {
    return SubtotalRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SubtotalRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SubtotalRequest.fields);
  }
}
registerMessage(SubtotalRequest);
export class SubtotalResult implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.SubtotalResult" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "rows",
      jsonName: "rows",
      prop: "rows",
      kind: "int32" as ProtoKind,
      repeated: true,
    },
  ];
  rows: number[] = [];

  constructor(init?: Partial<SubtotalResult>) {
    initMessage(this, SubtotalResult.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): SubtotalResult {
    return decodeMessage(SubtotalResult, data);
  }

  static parseFrom(data: Uint8Array): SubtotalResult {
    return SubtotalResult.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, SubtotalResult.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, SubtotalResult.fields);
  }
}
registerMessage(SubtotalResult);
export class TerminalCapabilities implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TerminalCapabilities" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "color_level",
      jsonName: "colorLevel",
      prop: "colorLevel",
      kind: "enum" as ProtoKind,
      enumType: TerminalColorLevel,
    },
    {
      no: 2,
      name: "sgr_mouse",
      jsonName: "sgrMouse",
      prop: "sgrMouse",
      kind: "bool" as ProtoKind,
    },
    {
      no: 3,
      name: "focus_events",
      jsonName: "focusEvents",
      prop: "focusEvents",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "bracketed_paste",
      jsonName: "bracketedPaste",
      prop: "bracketedPaste",
      kind: "bool" as ProtoKind,
    },
  ];
  colorLevel: TerminalColorLevel = 0;
  sgrMouse: boolean = false;
  focusEvents: boolean = false;
  bracketedPaste: boolean = false;

  constructor(init?: Partial<TerminalCapabilities>) {
    initMessage(this, TerminalCapabilities.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TerminalCapabilities {
    return decodeMessage(TerminalCapabilities, data);
  }

  static parseFrom(data: Uint8Array): TerminalCapabilities {
    return TerminalCapabilities.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TerminalCapabilities.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TerminalCapabilities.fields);
  }
}
registerMessage(TerminalCapabilities);
export class TerminalCommand implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TerminalCommand" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "kind",
      jsonName: "kind",
      prop: "kind",
      kind: "enum" as ProtoKind,
      enumType: TerminalCommand_Kind,
    },
  ];
  kind: TerminalCommand_Kind = 0;

  constructor(init?: Partial<TerminalCommand>) {
    initMessage(this, TerminalCommand.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TerminalCommand {
    return decodeMessage(TerminalCommand, data);
  }

  static parseFrom(data: Uint8Array): TerminalCommand {
    return TerminalCommand.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TerminalCommand.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TerminalCommand.fields);
  }
}
registerMessage(TerminalCommand);
export class TerminalInputBytes implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TerminalInputBytes" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "data",
      jsonName: "data",
      prop: "data",
      kind: "bytes" as ProtoKind,
    },
  ];
  data?: Uint8Array;

  constructor(init?: Partial<TerminalInputBytes>) {
    initMessage(this, TerminalInputBytes.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TerminalInputBytes {
    return decodeMessage(TerminalInputBytes, data);
  }

  static parseFrom(data: Uint8Array): TerminalInputBytes {
    return TerminalInputBytes.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TerminalInputBytes.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TerminalInputBytes.fields);
  }
}
registerMessage(TerminalInputBytes);
export class TerminalViewport implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TerminalViewport" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "origin_x",
      jsonName: "originX",
      prop: "originX",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "origin_y",
      jsonName: "originY",
      prop: "originY",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
    {
      no: 5,
      name: "fullscreen",
      jsonName: "fullscreen",
      prop: "fullscreen",
      kind: "bool" as ProtoKind,
    },
  ];
  originX: number = 0;
  originY: number = 0;
  width: number = 0;
  height: number = 0;
  fullscreen: boolean = false;

  constructor(init?: Partial<TerminalViewport>) {
    initMessage(this, TerminalViewport.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TerminalViewport {
    return decodeMessage(TerminalViewport, data);
  }

  static parseFrom(data: Uint8Array): TerminalViewport {
    return TerminalViewport.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TerminalViewport.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TerminalViewport.fields);
  }
}
registerMessage(TerminalViewport);
export class TextEditorParams implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextEditorParams" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "max_length",
      jsonName: "maxLength",
      prop: "maxLength",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "mask",
      jsonName: "mask",
      prop: "mask",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "allow_newlines",
      jsonName: "allowNewlines",
      prop: "allowNewlines",
      kind: "bool" as ProtoKind,
    },
    {
      no: 4,
      name: "input_type",
      jsonName: "inputType",
      prop: "inputType",
      kind: "enum" as ProtoKind,
      enumType: InputType,
    },
  ];
  maxLength: number = 0;
  mask: string = "";
  allowNewlines: boolean = false;
  inputType: InputType = 0;

  constructor(init?: Partial<TextEditorParams>) {
    initMessage(this, TextEditorParams.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextEditorParams {
    return decodeMessage(TextEditorParams, data);
  }

  static parseFrom(data: Uint8Array): TextEditorParams {
    return TextEditorParams.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextEditorParams.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextEditorParams.fields);
  }
}
registerMessage(TextEditorParams);
export class TextFormatRun implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextFormatRun" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "start_index",
      jsonName: "startIndex",
      prop: "startIndex",
      kind: "uint32" as ProtoKind,
    },
    {
      no: 2,
      name: "style",
      jsonName: "style",
      prop: "style",
      kind: "message" as ProtoKind,
      messageType: "TextRunStyle",
    },
  ];
  startIndex: number = 0;
  style?: TextRunStyle;

  constructor(init?: Partial<TextFormatRun>) {
    initMessage(this, TextFormatRun.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextFormatRun {
    return decodeMessage(TextFormatRun, data);
  }

  static parseFrom(data: Uint8Array): TextFormatRun {
    return TextFormatRun.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextFormatRun.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextFormatRun.fields);
  }
}
registerMessage(TextFormatRun);
export class TextQuery implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextQuery" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "case_sensitive",
      jsonName: "caseSensitive",
      prop: "caseSensitive",
      kind: "bool" as ProtoKind,
    },
    {
      no: 3,
      name: "full_match",
      jsonName: "fullMatch",
      prop: "fullMatch",
      kind: "bool" as ProtoKind,
    },
  ];
  text: string = "";
  caseSensitive: boolean = false;
  fullMatch: boolean = false;

  constructor(init?: Partial<TextQuery>) {
    initMessage(this, TextQuery.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextQuery {
    return decodeMessage(TextQuery, data);
  }

  static parseFrom(data: Uint8Array): TextQuery {
    return TextQuery.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextQuery.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextQuery.fields);
  }
}
registerMessage(TextQuery);
export class TextRendering implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextRendering" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "mode",
      jsonName: "mode",
      prop: "mode",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextRenderMode,
    },
    {
      no: 2,
      name: "hinting",
      jsonName: "hinting",
      prop: "hinting",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextHintingMode,
    },
    {
      no: 3,
      name: "pixel_snap",
      jsonName: "pixelSnap",
      prop: "pixelSnap",
      kind: "bool" as ProtoKind,
      optional: true,
    },
  ];
  mode: TextRenderMode = 0;
  hinting: TextHintingMode = 0;
  pixelSnap: boolean = false;

  constructor(init?: Partial<TextRendering>) {
    initMessage(this, TextRendering.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextRendering {
    return decodeMessage(TextRendering, data);
  }

  static parseFrom(data: Uint8Array): TextRendering {
    return TextRendering.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextRendering.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextRendering.fields);
  }
}
registerMessage(TextRendering);
export class TextRunStyle implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextRunStyle" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "foreground",
      jsonName: "foreground",
      prop: "foreground",
      kind: "uint32" as ProtoKind,
      optional: true,
    },
    {
      no: 2,
      name: "font",
      jsonName: "font",
      prop: "font",
      kind: "message" as ProtoKind,
      messageType: "Font",
    },
    {
      no: 3,
      name: "baseline",
      jsonName: "baseline",
      prop: "baseline",
      kind: "enum" as ProtoKind,
      optional: true,
      enumType: TextBaseline,
    },
    {
      no: 4,
      name: "link_url",
      jsonName: "linkUrl",
      prop: "linkUrl",
      kind: "string" as ProtoKind,
      optional: true,
    },
  ];
  foreground: number = 0;
  font?: Font;
  baseline: TextBaseline = 0;
  linkUrl: string = "";

  constructor(init?: Partial<TextRunStyle>) {
    initMessage(this, TextRunStyle.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextRunStyle {
    return decodeMessage(TextRunStyle, data);
  }

  static parseFrom(data: Uint8Array): TextRunStyle {
    return TextRunStyle.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextRunStyle.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextRunStyle.fields);
  }
}
registerMessage(TextRunStyle);
export class TextSelection implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextSelection" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "start",
      jsonName: "start",
      prop: "start",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "length",
      jsonName: "length",
      prop: "length",
      kind: "int32" as ProtoKind,
    },
  ];
  start: number = 0;
  length: number = 0;

  constructor(init?: Partial<TextSelection>) {
    initMessage(this, TextSelection.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextSelection {
    return decodeMessage(TextSelection, data);
  }

  static parseFrom(data: Uint8Array): TextSelection {
    return TextSelection.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextSelection.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextSelection.fields);
  }
}
registerMessage(TextSelection);
export class TextSelectionChanged implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TextSelectionChanged" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "selection",
      jsonName: "selection",
      prop: "selection",
      kind: "message" as ProtoKind,
      messageType: "TextSelection",
    },
  ];
  selection?: TextSelection;

  constructor(init?: Partial<TextSelectionChanged>) {
    initMessage(this, TextSelectionChanged.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TextSelectionChanged {
    return decodeMessage(TextSelectionChanged, data);
  }

  static parseFrom(data: Uint8Array): TextSelectionChanged {
    return TextSelectionChanged.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TextSelectionChanged.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TextSelectionChanged.fields);
  }
}
registerMessage(TextSelectionChanged);
export class TooltipRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TooltipRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "float" as ProtoKind,
    },
    {
      no: 2,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
  ];
  x: number = 0;
  y: number = 0;
  text: string = "";

  constructor(init?: Partial<TooltipRequest>) {
    initMessage(this, TooltipRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TooltipRequest {
    return decodeMessage(TooltipRequest, data);
  }

  static parseFrom(data: Uint8Array): TooltipRequest {
    return TooltipRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TooltipRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TooltipRequest.fields);
  }
}
registerMessage(TooltipRequest);
export class TreeChildrenRequestedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TreeChildrenRequestedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "node_id",
      jsonName: "nodeId",
      prop: "nodeId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "request_id",
      jsonName: "requestId",
      prop: "requestId",
      kind: "int64" as ProtoKind,
    },
  ];
  nodeId: string = "";
  row: number = 0;
  requestId: bigint = 0n;

  constructor(init?: Partial<TreeChildrenRequestedEvent>) {
    initMessage(this, TreeChildrenRequestedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TreeChildrenRequestedEvent {
    return decodeMessage(TreeChildrenRequestedEvent, data);
  }

  static parseFrom(data: Uint8Array): TreeChildrenRequestedEvent {
    return TreeChildrenRequestedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TreeChildrenRequestedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TreeChildrenRequestedEvent.fields);
  }
}
registerMessage(TreeChildrenRequestedEvent);
export class TreeNodeActivateEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TreeNodeActivateEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "node_id",
      jsonName: "nodeId",
      prop: "nodeId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
  ];
  nodeId: string = "";
  row: number = 0;

  constructor(init?: Partial<TreeNodeActivateEvent>) {
    initMessage(this, TreeNodeActivateEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TreeNodeActivateEvent {
    return decodeMessage(TreeNodeActivateEvent, data);
  }

  static parseFrom(data: Uint8Array): TreeNodeActivateEvent {
    return TreeNodeActivateEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TreeNodeActivateEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TreeNodeActivateEvent.fields);
  }
}
registerMessage(TreeNodeActivateEvent);
export class TreeNodeContextMenuEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TreeNodeContextMenuEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "node_id",
      jsonName: "nodeId",
      prop: "nodeId",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "x",
      jsonName: "x",
      prop: "x",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "y",
      jsonName: "y",
      prop: "y",
      kind: "int32" as ProtoKind,
    },
  ];
  nodeId: string = "";
  row: number = 0;
  x: number = 0;
  y: number = 0;

  constructor(init?: Partial<TreeNodeContextMenuEvent>) {
    initMessage(this, TreeNodeContextMenuEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TreeNodeContextMenuEvent {
    return decodeMessage(TreeNodeContextMenuEvent, data);
  }

  static parseFrom(data: Uint8Array): TreeNodeContextMenuEvent {
    return TreeNodeContextMenuEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TreeNodeContextMenuEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TreeNodeContextMenuEvent.fields);
  }
}
registerMessage(TreeNodeContextMenuEvent);
export class TypeAheadEndedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TypeAheadEndedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
  ];

  constructor(init?: Partial<TypeAheadEndedEvent>) {
    initMessage(this, TypeAheadEndedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TypeAheadEndedEvent {
    return decodeMessage(TypeAheadEndedEvent, data);
  }

  static parseFrom(data: Uint8Array): TypeAheadEndedEvent {
    return TypeAheadEndedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TypeAheadEndedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TypeAheadEndedEvent.fields);
  }
}
registerMessage(TypeAheadEndedEvent);
export class TypeAheadStartedEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TypeAheadStartedEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "text",
      jsonName: "text",
      prop: "text",
      kind: "string" as ProtoKind,
    },
  ];
  col: number = 0;
  text: string = "";

  constructor(init?: Partial<TypeAheadStartedEvent>) {
    initMessage(this, TypeAheadStartedEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TypeAheadStartedEvent {
    return decodeMessage(TypeAheadStartedEvent, data);
  }

  static parseFrom(data: Uint8Array): TypeAheadStartedEvent {
    return TypeAheadStartedEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TypeAheadStartedEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TypeAheadStartedEvent.fields);
  }
}
registerMessage(TypeAheadStartedEvent);
export class TypeViolation implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.TypeViolation" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "row",
      jsonName: "row",
      prop: "row",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "col",
      jsonName: "col",
      prop: "col",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "expected",
      jsonName: "expected",
      prop: "expected",
      kind: "enum" as ProtoKind,
      enumType: ColumnDataType,
    },
    {
      no: 4,
      name: "actual",
      jsonName: "actual",
      prop: "actual",
      kind: "message" as ProtoKind,
      messageType: "CellValue",
    },
    {
      no: 5,
      name: "reason",
      jsonName: "reason",
      prop: "reason",
      kind: "string" as ProtoKind,
    },
  ];
  row: number = 0;
  col: number = 0;
  expected: ColumnDataType = 0;
  actual?: CellValue;
  reason: string = "";

  constructor(init?: Partial<TypeViolation>) {
    initMessage(this, TypeViolation.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): TypeViolation {
    return decodeMessage(TypeViolation, data);
  }

  static parseFrom(data: Uint8Array): TypeViolation {
    return TypeViolation.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, TypeViolation.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, TypeViolation.fields);
  }
}
registerMessage(TypeViolation);
export class UnmergeCellsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.UnmergeCellsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "range",
      jsonName: "range",
      prop: "range",
      kind: "message" as ProtoKind,
      messageType: "CellRange",
    },
  ];
  gridId: bigint = 0n;
  range?: CellRange;

  constructor(init?: Partial<UnmergeCellsRequest>) {
    initMessage(this, UnmergeCellsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): UnmergeCellsRequest {
    return decodeMessage(UnmergeCellsRequest, data);
  }

  static parseFrom(data: Uint8Array): UnmergeCellsRequest {
    return UnmergeCellsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, UnmergeCellsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, UnmergeCellsRequest.fields);
  }
}
registerMessage(UnmergeCellsRequest);
export class UnmergeCellsResponse implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.UnmergeCellsResponse" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "unmerged_count",
      jsonName: "unmergedCount",
      prop: "unmergedCount",
      kind: "int32" as ProtoKind,
    },
  ];
  unmergedCount: number = 0;

  constructor(init?: Partial<UnmergeCellsResponse>) {
    initMessage(this, UnmergeCellsResponse.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): UnmergeCellsResponse {
    return decodeMessage(UnmergeCellsResponse, data);
  }

  static parseFrom(data: Uint8Array): UnmergeCellsResponse {
    return UnmergeCellsResponse.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, UnmergeCellsResponse.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, UnmergeCellsResponse.fields);
  }
}
registerMessage(UnmergeCellsResponse);
export class UpdateCellsRequest implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.UpdateCellsRequest" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "grid_id",
      jsonName: "gridId",
      prop: "gridId",
      kind: "int64" as ProtoKind,
    },
    {
      no: 2,
      name: "cells",
      jsonName: "cells",
      prop: "cells",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "CellUpdate",
    },
    {
      no: 3,
      name: "atomic",
      jsonName: "atomic",
      prop: "atomic",
      kind: "bool" as ProtoKind,
    },
  ];
  gridId: bigint = 0n;
  cells: CellUpdate[] = [];
  atomic: boolean = false;

  constructor(init?: Partial<UpdateCellsRequest>) {
    initMessage(this, UpdateCellsRequest.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): UpdateCellsRequest {
    return decodeMessage(UpdateCellsRequest, data);
  }

  static parseFrom(data: Uint8Array): UpdateCellsRequest {
    return UpdateCellsRequest.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, UpdateCellsRequest.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, UpdateCellsRequest.fields);
  }
}
registerMessage(UpdateCellsRequest);
export class ValidationError implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ValidationError" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "code",
      jsonName: "code",
      prop: "code",
      kind: "string" as ProtoKind,
    },
    {
      no: 2,
      name: "message",
      jsonName: "message",
      prop: "message",
      kind: "string" as ProtoKind,
    },
    {
      no: 3,
      name: "blocking",
      jsonName: "blocking",
      prop: "blocking",
      kind: "bool" as ProtoKind,
    },
  ];
  code: string = "";
  message: string = "";
  blocking: boolean = false;

  constructor(init?: Partial<ValidationError>) {
    initMessage(this, ValidationError.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ValidationError {
    return decodeMessage(ValidationError, data);
  }

  static parseFrom(data: Uint8Array): ValidationError {
    return ValidationError.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ValidationError.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ValidationError.fields);
  }
}
registerMessage(ValidationError);
export class ViewportState implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ViewportState" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "scroll_x",
      jsonName: "scrollX",
      prop: "scrollX",
      kind: "float" as ProtoKind,
    },
    {
      no: 2,
      name: "scroll_y",
      jsonName: "scrollY",
      prop: "scrollY",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "width",
      jsonName: "width",
      prop: "width",
      kind: "int32" as ProtoKind,
    },
    {
      no: 4,
      name: "height",
      jsonName: "height",
      prop: "height",
      kind: "int32" as ProtoKind,
    },
  ];
  scrollX: number = 0;
  scrollY: number = 0;
  width: number = 0;
  height: number = 0;

  constructor(init?: Partial<ViewportState>) {
    initMessage(this, ViewportState.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ViewportState {
    return decodeMessage(ViewportState, data);
  }

  static parseFrom(data: Uint8Array): ViewportState {
    return ViewportState.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ViewportState.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ViewportState.fields);
  }
}
registerMessage(ViewportState);
export class WriteResult implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.WriteResult" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "written_count",
      jsonName: "writtenCount",
      prop: "writtenCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 2,
      name: "rejected_count",
      jsonName: "rejectedCount",
      prop: "rejectedCount",
      kind: "int32" as ProtoKind,
    },
    {
      no: 3,
      name: "violations",
      jsonName: "violations",
      prop: "violations",
      kind: "message" as ProtoKind,
      repeated: true,
      messageType: "TypeViolation",
    },
  ];
  writtenCount: number = 0;
  rejectedCount: number = 0;
  violations: TypeViolation[] = [];

  constructor(init?: Partial<WriteResult>) {
    initMessage(this, WriteResult.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): WriteResult {
    return decodeMessage(WriteResult, data);
  }

  static parseFrom(data: Uint8Array): WriteResult {
    return WriteResult.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, WriteResult.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, WriteResult.fields);
  }
}
registerMessage(WriteResult);
export class ZoomEvent implements LiteMessage {
  static readonly typeName = "volvoxgrid.v1.ZoomEvent" as const;
  static readonly fields: readonly ProtoFieldInfo[] = [
    {
      no: 1,
      name: "phase",
      jsonName: "phase",
      prop: "phase",
      kind: "enum" as ProtoKind,
      enumType: ZoomEvent_Phase,
    },
    {
      no: 2,
      name: "scale",
      jsonName: "scale",
      prop: "scale",
      kind: "float" as ProtoKind,
    },
    {
      no: 3,
      name: "focal_x_px",
      jsonName: "focalXPx",
      prop: "focalXPx",
      kind: "float" as ProtoKind,
    },
    {
      no: 4,
      name: "focal_y_px",
      jsonName: "focalYPx",
      prop: "focalYPx",
      kind: "float" as ProtoKind,
    },
  ];
  phase: ZoomEvent_Phase = 0;
  scale: number = 0;
  focalXPx: number = 0;
  focalYPx: number = 0;

  constructor(init?: Partial<ZoomEvent>) {
    initMessage(this, ZoomEvent.fields, init as Record<string, unknown> | undefined);
  }

  static fromBinary(data: Uint8Array): ZoomEvent {
    return decodeMessage(ZoomEvent, data);
  }

  static parseFrom(data: Uint8Array): ZoomEvent {
    return ZoomEvent.fromBinary(data);
  }

  toBinary(): Uint8Array {
    return encodeMessage(this, ZoomEvent.fields);
  }

  toByteArray(): Uint8Array {
    return this.toBinary();
  }

  toJson(): ProtoJsonObject {
    return messageToJson(this, ZoomEvent.fields);
  }
}
registerMessage(ZoomEvent);
export const VolvoxGridServiceMethods = {
  Create: "/volvoxgrid.v1.VolvoxGridService/Create",
  Destroy: "/volvoxgrid.v1.VolvoxGridService/Destroy",
  Configure: "/volvoxgrid.v1.VolvoxGridService/Configure",
  GetConfig: "/volvoxgrid.v1.VolvoxGridService/GetConfig",
  LoadFontData: "/volvoxgrid.v1.VolvoxGridService/LoadFontData",
  DefineColumns: "/volvoxgrid.v1.VolvoxGridService/DefineColumns",
  GetSchema: "/volvoxgrid.v1.VolvoxGridService/GetSchema",
  DefineRows: "/volvoxgrid.v1.VolvoxGridService/DefineRows",
  InsertRows: "/volvoxgrid.v1.VolvoxGridService/InsertRows",
  RemoveRows: "/volvoxgrid.v1.VolvoxGridService/RemoveRows",
  MoveColumn: "/volvoxgrid.v1.VolvoxGridService/MoveColumn",
  MoveRow: "/volvoxgrid.v1.VolvoxGridService/MoveRow",
  UpdateCells: "/volvoxgrid.v1.VolvoxGridService/UpdateCells",
  GetCells: "/volvoxgrid.v1.VolvoxGridService/GetCells",
  LoadTable: "/volvoxgrid.v1.VolvoxGridService/LoadTable",
  LoadData: "/volvoxgrid.v1.VolvoxGridService/LoadData",
  AppendData: "/volvoxgrid.v1.VolvoxGridService/AppendData",
  Clear: "/volvoxgrid.v1.VolvoxGridService/Clear",
  Select: "/volvoxgrid.v1.VolvoxGridService/Select",
  GetSelection: "/volvoxgrid.v1.VolvoxGridService/GetSelection",
  ShowCell: "/volvoxgrid.v1.VolvoxGridService/ShowCell",
  SetTopRow: "/volvoxgrid.v1.VolvoxGridService/SetTopRow",
  SetLeftCol: "/volvoxgrid.v1.VolvoxGridService/SetLeftCol",
  Edit: "/volvoxgrid.v1.VolvoxGridService/Edit",
  Sort: "/volvoxgrid.v1.VolvoxGridService/Sort",
  Subtotal: "/volvoxgrid.v1.VolvoxGridService/Subtotal",
  AutoSize: "/volvoxgrid.v1.VolvoxGridService/AutoSize",
  Outline: "/volvoxgrid.v1.VolvoxGridService/Outline",
  GetNode: "/volvoxgrid.v1.VolvoxGridService/GetNode",
  Find: "/volvoxgrid.v1.VolvoxGridService/Find",
  Aggregate: "/volvoxgrid.v1.VolvoxGridService/Aggregate",
  GetMergedRange: "/volvoxgrid.v1.VolvoxGridService/GetMergedRange",
  MergeCells: "/volvoxgrid.v1.VolvoxGridService/MergeCells",
  UnmergeCells: "/volvoxgrid.v1.VolvoxGridService/UnmergeCells",
  GetMergedRegions: "/volvoxgrid.v1.VolvoxGridService/GetMergedRegions",
  GetMemoryUsage: "/volvoxgrid.v1.VolvoxGridService/GetMemoryUsage",
  Clipboard: "/volvoxgrid.v1.VolvoxGridService/Clipboard",
  Export: "/volvoxgrid.v1.VolvoxGridService/Export",
  Print: "/volvoxgrid.v1.VolvoxGridService/Print",
  Archive: "/volvoxgrid.v1.VolvoxGridService/Archive",
  ResizeViewport: "/volvoxgrid.v1.VolvoxGridService/ResizeViewport",
  SetRedraw: "/volvoxgrid.v1.VolvoxGridService/SetRedraw",
  Refresh: "/volvoxgrid.v1.VolvoxGridService/Refresh",
  LoadDemo: "/volvoxgrid.v1.VolvoxGridService/LoadDemo",
  GetDemoData: "/volvoxgrid.v1.VolvoxGridService/GetDemoData",
  RenderSession: "/volvoxgrid.v1.VolvoxGridService/RenderSession",
  EventStream: "/volvoxgrid.v1.VolvoxGridService/EventStream",
} as const;

